webpackJsonp([7],{

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultErrorHandler */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withClientToken; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sagAuth__ = __webpack_require__(58);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }


var defaultErrorHandler = function defaultErrorHandler(error, errorCode) {
  console.error("API returned ".concat(errorCode, " status code:"), error);
  var errorMessage = 'Some error occured';

  if (error.detail) {
    errorMessage = error.detail;
  }

  if (error.email) {
    errorMessage = error.email[0];
  }

  if (typeof error === 'string') {
    errorMessage = error;
  }

  return {
    errorMessage: errorMessage,
    errorCode: errorCode
  };
};
var withClientToken =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(_ref) {
    var _ref$action, action, _ref$args, args, _ref3, clientToken, error, errorCode;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$action = _ref.action, action = _ref$action === void 0 ? function (f) {
              return f;
            } : _ref$action, _ref$args = _ref.args, args = _ref$args === void 0 ? [] : _ref$args;
            _context.next = 3;
            return Object(__WEBPACK_IMPORTED_MODULE_0__sagAuth__["b" /* getClientToken */])();

          case 3:
            _ref3 = _context.sent;
            clientToken = _ref3.token;
            error = _ref3.error;
            errorCode = _ref3.errorCode;

            if (!error) {
              _context.next = 10;
              break;
            }

            _context.next = 10;
            return Promise.reject(defaultErrorHandler(error, errorCode));

          case 10:
            return _context.abrupt("return", action.apply(void 0, [clientToken].concat(_toConsumableArray(args))));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function withClientToken(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable global-require */
if (true) {
  module.exports = __webpack_require__(584);
} else {
  module.exports = require('./fetch.server.js');
}

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REFRESH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REFRESH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REFRESH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGOUT_USER; });
/* unused harmony export defaultState */
/* unused harmony export getLoggedInAuthState */
/* unused harmony export ACTIONS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);

var INIT = 'auth/INIT';
var REFRESH_REQUEST = 'auth/REFRESH_REQUEST';
var REFRESH_SUCCESS = 'auth/REFRESH_SUCCESS';
var REFRESH_FAILURE = 'auth/REFRESH_FAILURE';
var LOGOUT_USER = 'auth/LOGOUT_USER';
var defaultState = {
  isFetching: false,
  errorMessage: '',
  token: '',
  user: {}
};
function getLoggedInAuthState(user, token) {
  return {
    isFetching: false,
    errorMessage: '',
    token: token,
    user: user
  };
}
var ACTIONS = {
  init: function init() {
    return {
      type: INIT
    };
  }
};

function auth() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case INIT:
      return Object.assign({}, state);

    case REFRESH_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        errorMessage: ''
      });

    case REFRESH_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        errorMessage: '',
        token: action.token,
        refreshToken: action.refToken,
        user: Object.assign({}, state.user, action.user)
      });

    case LOGOUT_USER:
      return Object.assign({}, state, {
        token: null,
        refreshToken: null,
        user: Object.assign({}, state.user, {})
      });

    case REFRESH_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        errorMessage: action.message,
        clientToken: ''
      });

    default:
      return Object.assign({}, state);
  }
}

/* harmony default export */ __webpack_exports__["e"] = (auth);

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(63);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/actions/helpers/tokenHelpers.js
var tokenHelpers = __webpack_require__(107);

// EXTERNAL MODULE: ./src/actions/sagAuth.js
var sagAuth = __webpack_require__(58);

// EXTERNAL MODULE: ./src/actions/registration.js
var registration = __webpack_require__(252);

// EXTERNAL MODULE: ./src/history.js
var src_history = __webpack_require__(40);

// EXTERNAL MODULE: ./src/reducers/layout.js + 1 modules
var layout = __webpack_require__(69);

// EXTERNAL MODULE: ./src/utils/cookie.js
var cookie = __webpack_require__(32);

// EXTERNAL MODULE: ./src/utils/login.js
var login = __webpack_require__(81);

// EXTERNAL MODULE: ./src/reducers/polling.js
var reducers_polling = __webpack_require__(237);

// CONCATENATED MODULE: ./src/actions/polling.js

var polling_startPollingFor = function startPollingFor(obj) {
  return {
    type: reducers_polling["b" /* POLLING_START */],
    payload: {
      object: obj
    }
  };
};
var polling_setPollingTimeoutFor = function setPollingTimeoutFor(obj, timeoutId) {
  return {
    type: reducers_polling["a" /* POLLING_SET_TIMEOUT */],
    payload: {
      object: obj,
      timeoutId: timeoutId
    }
  };
};
var polling_stopPollingFor = function stopPollingFor(obj) {
  return {
    type: reducers_polling["c" /* POLLING_STOP */],
    payload: {
      object: obj
    }
  };
};
var resetPollingFor = function resetPollingFor(obj) {
  return function (dispatch, getState) {
    clearTimeout(getState().polling[obj].timeoutId);
    return dispatch(polling_stopPollingFor(obj));
  };
};
var resetPolling = function resetPolling() {
  return function (dispatch, getState) {
    var _getState = getState(),
        polling = _getState.polling;

    var keys = Object.keys(polling);

    for (var i = keys.length - 1; i >= 0; i -= 1) {
      dispatch(resetPollingFor(keys[i]));
    }
  };
};
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(76);
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// CONCATENATED MODULE: ./src/utils/polling.js


var polling_poll = function poll(fn) {
  var condition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (f) {
    return f;
  };
  var successCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (f) {
    return f;
  };
  var errorCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (f) {
    return f;
  };
  var completionCallback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (f) {
    return f;
  };
  var timeout = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : config["POLL_TIMEOUT"];

  if (false) {
    return function (f) {
      return f;
    };
  }

  if (typeof fn !== 'function') {
    throw new Error("POLLING: argument fn: ".concat(fn, " is not a function"));
  }

  if (typeof condition !== 'function') {
    throw new Error("POLLING: argument condition: ".concat(condition, " is not a function"));
  }

  if (typeof successCallback !== 'function') {
    throw new Error("POLLING: argument  successCallback: ".concat(successCallback, " is not a function"));
  }

  if (typeof errorCallback !== 'function') {
    throw new Error("POLLING: argument  errorCallback: ".concat(errorCallback, " is not a function"));
  }

  if (typeof completionCallback !== 'function') {
    throw new Error("POLLING: argument  completionCallback: ".concat(completionCallback, " is not a function"));
  }

  var timeoutId;

  var pollOnce = function pollOnce() {
    timeoutId = setTimeout(function () {
      return fn().then(function (result) {
        clearTimeout(timeoutId);

        if (condition()) {
          pollOnce();
          successCallback(result, timeoutId);
        } else {
          completionCallback(result, timeoutId);
        }
      }, function (error) {
        clearTimeout(timeoutId);
        errorCallback(error);
      });
    }, timeout);
  };

  pollOnce();
  return timeoutId;
};

/* harmony default export */ var utils_polling = (polling_poll);
// CONCATENATED MODULE: ./src/utils/stringUtil.js
var compareStringByKey = function compareStringByKey(key, reverse) {
  return function (obj1, obj2) {
    if (obj1[key] < obj2[key]) {
      return reverse ? 1 : -1;
    }

    if (obj1[key] > obj2[key]) {
      return reverse ? -1 : 1;
    }

    return 0;
  };
};
var hashString = function hashString(str) {
  var hash = 0;
  var i = 0;
  if (str.length === 0) return hash;

  for (i = 0; i < str.length; i += 1) {
    var chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }

  return Math.abs(hash).toString(16);
};
// CONCATENATED MODULE: ./src/reducers/routeReducers/signIn.js
/* unused harmony export handleRedirection */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONS; });
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }






 // import { checkPasswordFormat } from '../../routes/signIn/utils';







var signIn_getColor = function getColor(txt) {
  return "#".concat(hashString(txt).slice(-7, -1));
};

var regFieldsMap = {
  name: 'name',
  email: 'email',
  role: 'currentRole',
  password: 'password',
  license_id: 'license_id'
};
var INIT = 'signIn/INIT';
var TOGGLE_FORM = 'signIn/TOGGLE_FORM';
var SET_VALUE_FOR = 'signIn/SET_VALUE_FOR';
var SET_ATTEMPTING_LOGIN = 'signIn/SET_ATTEMPTING_LOGIN';
var SET_SIGNIN_ERR = 'signIn/SET_SIGNIN_ERR';
var SET_SUBDOMAIN = 'signIn/SET_SUBDOMAIN';
var HANDLE_ERROR = 'signIn/HANDLE_ERROR';
var TOGGLE_FORGOT_PASS = 'signIn/TOGGLE_FORGOT_PASS';
var SUBMIT_FORGOT_PASS = 'signIn/SUBMIT_FORGOT_PASS';
var SET_FOR_PASS_FIELDS_VAL = 'signIn/SET_FOR_PASS_FIELDS_VAL';
var SET_REG_FIELDS = 'signIn/SET_REG_FIELDS';
var SET_PASS_ERRMSG = 'signIn/SET_PASS_ERRMSG';
var PASS_TXT_TYPE = 'signIn/PASS_TXT_TYPE';
var TOGGLE_DROPDOWN = 'signIn/TOGGLE_DROPDOWN';
var SELECT_FILTER = 'signIn/SELECT_FILTER';
var SET_REG_COMPLETE = 'signIn/SET_REG_COMPLETE';
var SET_COOKIE_MSG = 'signIn/SET_COOKIE_MSG';
var SET_ALIAS_INFO = 'signIn/SET_ALIAS_INFO';
var defaultState = {
  orgId: '',
  regFields: [],
  showRegister: false,
  signinErrMsg: '',
  regErrMsg: '',
  subdomain: '',
  setPassword: false,
  currentForm: 'register',
  forgotPass: false,
  cookieMsg: false,
  attemptingLogin: false,
  loginFields: {
    email: '',
    password: ''
  },
  registerFields: {},
  forgotPassFields: {
    email: ''
  },
  forgotPassSubmitted: false,
  passErrMsg: '',
  passwordTxtType: 'password',
  filterDropdown: false,
  currentRole: '',
  registerComplete: false,
  validationTxt: '',
  showRegForm: false,
  sessionId: ''
};

var initInternal = function initInternal(orgId, regFields, showRegForm, registerFields, currentForm, roles) {
  return {
    type: INIT,
    orgId: orgId,
    regFields: regFields,
    showRegForm: showRegForm,
    registerFields: registerFields,
    currentForm: currentForm,
    roles: roles
  };
};

var setLoginFields = function setLoginFields(fields) {
  return {
    type: SET_VALUE_FOR,
    fields: fields
  };
};

var setAttemptingLogin = function setAttemptingLogin(bool) {
  return {
    type: SET_ATTEMPTING_LOGIN,
    bool: bool
  };
}; // const setSigninErr = err => ({ type: SET_SIGNIN_ERR, err });


var setSubdomain = function setSubdomain(domain) {
  return {
    type: SET_SUBDOMAIN,
    domain: domain
  };
};

var submitForgotPass = function submitForgotPass(bool) {
  return {
    type: SUBMIT_FORGOT_PASS,
    bool: bool
  };
};

var setRegField = function setRegField(fields) {
  return {
    type: SET_REG_FIELDS,
    fields: fields
  };
}; // const setPassErrMsg = passErrMsg => ({ type: SET_PASS_ERRMSG, passErrMsg });


var setForgotPassFieldVal = function setForgotPassFieldVal(fields) {
  return {
    type: SET_FOR_PASS_FIELDS_VAL,
    fields: fields
  };
};

var setRegComplete = function setRegComplete(bool, sessionId) {
  return {
    type: SET_REG_COMPLETE,
    bool: bool,
    sessionId: sessionId
  };
};

var setCookieMsg = function setCookieMsg(bool) {
  return {
    type: SET_COOKIE_MSG,
    bool: bool
  };
};

var setAliasInfo = function setAliasInfo(validationTxt) {
  return {
    type: SET_ALIAS_INFO,
    validationTxt: validationTxt
  };
};

var signIn_setLoginFieldsVal = function setLoginFieldsVal(field, val) {
  return function (dispatch, getState) {
    var loginFields = getState().routes.signIn.loginFields;
    var clonedLoginFields = Object(lodash["cloneDeep"])(loginFields);
    clonedLoginFields[field] = val;
    dispatch(setLoginFields(clonedLoginFields));
  };
};

var signIn_setForgotPassField = function setForgotPassField(field, val) {
  return function (dispatch, getState) {
    var forgotPassFields = getState().routes.signIn.forgotPassFields;
    var clonedforgotPassFields = Object(lodash["cloneDeep"])(forgotPassFields);
    clonedforgotPassFields[field] = val;
    dispatch(setForgotPassFieldVal(clonedforgotPassFields));
  };
};

var signIn_setRegFieldVal = function setRegFieldVal(field, val) {
  return function (dispatch, getState) {
    var registerFields = getState().routes.signIn.registerFields;
    var clonedRegisterFields = Object(lodash["cloneDeep"])(registerFields);
    clonedRegisterFields[field] = val;
    dispatch(setRegField(clonedRegisterFields)); // if (field === 'password') {
    //   const passErrMsg = checkPasswordFormat(val);
    //   dispatch(setPassErrMsg(passErrMsg));
    // }
  };
};

var signIn_redirectToSubdomain = function redirectToSubdomain(subdomain) {
  var redirectUrl = Object(login["a" /* default */])({
    organizationSubdomain: subdomain,
    websiteHost: window.location.host
  });
  window.location.replace(redirectUrl);
};

var generateApiDetails = function generateApiDetails(regFields, state) {
  var registerFields = state.registerFields,
      currentRole = state.currentRole;
  var details = {};

  for (var i = regFields.length - 1; i >= 0; i -= 1) {
    var field = regFields[i];
    var stateKey = regFieldsMap[field];

    if (stateKey === 'currentRole') {
      details[field] = currentRole.value;
    } else {
      details[field] = registerFields[stateKey];
    }
  }

  return details;
};

var handleError = function handleError(error, errorCode) {
  console.error("API returned ".concat(errorCode, " status code:"), error);
  var errorMessage = 'Some error occured';

  if (error.errorMessage) {
    errorMessage = error.errorMessage;
  }

  if (typeof error === 'string') {
    errorMessage = error;
  }

  return {
    errorMessage: errorMessage,
    errorCode: errorCode
  };
};

var regsiterUser =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(orgId, formDetails) {
    var _ref2, error, errorCode, data, _handleError, errorMessage;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return Object(tokenHelpers["a" /* withClientToken */])({
              action: registration["c" /* registerUserToOrg */],
              args: [orgId, formDetails]
            });

          case 3:
            _ref2 = _context.sent;
            error = _ref2.error;
            errorCode = _ref2.errorCode;
            data = _objectWithoutProperties(_ref2, ["error", "errorCode"]);

            if (!error) {
              _context.next = 10;
              break;
            }

            _handleError = handleError(error, errorCode), errorMessage = _handleError.errorMessage;
            return _context.abrupt("return", {
              error: errorMessage,
              sessionId: null
            });

          case 10:
            return _context.abrupt("return", {
              error: null,
              sessionId: data.session_id
            });

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
            return _context.abrupt("return", {
              error: 'Some error occured. Please try again later.',
              sessionId: null
            });

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 13]]);
  }));

  return function regsiterUser(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var signIn_handleRedirection = function handleRedirection(domainStatus, subdomain) {
  if (domainStatus) {
    setTimeout(signIn_redirectToSubdomain(subdomain), 1000);
    return;
  }

  src_history["a" /* default */].push('/redirect');
};

var signIn_handleLogin = function handleLogin() {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(dispatch, getState) {
        var loginFields, email, password, _ref4, error, errorCode, data, subdomain, userId, user, domainStatus;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                Object(cookie["f" /* saveCookieConsent */])(true);
                dispatch(setCookieMsg(false));
                loginFields = getState().routes.signIn.loginFields;
                email = loginFields.email, password = loginFields.password;

                if (email) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", dispatch(layout["a" /* ACTIONS */].setAlert("Email field can't be empty", 'danger')));

              case 6:
                if (password) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return", dispatch(layout["a" /* ACTIONS */].setAlert("Password field can't be empty", 'danger')));

              case 8:
                dispatch(setAttemptingLogin(true));
                _context2.prev = 9;
                _context2.next = 12;
                return Object(tokenHelpers["a" /* withClientToken */])({
                  action: sagAuth["c" /* loginUser */],
                  args: [email, password]
                });

              case 12:
                _ref4 = _context2.sent;
                error = _ref4.error;
                errorCode = _ref4.errorCode;
                data = _objectWithoutProperties(_ref4, ["error", "errorCode"]);

                if (!error) {
                  _context2.next = 20;
                  break;
                }

                if (errorCode === 403) {
                  dispatch(layout["a" /* ACTIONS */].setAlert(error.errorMessage, 'danger'));
                  setTimeout(function () {
                    return src_history["a" /* default */].push('/change-password?title=Reset');
                  }, 2000);
                }

                dispatch(setAttemptingLogin(false));
                return _context2.abrupt("return", dispatch(layout["a" /* ACTIONS */].setAlert(error.errorMessage, 'danger')));

              case 20:
                subdomain = data.subdomain_url, userId = data.id;
                user = Object(lodash["merge"])({}, data, {
                  user_id: userId
                });
                delete user.user_token;
                delete user.refresh_token;
                delete user.redirection_token;
                delete user.id;
                Object(cookie["e" /* saveAuthCookie */])(subdomain);
                domainStatus = true;
                dispatch(setSubdomain(subdomain));
                Object(cookie["a" /* clearExtraAliasInfo */])(); // console.log({domainStatus, subdomain})

                signIn_handleRedirection(domainStatus, subdomain);
                _context2.next = 37;
                break;

              case 33:
                _context2.prev = 33;
                _context2.t0 = _context2["catch"](9);
                console.error(_context2.t0);
                dispatch(setAttemptingLogin(false));

              case 37:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[9, 33]]);
      }));

      return function (_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
};

var signIn_pollSessionLogin = function pollSessionLogin() {
  var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
  return function (dispatch, getState) {
    var sessionId = getState().routes.signIn.sessionId;

    var _getState = getState(),
        polling = _getState.polling; // check if already polling


    if (polling.sessionLogin && polling.sessionLogin.isPolling) {
      dispatch(resetPollingFor('sessionLogin'));
    }

    dispatch(polling_startPollingFor('sessionLogin'));

    var stopPolling = function stopPolling() {
      dispatch(resetPollingFor('sessionLogin'));
    };

    var loginSuccessful = false;
    var subdomain = '';
    var timeoutId = utils_polling(function () {
      return Object(sagAuth["d" /* loginUserSession */])(sessionId).then(function (_ref5) {
        var userToken = _ref5.userToken,
            orgSubD = _ref5.subdomain;
        loginSuccessful = !!userToken;
        subdomain = orgSubD;
      });
    }, function () {
      return !loginSuccessful;
    }, function (dummy, nextTimeoutId) {
      return dispatch(polling_setPollingTimeoutFor('sessionLogin', nextTimeoutId));
    }, function (error) {
      throw new Error(error);
    }, function () {
      stopPolling();
      signIn_redirectToSubdomain(subdomain);
    }, timeout);
    dispatch(polling_setPollingTimeoutFor('sessionLogin', timeoutId));
  };
};

var signIn_handleRegister = function handleRegister() {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(dispatch, getState) {
        var _getState$routes$sign, registerFields, regFields, currentRole, orgId, password, password2, name, email, extraAliasInfo, parsedExtraAliasInfo, passwordRegex, showRegForm, validationTxt, correctPass, details, responseOrgId, _ref7, error, sessionId;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _getState$routes$sign = getState().routes.signIn, registerFields = _getState$routes$sign.registerFields, regFields = _getState$routes$sign.regFields, currentRole = _getState$routes$sign.currentRole, orgId = _getState$routes$sign.orgId;
                password = registerFields.password, password2 = registerFields.password2, name = registerFields.name, email = registerFields.email;

                if (!(Object.keys(registerFields).includes('name') && !name)) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return", dispatch(layout["a" /* ACTIONS */].setAlert("Name field can't be empty", 'danger')));

              case 4:
                if (!(Object.keys(registerFields).includes('email') && !email)) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return", dispatch(layout["a" /* ACTIONS */].setAlert("Email field can't be empty", 'danger')));

              case 6:
                if (!(Object.keys(registerFields).includes('role') && (!currentRole || currentRole === 'Select Role'))) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return", dispatch(layout["a" /* ACTIONS */].setAlert('Please select a role', 'danger')));

              case 8:
                if (!(Object.keys(registerFields).includes('license_id') && !currentRole)) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt("return", dispatch(layout["a" /* ACTIONS */].setAlert('No valid license found', 'danger')));

              case 10:
                if (!(Object.keys(registerFields).includes('password') && !password)) {
                  _context3.next = 12;
                  break;
                }

                return _context3.abrupt("return", dispatch(layout["a" /* ACTIONS */].setAlert("Password can't be empty", 'danger')));

              case 12:
                extraAliasInfo = Object(cookie["d" /* getCookieValue */])('extra_alias_info');

                if (!(Object.keys(registerFields).includes('password') && extraAliasInfo)) {
                  _context3.next = 19;
                  break;
                }

                parsedExtraAliasInfo = JSON.parse(extraAliasInfo);
                passwordRegex = parsedExtraAliasInfo.passwordRegex, showRegForm = parsedExtraAliasInfo.showRegForm, validationTxt = parsedExtraAliasInfo.validationTxt;
                correctPass = RegExp(passwordRegex).test(registerFields.password);

                if (correctPass) {
                  _context3.next = 19;
                  break;
                }

                return _context3.abrupt("return", dispatch(setAliasInfo(validationTxt)));

              case 19:
                if (!(Object.keys(registerFields).includes('password') && password !== password2)) {
                  _context3.next = 21;
                  break;
                }

                return _context3.abrupt("return", dispatch(layout["a" /* ACTIONS */].setAlert("Passwords don't match", 'danger')));

              case 21:
                details = generateApiDetails(regFields, getState().routes.signIn);
                responseOrgId = '';

                if (extraAliasInfo) {
                  responseOrgId = JSON.parse(extraAliasInfo).responseOrgId;
                }

                dispatch(setAttemptingLogin(true));
                _context3.prev = 25;
                _context3.next = 28;
                return regsiterUser(responseOrgId || orgId, details);

              case 28:
                _ref7 = _context3.sent;
                error = _ref7.error;
                sessionId = _ref7.sessionId;

                // sessionId will be used for polling..
                if (error) {
                  dispatch(setRegComplete(false));
                  dispatch(setAttemptingLogin(false));
                  dispatch(layout["a" /* ACTIONS */].setAlert(error, 'danger'));
                } else {
                  dispatch(setAttemptingLogin(false));
                  dispatch(setRegComplete(true, sessionId));
                  Object(cookie["a" /* clearExtraAliasInfo */])();
                  dispatch(signIn_pollSessionLogin());
                }

                _context3.next = 40;
                break;

              case 34:
                _context3.prev = 34;
                _context3.t0 = _context3["catch"](25);
                console.error(_context3.t0);
                setAttemptingLogin(false);
                dispatch(setRegComplete(false));
                dispatch(layout["a" /* ACTIONS */].setAlert(_context3.t0.errorMessage, 'danger'));

              case 40:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[25, 34]]);
      }));

      return function (_x5, _x6) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
};

var signIn_handleForgotPassword = function handleForgotPassword() {
  return (
    /*#__PURE__*/
    function () {
      var _ref8 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(dispatch, getState) {
        var forgotPassFields, email, _ref9, error, errorCode;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch(setAttemptingLogin(true));
                forgotPassFields = getState().routes.signIn.forgotPassFields;
                email = forgotPassFields.email;

                if (email) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return", dispatch(layout["a" /* ACTIONS */].setAlert('Please enter email', 'danger')));

              case 5:
                _context4.prev = 5;
                _context4.next = 8;
                return Object(tokenHelpers["a" /* withClientToken */])({
                  action: sagAuth["a" /* forgotPassword */],
                  args: [email]
                });

              case 8:
                _ref9 = _context4.sent;
                error = _ref9.error;
                errorCode = _ref9.errorCode;

                if (error) {
                  dispatch(layout["a" /* ACTIONS */].setAlert('Some error occured. Please try again later', 'success'));
                }

                dispatch(submitForgotPass(true));
                dispatch(setAttemptingLogin(false));
                _context4.next = 21;
                break;

              case 16:
                _context4.prev = 16;
                _context4.t0 = _context4["catch"](5);
                console.error(_context4.t0);
                dispatch(setAttemptingLogin(false));
                dispatch(layout["a" /* ACTIONS */].setAlert('Some error eccured. Please try after some time', 'danger'));

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[5, 16]]);
      }));

      return function (_x7, _x8) {
        return _ref8.apply(this, arguments);
      };
    }()
  );
};

var enterPressHandler = function enterPressHandler(compType) {
  return function (dispatch) {
    if (compType === 'login') {
      dispatch(signIn_handleLogin());
    }

    if (compType === 'register') {
      dispatch(signIn_handleRegister());
    }
  };
};

var signIn_promptCookie = function promptCookie() {
  return function (dispatch) {
    var cookieConsent = Object(cookie["d" /* getCookieValue */])('cookie_consent');

    if (cookieConsent) {
      dispatch(signIn_handleLogin());
    } else {
      dispatch(setCookieMsg(true));
    }
  };
};

var declineCookie = function declineCookie() {
  return function (dispatch) {
    dispatch(setCookieMsg(false));
  };
};

var signIn_errorOpts = function errorOpts(error, errorCode, errType) {
  console.error("API returned ".concat(errorCode, " status code:"), error);
  var errorMessage = 'Some error occured';

  if (error.detail) {
    errorMessage = error.detail;
  }

  if (error.email) {
    errorMessage = error.email[0];
  }

  if (error.message) {
    errorMessage = error.message;
  }

  if (error.errorMessage && Object(lodash["isArray"])(error.errorMessage)) {
    errorMessage = error.errorMessage[0];
  }

  if (error.errorMessage && typeof error.errorMessage === 'string') {
    errorMessage = error.errorMessage;
  }

  if (typeof error === 'string') {
    errorMessage = error;
  }

  if (errType === 'login') {
    return {
      signinErrMsg: errorMessage,
      attemptingLogin: false
    };
  }

  return {
    regErrMsg: errorMessage,
    attemptingLogin: false
  };
};

var signIn_init = function init(_ref10) {
  var apiData = _ref10.apiData;
  return (
    /*#__PURE__*/
    function () {
      var _ref11 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5(dispatch) {
        var regFields, orgId, showRegister, registerFields, showRegForm, extraAliasInfo, parsedInfo, mappedRoles, _ref12, roles, error;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                regFields = apiData.regFields, orgId = apiData.orgId, showRegister = apiData.showRegister;
                registerFields = {};
                regFields.forEach(function (d) {
                  registerFields[d] = '';
                });
                registerFields.password2 = '';
                showRegForm = true;
                extraAliasInfo = Object(cookie["d" /* getCookieValue */])('extra_alias_info');

                if (extraAliasInfo) {
                  parsedInfo = JSON.parse(extraAliasInfo);
                  showRegForm = parsedInfo.showRegForm;
                }

                mappedRoles = [];

                if (!orgId) {
                  _context5.next = 25;
                  break;
                }

                showRegForm = !!orgId;
                _context5.prev = 10;
                _context5.next = 13;
                return Object(tokenHelpers["a" /* withClientToken */])({
                  action: registration["b" /* listOrgProfiles */],
                  args: [orgId]
                });

              case 13:
                _ref12 = _context5.sent;
                roles = _ref12.roles;
                error = _ref12.error;
                mappedRoles = roles && roles.length && roles.map(function (role) {
                  return {
                    value: role.role.name,
                    label: role.role.name,
                    id: role.role.profile_id,
                    color: signIn_getColor(role.role.name)
                  };
                });
                dispatch(initInternal(orgId, regFields, showRegForm, registerFields, orgId ? 'register' : 'login', mappedRoles));
                _context5.next = 23;
                break;

              case 20:
                _context5.prev = 20;
                _context5.t0 = _context5["catch"](10);
                console.error(_context5.t0);

              case 23:
                _context5.next = 26;
                break;

              case 25:
                dispatch(initInternal(orgId, regFields, showRegForm, registerFields, orgId ? 'register' : 'login'));

              case 26:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[10, 20]]);
      }));

      return function (_x9) {
        return _ref11.apply(this, arguments);
      };
    }()
  );
};

var ACTIONS = {
  init: signIn_init,
  toggleForm: function toggleForm(form) {
    return {
      type: TOGGLE_FORM,
      form: form
    };
  },
  toggleForgotPass: function toggleForgotPass(bool) {
    return {
      type: TOGGLE_FORGOT_PASS,
      bool: bool
    };
  },
  changePassTxtType: function changePassTxtType() {
    return {
      type: PASS_TXT_TYPE
    };
  },
  toggleDropDown: function toggleDropDown(bool) {
    return {
      type: TOGGLE_DROPDOWN,
      bool: bool
    };
  },
  selectFilter: function selectFilter(role) {
    return {
      type: SELECT_FILTER,
      role: role
    };
  },
  setLoginFieldsVal: signIn_setLoginFieldsVal,
  handleLogin: signIn_handleLogin,
  enterPressHandler: enterPressHandler,
  handleForgotPassword: signIn_handleForgotPassword,
  setForgotPassField: signIn_setForgotPassField,
  submitForgotPass: submitForgotPass,
  setRegFieldVal: signIn_setRegFieldVal,
  handleRegister: signIn_handleRegister,
  promptCookie: signIn_promptCookie,
  declineCookie: declineCookie
};

function signIn() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case INIT:
      return Object.assign({}, state, {
        orgId: action.orgId,
        regFields: action.regFields,
        showRegister: action.showRegForm,
        registerFields: action.registerFields,
        currentForm: action.currentForm,
        roles: action.roles
      });

    case TOGGLE_FORM:
      return Object.assign({}, state, {
        currentForm: action.form
      });

    case SET_VALUE_FOR:
      return Object.assign({}, state, {
        loginFields: action.fields
      });

    case SET_ATTEMPTING_LOGIN:
      return Object.assign({}, state, {
        attemptingLogin: action.bool
      });

    case SET_SIGNIN_ERR:
      return Object.assign({}, state, {
        signinErrMsg: action.err
      });

    case SET_SUBDOMAIN:
      return Object.assign({}, state, {
        subdomain: action.domain
      });

    case HANDLE_ERROR:
      return Object.assign({}, state, signIn_errorOpts(action.err, action.errCode, action.errType));

    case TOGGLE_FORGOT_PASS:
      return Object.assign({}, state, {
        forgotPass: action.bool,
        signinErrMsg: ''
      });

    case SUBMIT_FORGOT_PASS:
      return Object.assign({}, state, {
        forgotPassSubmitted: action.bool,
        signinErrMsg: ''
      });

    case SET_FOR_PASS_FIELDS_VAL:
      return Object.assign({}, state, {
        forgotPassFields: action.fields
      });

    case SET_REG_FIELDS:
      return Object.assign({}, state, {
        registerFields: action.fields
      });

    case SET_PASS_ERRMSG:
      return Object.assign({}, state, {
        passErrMsg: action.passErrMsg
      });

    case PASS_TXT_TYPE:
      return Object.assign({}, state, {
        passwordTxtType: state.passwordTxtType === 'text' ? 'password' : 'text'
      });

    case TOGGLE_DROPDOWN:
      return Object.assign({}, state, {
        filterDropdown: action.bool
      });

    case SELECT_FILTER:
      return Object.assign({}, state, {
        currentRole: action.role,
        filterDropdown: false
      });

    case SET_REG_COMPLETE:
      return Object.assign({}, state, {
        registerComplete: action.bool,
        sessionId: action.sessionId
      });

    case SET_COOKIE_MSG:
      return Object.assign({}, state, {
        cookieMsg: action.bool
      });

    case SET_ALIAS_INFO:
      return Object.assign({}, state, {
        validationTxt: action.validationTxt // showRegForm: action.showRegForm,

      });

    default:
      return Object.assign({}, state);
  }
}

/* harmony default export */ var routeReducers_signIn = __webpack_exports__["b"] = (signIn);

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dbdab5ab.png";

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tokenSelector; });
/* unused harmony export refreshTokenSelector */
/* unused harmony export isAuthenticatedSelector */
/* unused harmony export userSelector */
/* unused harmony export userIdSelector */
/* unused harmony export userNameSelector */
/* unused harmony export userEmailSelector */
/* unused harmony export userImageSelector */
/* unused harmony export userRoleSelector */
/* unused harmony export orgIdSelector */
/* unused harmony export orgCtxSelector */
/* unused harmony export isPlanGeneratedSelector */
/* unused harmony export authErrorSelector */
/* unused harmony export isAdminSelector */
/* unused harmony export hasCompletedPreTestSelector */
/* unused harmony export preTestIdSelector */
/* unused harmony export isFirstLoginSelector */
/* unused harmony export fcmTokenCreatedSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_cookie__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config__);
// import { createSelector } from 'reselect';


var tokenSelector = function tokenSelector(state) {
  return state && state.auth.token;
};
var refreshTokenSelector = function refreshTokenSelector() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_cookie__["d" /* getCookieValue */])(__WEBPACK_IMPORTED_MODULE_1__config__["SPOTMENTOR_ENV"]);
};
var isAuthenticatedSelector = function isAuthenticatedSelector() {
  return !!refreshTokenSelector();
};
var userSelector = function userSelector(state) {
  return state.auth.user;
};
var userIdSelector = function userIdSelector(state) {
  return state.auth.user && state.auth.user.user_id;
};
var userNameSelector = function userNameSelector(state) {
  return state.auth.user && state.auth.user.name || 'User';
};
var userEmailSelector = function userEmailSelector(state) {
  return state.auth.user && state.auth.user.email || '';
};
var userImageSelector = function userImageSelector(state) {
  return state.auth.user && state.auth.user.profile_picture;
};
var userRoleSelector = function userRoleSelector(state) {
  return state.auth.user && state.auth.user.divisions && state.auth.user.divisions.role;
};
var orgIdSelector = function orgIdSelector(state) {
  return state.auth.user && state.auth.user.organization_id;
};
var orgCtxSelector = function orgCtxSelector(state) {
  return state.auth.user && state.auth.user.context || 'live';
};
var isPlanGeneratedSelector = function isPlanGeneratedSelector(state) {
  return state.auth.user && state.auth.user.learning_plans_generated;
};
var authErrorSelector = function authErrorSelector(state) {
  return state.auth.errorMessage && 'detail' in state.auth.errorMessage && state.auth.errorMessage.detail || '';
};
var isAdminSelector = function isAdminSelector(state) {
  return state.auth.user && state.auth.user.user_type <= 3;
};
var hasCompletedPreTestSelector = function hasCompletedPreTestSelector(state) {
  return state.auth.user && state.auth.user.has_completed_pretest;
};
var preTestIdSelector = function preTestIdSelector(state) {
  return state.auth.user && state.auth.user.pretest_assessment_id;
};
var isFirstLoginSelector = function isFirstLoginSelector(state) {
  return state.auth.user && !!state.auth.user.is_first_login;
};
var fcmTokenCreatedSelector = function fcmTokenCreatedSelector(state) {
  return state.auth.user && Object.values(state.auth.user.fcm_info || {}).some(function (d) {
    return d;
  });
};

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return POLLING_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return POLLING_STOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return POLLING_SET_TIMEOUT; });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var POLLING_START = 'polling/POLLING_START';
var POLLING_STOP = 'polling/POLLING_STOP';
var POLLING_SET_TIMEOUT = 'polling/POLLING_SET_TIMEOUT';

function polling() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var key = action.payload && action.payload.object;

  switch (action.type) {
    case POLLING_START:
      return Object.assign({}, state, _defineProperty({}, key, {
        isPolling: true,
        timeoutId: ''
      }));

    case POLLING_SET_TIMEOUT:
      return Object.assign({}, state, _defineProperty({}, key, {
        isPolling: true,
        timeoutId: action.payload.timeoutId
      }));

    case POLLING_STOP:
      return Object.assign({}, state, _defineProperty({}, key, {
        isPolling: false,
        timeoutId: ''
      }));

    default:
      return state;
  }
}

/* harmony default export */ __webpack_exports__["d"] = (polling);

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(11);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__(240);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(63);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/isomorphic-style-loader/lib/withStyles.js
var withStyles = __webpack_require__(57);
var withStyles_default = /*#__PURE__*/__webpack_require__.n(withStyles);

// EXTERNAL MODULE: ./node_modules/font-awesome/css/font-awesome.min.css
var font_awesome_min = __webpack_require__(525);
var font_awesome_min_default = /*#__PURE__*/__webpack_require__.n(font_awesome_min);

// EXTERNAL MODULE: ./node_modules/bootstrap/dist/css/bootstrap.min.css
var bootstrap_min = __webpack_require__(248);
var bootstrap_min_default = /*#__PURE__*/__webpack_require__.n(bootstrap_min);

// EXTERNAL MODULE: ./node_modules/normalize.css/normalize.css
var normalize = __webpack_require__(548);
var normalize_default = /*#__PURE__*/__webpack_require__.n(normalize);

// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(550);
var slick_default = /*#__PURE__*/__webpack_require__.n(slick);

// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(552);
var slick_theme_default = /*#__PURE__*/__webpack_require__.n(slick_theme);

// EXTERNAL MODULE: ./src/utils/cookie.js
var cookie = __webpack_require__(32);

// EXTERNAL MODULE: ./src/components/Layout/Layout.css
var Layout_Layout = __webpack_require__(559);
var Layout_default = /*#__PURE__*/__webpack_require__.n(Layout_Layout);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(77);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/components/Header/Header.css
var Header_Header = __webpack_require__(561);
var Header_default = /*#__PURE__*/__webpack_require__.n(Header_Header);

// EXTERNAL MODULE: ./src/history.js
var src_history = __webpack_require__(40);

// CONCATENATED MODULE: ./src/components/Link/Link.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }





function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var Link_Link =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = Link.__proto__ || Object.getPrototypeOf(Link)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "handleClick", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        if (_this.props.onClick) {
          _this.props.onClick(event);
        }

        if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
          return;
        }

        if (event.defaultPrevented === true) {
          return;
        }

        if (_this.props.to) {
          event.preventDefault();
          src_history["a" /* default */].push(_this.props.to);
        }

        (function () {});
      }
    }), _temp));
  }

  _createClass(Link, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          to = _props.to,
          children = _props.children,
          props = _objectWithoutProperties(_props, ["to", "children"]);

      return react_default.a.createElement("a", _extends({
        href: to
      }, props, {
        onClick: this.handleClick
      }), children);
    }
  }]);

  return Link;
}(react_default.a.Component);

Object.defineProperty(Link_Link, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    onClick: null
  }
});
/* harmony default export */ var components_Link_Link = (Link_Link);
// EXTERNAL MODULE: ./src/components/Header/LogoSvgFull.js
var LogoSvgFull = __webpack_require__(249);

// EXTERNAL MODULE: ./src/components/Header/img/logowhite.png
var logowhite = __webpack_require__(222);
var logowhite_default = /*#__PURE__*/__webpack_require__.n(logowhite);

// CONCATENATED MODULE: ./src/utils.js
var smoothScroll = {
  timer: null,
  stop: function stop() {
    clearTimeout(this.timer);
  },
  scrollTo: function scrollTo(id, callback) {
    var settings = {
      duration: 2000,
      easing: {
        outQuint: function outQuint(x, t, b, c, d) {
          return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
        }
      }
    };
    var percentage;
    var startTime;
    var node = document.getElementById(id);
    var nodeTop = node.offsetTop;
    var nodeHeight = node.offsetHeight;
    var body = document.body;
    var html = document.documentElement;
    var height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    var windowHeight = window.innerHeight;
    var offset = window.pageYOffset;
    var delta = nodeTop - offset;
    var bottomScrollableY = height - windowHeight;
    var targetY = bottomScrollableY < delta ? bottomScrollableY - (height - nodeTop - nodeHeight + offset) : delta;
    startTime = Date.now();
    percentage = 0;

    if (this.timer) {
      clearInterval(this.timer);
    }

    function step() {
      var yScroll;
      var elapsed = Date.now() - startTime;

      if (elapsed > settings.duration) {
        clearTimeout(this.timer);
      }

      percentage = elapsed / settings.duration;

      if (percentage > 1) {
        clearTimeout(this.timer);

        if (callback) {
          callback();
        }
      } else {
        yScroll = settings.easing.outQuint(0, elapsed, offset, targetY, settings.duration);
        window.scrollTo(0, yScroll);
        this.timer = setTimeout(step, 5);
      }
    }

    this.timer = setTimeout(step, 5);
  }
};
// EXTERNAL MODULE: ./src/utils/login.js
var login = __webpack_require__(81);

// CONCATENATED MODULE: ./src/components/Header/Header.js
function Header__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Header__typeof = function _typeof(obj) { return typeof obj; }; } else { Header__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Header__typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Header__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Header__createClass(Constructor, protoProps, staticProps) { if (protoProps) Header__defineProperties(Constructor.prototype, protoProps); if (staticProps) Header__defineProperties(Constructor, staticProps); return Constructor; }

function Header__possibleConstructorReturn(self, call) { if (call && (Header__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Header__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }












var Header__ref = _jsx("i", {
  className: "fa fa-power-off"
});

var _ref2 = _jsx("a", {
  href: "https://cutshort.io/company/spotmentor-technologies?career_page=true",
  target: "_blank"
}, void 0, ' ', "Join us", ' ');

var _ref3 = _jsx("i", {
  className: "fa fa-laptop"
});

var _ref4 = _jsx("i", {
  className: "fa fa-power-off"
});

var Header_Header_Header =
/*#__PURE__*/
function (_React$Component) {
  Header__inherits(Header, _React$Component);

  function Header(props) {
    var _this;

    Header__classCallCheck(this, Header);

    _this = Header__possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
    Object.defineProperty(Header__assertThisInitialized(_this), "uppdateScroll", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          scrollPosition: window.scrollY
        });
      }
    });
    Object.defineProperty(Header__assertThisInitialized(_this), "scrollToNews", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        smoothScroll.scrollTo('newsHere');
      }
    });
    Object.defineProperty(Header__assertThisInitialized(_this), "updateDimensions", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          windowWidth: window.innerWidth
        });
      }
    });
    Object.defineProperty(Header__assertThisInitialized(_this), "clickSignIn", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        src_history["a" /* default */].push('/sign-in');

        _this.setState({
          isOpenedPanel: false
        });
      }
    });
    Object.defineProperty(Header__assertThisInitialized(_this), "clickLogin", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        src_history["a" /* default */].push('/sign-in');

        _this.setState({
          isOpenedPanel: false
        });
      }
    });
    Object.defineProperty(Header__assertThisInitialized(_this), "navClick", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(to) {
        var nav = function nav() {
          if (window.location.pathname === '/') {
            smoothScroll.scrollTo(to);
          } else {
            src_history["a" /* default */].push("/#".concat(to));
          }
        };

        _this.setState({
          isOpenedPanel: false
        }, nav);
      }
    });
    Object.defineProperty(Header__assertThisInitialized(_this), "goTo", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(to) {
        var nav = function nav() {
          _this.props.logoutUser();

          src_history["a" /* default */].push(to);
        };

        _this.setState({
          isOpenedPanel: false
        }, nav);
      }
    });
    Object.defineProperty(Header__assertThisInitialized(_this), "togglePanel", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState(function (prevState) {
          return {
            isOpenedPanel: !prevState.isOpenedPanel
          };
        });
      }
    });
    Object.defineProperty(Header__assertThisInitialized(_this), "handleGoToPlatform", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var user = _this.props.user;
        var redirectUrl = Object(login["a" /* default */])({
          organizationSubdomain: user.subdomain_url,
          websiteHost: window.location.host
        });
        window.location.replace(redirectUrl);
      }
    });
    _this.state = {
      windowWidth: 0,
      isOpenedPanel: false,
      scrollPosition: 0
    };
    return _this;
  }

  Header__createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateDimensions();
      this.uppdateScroll();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      window.addEventListener('resize', this.updatedDimensions);
      window.addEventListener('scroll', this.uppdateScroll);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
      window.removeEventListener('scroll', this.uppdateScroll);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          isLogin = _state.isLogin,
          windowWidth = _state.windowWidth,
          isOpenedPanel = _state.isOpenedPanel,
          scrollPosition = _state.scrollPosition;
      var _props = this.props,
          isLoggedIn = _props.isLoggedIn,
          user = _props.user,
          isCookieConsentGiven = _props.isCookieConsentGiven,
          headerBackground = _props.headerBackground;
      var headerStyle = {
        backgroundColor: 'transparent',
        boxShadow: '0 0 0 0 #fff'
      };
      var textColor = '#fff';
      var buttonTextColor = '#5d4ea2';

      if (headerBackground === 'white' || scrollPosition > 100) {
        headerStyle = {
          backgroundColor: '#fff',
          boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.12)'
        };
        textColor = '#5d4ea2';
        buttonTextColor = '#fff';
      }

      return _jsx("div", {
        className: Header_default.a.container,
        style: {
          backgroundColor: scrollPosition < 100 ? 'transparent' : '#1a1a24',
          boxShadow: scrollPosition < 100 ? '0 0 0 0 #fff' : '0 4px 10px 0 rgba(0, 0, 0, 0.12)'
        }
      }, void 0, _jsx(components_Link_Link, {
        className: Header_default.a.brand,
        onClick: function onClick() {
          return _this2.navClick('top');
        }
      }, void 0, _jsx("img", {
        src: logowhite_default.a,
        style: {
          width: 150
        }
      })), windowWidth > 800 && _jsx("div", {
        className: Header_default.a.navigation
      }, void 0, _jsx("div", {
        className: Header_default.a.pageLinks
      }, void 0, _jsx("div", {
        className: Header_default.a.buttons
      }, void 0, !this.props.isLoggedIn && _jsx("a", {
        onClick: this.clickSignIn
      }, void 0, "Login"), false && !this.props.isLoggedIn && _jsx("a", {
        onClick: this.clickLogin
      }, void 0, "Sign In"), isLoggedIn && user.subdomain_url && _jsx("button", {
        onClick: isCookieConsentGiven ? this.handleGoToPlatform : function () {},
        style: {
          color: buttonTextColor,
          backgroundColor: isCookieConsentGiven ? textColor : '#777',
          cursor: isCookieConsentGiven ? 'pointer' : 'no-drop'
        },
        disabled: !isCookieConsentGiven
      }, void 0, "Go to Platform"), this.props.isLoggedIn && _jsx("a", {
        onClick: function onClick() {
          return _this2.goTo('/logout');
        },
        style: {
          color: textColor
        }
      }, void 0, Header__ref)))), windowWidth <= 800 && _jsx("button", {
        onClick: this.togglePanel,
        className: classnames_default()(Header_default.a.button, _defineProperty({}, Header_default.a.close, isOpenedPanel))
      }, void 0, _jsx("span", {
        className: Header_default.a.hamburger
      })), windowWidth <= 800 && isOpenedPanel && _jsx("div", {
        className: Header_default.a.sideNavPanel
      }, void 0, react_default.a.createElement("div", {
        ref: function ref(c) {
          _this2.sidePanel = c;
        },
        className: Header_default.a.sideNavOverlay // style={{ transform: isOpenedPanel ? 'scale(1)' : 'scale(0)' }}

      }), _jsx("div", {
        className: Header_default.a.smallPageLinks
      }, void 0, _jsx("a", {
        onClick: function onClick() {
          return _this2.navClick('services');
        }
      }, void 0, " Product "), _jsx("a", {
        onClick: function onClick() {
          return _this2.navClick('team');
        }
      }, void 0, " About us "), _ref2, _jsx("a", {
        onClick: function onClick() {
          return src_history["a" /* default */].push('/blog');
        }
      }, void 0, " Blogs ")), _jsx("div", {
        className: Header_default.a.smallButtons
      }, void 0, !this.props.isLoggedIn && _jsx("a", {
        onClick: this.clickLogin
      }, void 0, " Sign In "), isLoggedIn && user.subdomain_url && _jsx("a", {
        onClick: isCookieConsentGiven ? this.handleGoToPlatform : function () {}
      }, void 0, ' ', _jsx("div", {
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, void 0, _ref3, "Go to Platform", ' ')), this.props.isLoggedIn && _jsx("a", {
        onClick: function onClick() {
          return _this2.goTo('/logout');
        },
        style: {
          display: 'flex'
        }
      }, void 0, _ref4, "Logout"))));
    }
  }]);

  return Header;
}(react_default.a.Component);

/* harmony default export */ var components_Header_Header = (withStyles_default()(Header_default.a)(Header_Header_Header));
// EXTERNAL MODULE: ./node_modules/reactstrap/dist/reactstrap.es.js + 6 modules
var reactstrap_es = __webpack_require__(239);

// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(570);
var modules_default = /*#__PURE__*/__webpack_require__.n(modules);

// CONCATENATED MODULE: ./src/components/Footer/icons/UpArrows.js
var UpArrows_REACT_ELEMENT_TYPE;

function UpArrows__jsx(type, props, key, children) { if (!UpArrows_REACT_ELEMENT_TYPE) { UpArrows_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: UpArrows_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function UpArrows__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { UpArrows__typeof = function _typeof(obj) { return typeof obj; }; } else { UpArrows__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return UpArrows__typeof(obj); }

function UpArrows__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function UpArrows__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function UpArrows__createClass(Constructor, protoProps, staticProps) { if (protoProps) UpArrows__defineProperties(Constructor.prototype, protoProps); if (staticProps) UpArrows__defineProperties(Constructor, staticProps); return Constructor; }

function UpArrows__possibleConstructorReturn(self, call) { if (call && (UpArrows__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function UpArrows__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */


var UpArrows__ref = UpArrows__jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 284.929 284.929",
  width: "20px",
  height: "20px"
}, void 0, UpArrows__jsx("g", {
  fill: "#FFF"
}, void 0, UpArrows__jsx("path", {
  d: "M17.128 167.872c1.903 1.902 4.093 2.854 6.567 2.854s4.664-.952 6.567-2.854L142.466 55.666l112.208 112.206c1.902 1.902 4.093 2.854 6.563 2.854 2.478 0 4.668-.952 6.57-2.854l14.274-14.277c1.902-1.902 2.847-4.093 2.847-6.563 0-2.475-.951-4.665-2.847-6.567L149.028 7.419c-1.901-1.906-4.088-2.853-6.562-2.853s-4.665.95-6.567 2.853L2.856 140.464C.95 142.367 0 144.554 0 147.034c0 2.468.953 4.658 2.856 6.561l14.272 14.277z"
}), UpArrows__jsx("path", {
  d: "M149.028 117.055c-1.901-1.906-4.088-2.856-6.562-2.856s-4.665.953-6.567 2.856L2.856 250.1C.95 252.003 0 254.192 0 256.67c0 2.472.953 4.661 2.856 6.564l14.272 14.276c1.903 1.903 4.093 2.848 6.567 2.848s4.664-.951 6.567-2.848l112.204-112.209L254.674 277.51c1.902 1.903 4.093 2.852 6.563 2.852 2.478 0 4.668-.948 6.57-2.852l14.274-14.276c1.902-1.903 2.847-4.093 2.847-6.564 0-2.478-.951-4.667-2.847-6.57L149.028 117.055z"
})));

var UpArrows =
/*#__PURE__*/
function (_React$Component) {
  UpArrows__inherits(UpArrows, _React$Component);

  function UpArrows() {
    UpArrows__classCallCheck(this, UpArrows);

    return UpArrows__possibleConstructorReturn(this, (UpArrows.__proto__ || Object.getPrototypeOf(UpArrows)).apply(this, arguments));
  }

  UpArrows__createClass(UpArrows, [{
    key: "render",
    value: function render() {
      return UpArrows__ref;
    }
  }]);

  return UpArrows;
}(react_default.a.Component);

/* harmony default export */ var icons_UpArrows = (UpArrows);
// CONCATENATED MODULE: ./src/components/Footer/icons/LinkedIn.js
var LinkedIn_REACT_ELEMENT_TYPE;

function LinkedIn__jsx(type, props, key, children) { if (!LinkedIn_REACT_ELEMENT_TYPE) { LinkedIn_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: LinkedIn_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function LinkedIn__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { LinkedIn__typeof = function _typeof(obj) { return typeof obj; }; } else { LinkedIn__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return LinkedIn__typeof(obj); }

function LinkedIn__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LinkedIn__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function LinkedIn__createClass(Constructor, protoProps, staticProps) { if (protoProps) LinkedIn__defineProperties(Constructor.prototype, protoProps); if (staticProps) LinkedIn__defineProperties(Constructor, staticProps); return Constructor; }

function LinkedIn__possibleConstructorReturn(self, call) { if (call && (LinkedIn__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function LinkedIn__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */


var LinkedIn__ref = LinkedIn__jsx("svg", {
  height: "30px",
  width: "30px",
  version: "1.1",
  viewBox: "0 0 112.196 112.196",
  xmlSpace: "preserve"
}, void 0, LinkedIn__jsx("circle", {
  cx: "56.098",
  cy: "56.097",
  fill: " rgba(var(--ey-spotmentor), 1)",
  r: "56.098"
}), LinkedIn__jsx("path", {
  className: "active-path",
  d: "m89.616 60.611v23.128h-13.409v-21.578c0-5.418-1.936-9.118-6.791-9.118-3.705 0-5.906 2.491-6.878 4.903-0.353 0.862-0.444 2.059-0.444 3.268v22.524h-13.41s0.18-36.546 0-40.329h13.411v5.715c-0.027 0.045-0.065 0.089-0.089 0.132h0.089v-0.132c1.782-2.742 4.96-6.662 12.085-6.662 8.822 0 15.436 5.764 15.436 18.149zm-54.96-36.642c-4.587 0-7.588 3.011-7.588 6.967 0 3.872 2.914 6.97 7.412 6.97h0.087c4.677 0 7.585-3.098 7.585-6.97-0.089-3.956-2.908-6.967-7.496-6.967zm-6.791 59.77h13.405v-40.33h-13.405v40.33z",
  fill: "#181818"
}));

var LinkedIn =
/*#__PURE__*/
function (_React$Component) {
  LinkedIn__inherits(LinkedIn, _React$Component);

  function LinkedIn() {
    LinkedIn__classCallCheck(this, LinkedIn);

    return LinkedIn__possibleConstructorReturn(this, (LinkedIn.__proto__ || Object.getPrototypeOf(LinkedIn)).apply(this, arguments));
  }

  LinkedIn__createClass(LinkedIn, [{
    key: "render",
    value: function render() {
      return LinkedIn__ref;
    }
  }]);

  return LinkedIn;
}(react_default.a.Component);

/* harmony default export */ var icons_LinkedIn = (LinkedIn);
// CONCATENATED MODULE: ./src/components/Footer/icons/Envelope.js
var _jsx2;

function Envelope__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Envelope_REACT_ELEMENT_TYPE;

function Envelope__jsx(type, props, key, children) { if (!Envelope_REACT_ELEMENT_TYPE) { Envelope_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Envelope_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Envelope__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Envelope__typeof = function _typeof(obj) { return typeof obj; }; } else { Envelope__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Envelope__typeof(obj); }

function Envelope__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Envelope__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Envelope__createClass(Constructor, protoProps, staticProps) { if (protoProps) Envelope__defineProperties(Constructor.prototype, protoProps); if (staticProps) Envelope__defineProperties(Constructor, staticProps); return Constructor; }

function Envelope__possibleConstructorReturn(self, call) { if (call && (Envelope__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Envelope__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */


var Envelope__ref = Envelope__jsx("svg", (_jsx2 = {
  height: "512px",
  width: "512px",
  version: "1.1",
  viewBox: "0 0 299.997 299.997",
  xmlSpace: "preserve"
}, Envelope__defineProperty(_jsx2, "width", "30px"), Envelope__defineProperty(_jsx2, "height", "30px"), _jsx2), void 0, Envelope__jsx("path", {
  className: "active-path",
  d: "m150 0c-82.839 0-150 67.158-150 150 0 82.837 67.156 150 150 150s150-67.163 150-150c0-82.839-67.161-150-150-150zm3e-3 52.686l88.763 55.35h-177.53l88.763-55.35zm89.869 143.74h-9e-3c0 8.878-7.195 16.072-16.072 16.072h-147.58c-8.878 0-16.072-7.195-16.072-16.072v-84.865c0-0.939 0.096-1.852 0.252-2.749l84.808 52.883c0.104 0.065 0.215 0.109 0.322 0.169 0.112 0.062 0.226 0.122 0.34 0.179 0.599 0.309 1.216 0.558 1.847 0.721 0.065 0.018 0.13 0.026 0.195 0.041 0.692 0.163 1.393 0.265 2.093 0.265h5e-3 0.01c0.7 0 1.401-0.099 2.093-0.265 0.065-0.016 0.13-0.023 0.195-0.041 0.63-0.163 1.245-0.412 1.847-0.721 0.114-0.057 0.228-0.117 0.34-0.179 0.106-0.06 0.218-0.104 0.322-0.169l84.808-52.883c0.156 0.897 0.252 1.808 0.252 2.749v84.865z",
  fill: " rgba(var(--ey-spotmentor), 1)"
}));

var Twitter =
/*#__PURE__*/
function (_React$Component) {
  Envelope__inherits(Twitter, _React$Component);

  function Twitter() {
    Envelope__classCallCheck(this, Twitter);

    return Envelope__possibleConstructorReturn(this, (Twitter.__proto__ || Object.getPrototypeOf(Twitter)).apply(this, arguments));
  }

  Envelope__createClass(Twitter, [{
    key: "render",
    value: function render() {
      return Envelope__ref;
    }
  }]);

  return Twitter;
}(react_default.a.Component);

/* harmony default export */ var Envelope = (Twitter);
// CONCATENATED MODULE: ./src/components/Footer/icons/Phone.js
var Phone__jsx2;

function Phone__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Phone_REACT_ELEMENT_TYPE;

function Phone__jsx(type, props, key, children) { if (!Phone_REACT_ELEMENT_TYPE) { Phone_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Phone_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Phone__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Phone__typeof = function _typeof(obj) { return typeof obj; }; } else { Phone__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Phone__typeof(obj); }

function Phone__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Phone__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Phone__createClass(Constructor, protoProps, staticProps) { if (protoProps) Phone__defineProperties(Constructor.prototype, protoProps); if (staticProps) Phone__defineProperties(Constructor, staticProps); return Constructor; }

function Phone__possibleConstructorReturn(self, call) { if (call && (Phone__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Phone__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */


var Phone__ref = Phone__jsx("svg", (Phone__jsx2 = {
  height: "512px",
  width: "512px",
  version: "1.1",
  viewBox: "0 0 485.213 485.212",
  xmlSpace: "preserve"
}, Phone__defineProperty(Phone__jsx2, "width", "30px"), Phone__defineProperty(Phone__jsx2, "height", "30px"), Phone__jsx2), void 0, Phone__jsx("path", {
  className: "active-path",
  d: "m242.61 0c-133.98 0-242.61 108.63-242.61 242.61 0 133.98 108.63 242.61 242.61 242.61s242.6-108.63 242.6-242.61c1e-3 -133.98-108.63-242.61-242.6-242.61zm128.11 353.99l-19.425 19.429c-3.468 3.463-13.623 5.624-13.949 5.624-61.452 0.536-120.62-23.602-164.1-67.08-43.593-43.618-67.759-103-67.11-164.66 0-0.028 2.224-9.892 5.689-13.324l19.424-19.427c7.108-7.141 20.762-10.368 30.327-7.168l4.086 1.363c9.537 3.197 19.55 13.742 22.185 23.457l9.771 35.862c2.635 9.743-0.919 23.604-8.025 30.712l-12.97 12.972c12.734 47.142 49.723 84.138 96.873 96.903l12.965-12.975c7.141-7.141 20.997-10.692 30.719-8.061l35.857 9.806c9.717 2.67 20.26 12.62 23.456 22.154l1.363 4.145c3.168 9.538-0.034 23.189-7.141 30.265z",
  fill: " rgba(var(--ey-spotmentor), 1)"
}));

var Phone =
/*#__PURE__*/
function (_React$Component) {
  Phone__inherits(Phone, _React$Component);

  function Phone() {
    Phone__classCallCheck(this, Phone);

    return Phone__possibleConstructorReturn(this, (Phone.__proto__ || Object.getPrototypeOf(Phone)).apply(this, arguments));
  }

  Phone__createClass(Phone, [{
    key: "render",
    value: function render() {
      return Phone__ref;
    }
  }]);

  return Phone;
}(react_default.a.Component);

/* harmony default export */ var icons_Phone = (Phone);
// EXTERNAL MODULE: ./src/components/Footer/Footer.css
var Footer_Footer = __webpack_require__(578);
var Footer_default = /*#__PURE__*/__webpack_require__.n(Footer_Footer);

// CONCATENATED MODULE: ./src/components/Footer/Footer.js
function Footer__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Footer__typeof = function _typeof(obj) { return typeof obj; }; } else { Footer__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Footer__typeof(obj); }

var Footer_REACT_ELEMENT_TYPE;

function Footer__jsx(type, props, key, children) { if (!Footer_REACT_ELEMENT_TYPE) { Footer_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Footer_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Footer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Footer__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Footer__createClass(Constructor, protoProps, staticProps) { if (protoProps) Footer__defineProperties(Constructor.prototype, protoProps); if (staticProps) Footer__defineProperties(Constructor, staticProps); return Constructor; }

function Footer__possibleConstructorReturn(self, call) { if (call && (Footer__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Footer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Footer__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }















var Footer__ref2 = Footer__jsx("img", {
  src: logowhite_default.a,
  alt: "logo"
});

var Footer__ref3 = Footer__jsx("i", {
  className: "fa fa-map-marker"
});

var Footer__ref4 = Footer__jsx("i", {
  className: "fa fa-envelope",
  "aria-hidden": "true"
});

var _ref5 = Footer__jsx("i", {
  className: "fa fa-phone"
});

var _ref6 = Footer__jsx("svg", {
  className: "icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "100",
  height: "100",
  viewBox: "0 0 65 26"
}, void 0, Footer__jsx("g", {
  fill: "#5C7285",
  fillRule: "evenodd"
}, void 0, Footer__jsx("path", {
  fillRule: "nonzero",
  d: "M19.977 6.819l-.001-.02c-.01-.24-.017-.493-.021-.775-.02-1.376-1.049-2.514-2.344-2.59-2.7-.16-4.79-1.096-6.574-2.945l-.015-.015a1.439 1.439 0 0 0-2.043 0l-.015.015C7.179 2.338 5.09 3.273 2.389 3.433 1.094 3.51.065 4.648.046 6.024c-.004.28-.011.534-.021.775l-.002.045c-.052 2.926-.117 6.566 1.03 9.87.63 1.818 1.584 3.398 2.837 4.696 1.426 1.479 3.294 2.653 5.552 3.49A1.638 1.638 0 0 0 10 25a1.591 1.591 0 0 0 .56-.101c2.254-.838 4.12-2.013 5.546-3.491 1.252-1.299 2.206-2.879 2.837-4.697 1.15-3.314 1.086-6.962 1.034-9.892zm-2.327 9.386c-1.209 3.483-3.677 5.875-7.546 7.312a.292.292 0 0 1-.208 0c-3.872-1.435-6.342-3.825-7.55-7.308-1.057-3.046-.997-6.388-.945-9.337v-.016c.012-.253.019-.519.023-.81.008-.611.466-1.117 1.042-1.15 1.528-.091 2.87-.405 4.104-.96 1.232-.554 2.326-1.335 3.345-2.387a.122.122 0 0 1 .17 0c1.02 1.052 2.113 1.833 3.345 2.387 1.233.555 2.576.869 4.104.96.576.033 1.034.539 1.043 1.15.004.293.011.558.022.81.052 2.952.11 6.296-.949 9.349z"
}), Footer__jsx("path", {
  fillRule: "nonzero",
  d: "M10 6.307c-3.228 0-5.853 2.79-5.853 6.218 0 3.429 2.625 6.218 5.853 6.218 3.227 0 5.853-2.79 5.853-6.218 0-3.429-2.626-6.218-5.853-6.218zm0 10.972c-2.468 0-4.475-2.133-4.475-4.754C5.525 9.903 7.532 7.77 10 7.77c2.467 0 4.475 2.132 4.475 4.754 0 2.621-2.008 4.754-4.475 4.754z"
}), Footer__jsx("path", {
  d: "M11.682 10.594l-2.719 2.888-.737-.783a.66.66 0 0 0-.975 0 .765.765 0 0 0 0 1.035l1.225 1.301c.135.143.311.215.487.215a.667.667 0 0 0 .488-.215l3.206-3.406a.765.765 0 0 0 0-1.035.66.66 0 0 0-.975 0z"
}), Footer__jsx("text", {
  fontFamily: "GoogleSans-Bold, Google Sans",
  fontSize: "14",
  fontWeight: "bold",
  transform: "translate(0 -1)"
}, void 0, Footer__jsx("tspan", {
  x: "24",
  y: "14"
}, void 0, "GDPR")), Footer__jsx("text", {
  fontFamily: "GoogleSans-Regular, Google Sans",
  fontSize: "10",
  letterSpacing: "2.9",
  transform: "translate(0 -1)"
}, void 0, Footer__jsx("tspan", {
  x: "25",
  y: "24"
}, void 0, "Ready"))));

var _ref7 = Footer__jsx(icons_UpArrows, {});

var _ref8 = Footer__jsx("a", {
  href: "http://www.spotmentor.com"
}, void 0, "spotmentor.com");

var _ref9 = Footer__jsx("a", {
  href: "mailto: shekhar.suman1@in.ey.com"
}, void 0, Footer__jsx(Envelope, {}));

var _ref10 = Footer__jsx("a", {
  href: "phone: +917738257059"
}, void 0, Footer__jsx(icons_Phone, {}));

var _ref11 = Footer__jsx("a", {
  href: "https://www.linkedin.com/company/spotmentor-education-technologies/",
  target: "_blank"
}, void 0, Footer__jsx(icons_LinkedIn, {}));

var Footer_Footer_Footer =
/*#__PURE__*/
function (_React$Component) {
  Footer__inherits(Footer, _React$Component);

  function Footer() {
    var _ref;

    var _temp, _this;

    Footer__classCallCheck(this, Footer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return Footer__possibleConstructorReturn(_this, (_temp = _this = Footer__possibleConstructorReturn(this, (_ref = Footer.__proto__ || Object.getPrototypeOf(Footer)).call.apply(_ref, [this].concat(args))), Object.defineProperty(Footer__assertThisInitialized(_this), "scrollToNews", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        if (window.location.pathname === '/') {
          smoothScroll.scrollTo('newsHere');
        } else {
          src_history["a" /* default */].push("/#newsHere");
        }
      }
    }), Object.defineProperty(Footer__assertThisInitialized(_this), "scrollTop", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        modules["animateScroll"].scrollToTop(); // smoothScroll.scrollTo('top');
      }
    }), _temp));
  }

  Footer__createClass(Footer, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          contactFields = _props.contactFields,
          changeFields = _props.changeFields,
          submitContactUs = _props.submitContactUs,
          isSendingMsg = _props.isSendingMsg;
      return Footer__jsx("div", {
        id: "footer"
      }, void 0, Footer__jsx("footer", {
        className: classnames_default()(Footer_default.a.row, Footer_default.a.footerArea, Footer_default.a.footerAreaTwo, Footer_default.a.footerAreaFour)
      }, void 0, Footer__jsx("div", {
        className: Footer_default.a.footerTop
      }, void 0, Footer__jsx(reactstrap_es["b" /* Container */], {}, void 0, Footer__jsx(reactstrap_es["d" /* Row */], {}, void 0, Footer__jsx(reactstrap_es["a" /* Col */], {
        md: "4",
        xs: "12",
        className: classnames_default()(Footer_default.a.widget, Footer_default.a.singleFtWidget)
      }, void 0, Footer__jsx("a", {
        href: "http://www.spotmentor.com",
        className: Footer_default.a.brandLogo
      }, void 0, Footer__ref2), Footer__jsx("ul", {}, void 0, Footer__jsx("li", {}, void 0, Footer__ref3, Footer__jsx("div", {
        className: classnames_default()(Footer_default.a.locationAddress, Footer_default.a.fleft)
      }, void 0, "GVT, Sector 43, Gurgaon")), Footer__jsx("li", {}, void 0, Footer__ref4, Footer__jsx("div", {
        className: classnames_default()(Footer_default.a.locationAddress, Footer_default.a.fleft)
      }, void 0, "shekhar.suman@in.ey.com")), Footer__jsx("li", {}, void 0, _ref5, Footer__jsx("div", {
        className: classnames_default()(Footer_default.a.locationAddress, Footer_default.a.fleft)
      }, void 0, "+91 7738257059"))), _ref6), Footer__jsx(reactstrap_es["a" /* Col */], {
        md: "4",
        xs: "12",
        className: classnames_default()(Footer_default.a.widget, Footer_default.a.latestWidget)
      }), Footer__jsx(reactstrap_es["a" /* Col */], {
        md: "4",
        xs: "12",
        className: classnames_default()(Footer_default.a.widget, Footer_default.a.contactFromWidget)
      }, void 0, Footer__jsx("h4", {
        className: Footer_default.a.widgetTitle
      }, void 0, "contact us"), Footer__jsx("div", {
        className: classnames_default()(Footer_default.a.widgetContactList, Footer_default.a.m0)
      }, void 0, Footer__jsx(reactstrap_es["c" /* Form */], {
        className: classnames_default()(Footer_default.a.submitForm, Footer_default.a.m0)
      }, void 0, Footer__jsx("input", {
        type: "text",
        className: Footer_default.a.formControl,
        id: "contactusname",
        onChange: function onChange(e) {
          return changeFields('name', e.target.value);
        },
        placeholder: "Your Name",
        value: contactFields.name
      }), Footer__jsx("input", {
        type: "email",
        className: Footer_default.a.formControl,
        id: "contactusemail",
        onChange: function onChange(e) {
          return changeFields('email', e.target.value);
        },
        placeholder: "Your Email",
        value: contactFields.email
      }), Footer__jsx("input", {
        type: "text",
        className: Footer_default.a.formControl,
        id: "contactusnumber",
        onChange: function onChange(e) {
          return changeFields('number', e.target.value);
        },
        placeholder: "Your Phone Number",
        value: contactFields.number,
        name: "number"
      }), Footer__jsx("textarea", {
        className: classnames_default()(Footer_default.a.formControl, Footer_default.a.message),
        id: "contactusmessage",
        onChange: function onChange(e) {
          return changeFields('message', e.target.value);
        },
        placeholder: "Your Message",
        value: contactFields.message
      }), Footer__jsx("button", {
        className: classnames_default()(Footer_default.a.submit, Footer_default.a.btnH),
        type: "submit",
        onClick: submitContactUs
      }, void 0, isSendingMsg ? 'Sending..' : 'Send'))))))), Footer__jsx("div", {
        className: classnames_default()(Footer_default.a.m0, Footer_default.a.footerBottom)
      }, void 0, Footer__jsx(reactstrap_es["b" /* Container */], {}, void 0, Footer__jsx("div", {
        className: Footer_default.a.scrollT,
        onClick: this.scrollTop
      }, void 0, _ref7), Footer__jsx(reactstrap_es["d" /* Row */], {}, void 0, Footer__jsx(reactstrap_es["a" /* Col */], {
        md: "10",
        style: {
          display: 'flex',
          justifyContent: 'space-between'
        }
      }, void 0, Footer__jsx("a", {
        href: "/legal/cookie-policy",
        className: Footer_default.a.link
      }, void 0, "Cookie policy"), Footer__jsx("a", {
        href: "/legal/gdpr-policy",
        className: Footer_default.a.link
      }, void 0, "GDPR policy"), Footer__jsx("div", {}, void 0, "Copyright \xA9 2018 ", Footer__jsx("br", {
        className: Footer_default.a.visibleXs
      }), ' ', _ref8)), Footer__jsx(reactstrap_es["a" /* Col */], {
        md: "2",
        className: Footer_default.a.right
      }, void 0, Footer__jsx("div", {
        className: Footer_default.a.svgSocialIcons
      }, void 0, _ref9), Footer__jsx("div", {
        className: Footer_default.a.svgSocialIcons
      }, void 0, _ref10), Footer__jsx("div", {
        className: Footer_default.a.svgSocialIcons
      }, void 0, _ref11)))))));
    }
  }]);

  return Footer;
}(react_default.a.Component);

/* harmony default export */ var components_Footer_Footer = (withStyles_default()(Footer_default.a)(Footer_Footer_Footer));
// EXTERNAL MODULE: ./src/components/Placeholder/Placeholder.css
var Placeholder_Placeholder = __webpack_require__(580);
var Placeholder_default = /*#__PURE__*/__webpack_require__.n(Placeholder_Placeholder);

// CONCATENATED MODULE: ./src/components/Placeholder/Spotmentor.js
function Spotmentor__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Spotmentor__typeof = function _typeof(obj) { return typeof obj; }; } else { Spotmentor__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Spotmentor__typeof(obj); }

var Spotmentor_REACT_ELEMENT_TYPE;

function Spotmentor__jsx(type, props, key, children) { if (!Spotmentor_REACT_ELEMENT_TYPE) { Spotmentor_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Spotmentor_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Spotmentor__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Spotmentor__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Spotmentor__createClass(Constructor, protoProps, staticProps) { if (protoProps) Spotmentor__defineProperties(Constructor.prototype, protoProps); if (staticProps) Spotmentor__defineProperties(Constructor, staticProps); return Constructor; }

function Spotmentor__possibleConstructorReturn(self, call) { if (call && (Spotmentor__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Spotmentor__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Spotmentor__ref = Spotmentor__jsx("em", {}, void 0, "S");

var Spotmentor__ref2 = Spotmentor__jsx("em", {}, void 0, "P");

var Spotmentor__ref3 = Spotmentor__jsx("em", {}, void 0, "T");

var Spotmentor__ref4 = Spotmentor__jsx("em", {}, void 0, "M");

var Spotmentor__ref5 = Spotmentor__jsx("em", {}, void 0, "E");

var Spotmentor__ref6 = Spotmentor__jsx("em", {}, void 0, "N");

var Spotmentor__ref7 = Spotmentor__jsx("em", {}, void 0, "T");

var Spotmentor__ref8 = Spotmentor__jsx("em", {}, void 0, "R");

var Spotmentor =
/*#__PURE__*/
function (_React$Component) {
  Spotmentor__inherits(Spotmentor, _React$Component);

  function Spotmentor() {
    Spotmentor__classCallCheck(this, Spotmentor);

    return Spotmentor__possibleConstructorReturn(this, (Spotmentor.__proto__ || Object.getPrototypeOf(Spotmentor)).apply(this, arguments));
  }

  Spotmentor__createClass(Spotmentor, [{
    key: "render",
    value: function render() {
      var s = this.props.styles;
      return Spotmentor__jsx("div", {
        className: s.spotmentor
      }, void 0, Spotmentor__jsx("h1", {}, void 0, Spotmentor__ref, Spotmentor__ref2, Spotmentor__jsx("em", {
        className: s.planetLeft
      }, void 0, "O"), Spotmentor__ref3, Spotmentor__ref4, Spotmentor__ref5, Spotmentor__ref6, Spotmentor__ref7, Spotmentor__jsx("em", {
        className: s.planetRight
      }, void 0, "O"), Spotmentor__ref8));
    }
  }]);

  return Spotmentor;
}(react_default.a.Component);

/* harmony default export */ var Placeholder_Spotmentor = (Spotmentor);
// CONCATENATED MODULE: ./src/components/Placeholder/Placeholder.js
function Placeholder__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Placeholder__typeof = function _typeof(obj) { return typeof obj; }; } else { Placeholder__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Placeholder__typeof(obj); }

var Placeholder_REACT_ELEMENT_TYPE;

function Placeholder__jsx(type, props, key, children) { if (!Placeholder_REACT_ELEMENT_TYPE) { Placeholder_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Placeholder_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Placeholder__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Placeholder__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Placeholder__createClass(Constructor, protoProps, staticProps) { if (protoProps) Placeholder__defineProperties(Constructor.prototype, protoProps); if (staticProps) Placeholder__defineProperties(Constructor, staticProps); return Constructor; }

function Placeholder__possibleConstructorReturn(self, call) { if (call && (Placeholder__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Placeholder__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Placeholder__ref = Placeholder__jsx(Placeholder_Spotmentor, {
  styles: Placeholder_default.a
});

var Placeholder_Placeholder_Placeholder =
/*#__PURE__*/
function (_React$Component) {
  Placeholder__inherits(Placeholder, _React$Component);

  function Placeholder() {
    Placeholder__classCallCheck(this, Placeholder);

    return Placeholder__possibleConstructorReturn(this, (Placeholder.__proto__ || Object.getPrototypeOf(Placeholder)).apply(this, arguments));
  }

  Placeholder__createClass(Placeholder, [{
    key: "render",
    value: function render() {
      var text = this.props.text;
      return Placeholder__jsx("div", {
        className: Placeholder_default.a.container
      }, void 0, Placeholder__ref, Placeholder__jsx("h1", {}, void 0, text));
    }
  }]);

  return Placeholder;
}(react_default.a.Component);

Object.defineProperty(Placeholder_Placeholder_Placeholder, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    text: 'LOADING...'
  }
});
/* harmony default export */ var components_Placeholder_Placeholder = (withStyles_default()(Placeholder_default.a)(Placeholder_Placeholder_Placeholder));
// CONCATENATED MODULE: ./src/components/Layout/CookiePrompt.js
function CookiePrompt__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { CookiePrompt__typeof = function _typeof(obj) { return typeof obj; }; } else { CookiePrompt__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return CookiePrompt__typeof(obj); }

function CookiePrompt__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CookiePrompt__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function CookiePrompt__createClass(Constructor, protoProps, staticProps) { if (protoProps) CookiePrompt__defineProperties(Constructor.prototype, protoProps); if (staticProps) CookiePrompt__defineProperties(Constructor, staticProps); return Constructor; }

function CookiePrompt__possibleConstructorReturn(self, call) { if (call && (CookiePrompt__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function CookiePrompt__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function CookiePrompt__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var CookiePrompt_REACT_ELEMENT_TYPE;

function CookiePrompt__jsx(type, props, key, children) { if (!CookiePrompt_REACT_ELEMENT_TYPE) { CookiePrompt_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: CookiePrompt_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }





var CookiePrompt__ref = CookiePrompt__jsx("p", {}, void 0, "This website uses cookies to improve user experience. By continuing to browse this website, you declare to accept the use of cookies. For more information visit our", ' ', CookiePrompt__jsx("a", {
  href: "/legal/cookie-policy",
  target: "_blank"
}, void 0, "Privacy Policy"));

var Prompt = function Prompt(props) {
  var s = props.styles,
      bottom = props.bottom,
      isLoginPage = props.isLoginPage,
      onClose = props.onClose,
      onConsent = props.onConsent;
  return CookiePrompt__jsx("div", {
    className: s.cookiePrompt,
    style: {
      bottom: bottom,
      height: isLoginPage ? '120px' : 'auto'
    }
  }, void 0, !isLoginPage && CookiePrompt__jsx("span", {
    onClick: onClose,
    className: "mdi mdi-close"
  }), CookiePrompt__ref, isLoginPage && CookiePrompt__jsx("button", {
    onClick: onConsent
  }, void 0, " Accept all cookies "));
};

var CookiePrompt_CookiePrompt =
/*#__PURE__*/
function (_React$Component) {
  CookiePrompt__inherits(CookiePrompt, _React$Component);

  function CookiePrompt(props) {
    var _this;

    CookiePrompt__classCallCheck(this, CookiePrompt);

    _this = CookiePrompt__possibleConstructorReturn(this, (CookiePrompt.__proto__ || Object.getPrototypeOf(CookiePrompt)).call(this));
    Object.defineProperty(CookiePrompt__assertThisInitialized(_this), "animateHideCookie", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          bottom: '-40vh'
        }, function () {
          setTimeout(function () {
            _this.hideCookie();
          }, 300);
        });
      }
    });
    Object.defineProperty(CookiePrompt__assertThisInitialized(_this), "saveConsent", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        Object(cookie["f" /* saveCookieConsent */])(true);

        _this.setState({
          showCookiePrompt: false
        });

        _this.props.saveConsent();
      }
    });
    Object.defineProperty(CookiePrompt__assertThisInitialized(_this), "hideCookie", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          showCookiePrompt: false
        });
      }
    });
    _this.state = {
      isLoginPage: props.isLoginPage,
      bottom: '-40vh',
      showCookiePrompt: true
    };
    return _this;
  }

  CookiePrompt__createClass(CookiePrompt, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var time = this.state.isLoginPage ? 0 : 5000;
      setTimeout(function () {
        _this2.setState({
          bottom: '0'
        });
      }, time);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isLoginPage) {
        this.setState({
          isLoginPage: nextProps.isLoginPage,
          showCookiePrompt: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var s = this.props.styles;
      var _state = this.state,
          bottom = _state.bottom,
          isLoginPage = _state.isLoginPage,
          showCookiePrompt = _state.showCookiePrompt;

      if (!showCookiePrompt) {
        return null;
      }

      return CookiePrompt__jsx("div", {
        className: s.cookiePromptContainer,
        style: {
          height: isLoginPage ? '100vh' : 'auto' // padding: '10px',

        }
      }, void 0, isLoginPage && CookiePrompt__jsx("div", {
        className: s.cookieOverlay
      }), CookiePrompt__jsx(Prompt, {
        styles: s,
        bottom: bottom,
        onClose: this.hideCookie,
        onConsent: this.saveConsent,
        isLoginPage: isLoginPage
      }));
    }
  }]);

  return CookiePrompt;
}(react_default.a.Component);

Object.defineProperty(CookiePrompt_CookiePrompt, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    isLoginPage: false
  }
});
/* harmony default export */ var Layout_CookiePrompt = (CookiePrompt_CookiePrompt);
// EXTERNAL MODULE: ./src/components/SnackBar/SnackBar.css
var SnackBar_SnackBar = __webpack_require__(582);
var SnackBar_default = /*#__PURE__*/__webpack_require__.n(SnackBar_SnackBar);

// CONCATENATED MODULE: ./src/components/SnackBar/SnackBar.js
function SnackBar__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { SnackBar__typeof = function _typeof(obj) { return typeof obj; }; } else { SnackBar__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return SnackBar__typeof(obj); }

var SnackBar_REACT_ELEMENT_TYPE;

function SnackBar__jsx(type, props, key, children) { if (!SnackBar_REACT_ELEMENT_TYPE) { SnackBar_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: SnackBar_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function SnackBar__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SnackBar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SnackBar__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SnackBar__createClass(Constructor, protoProps, staticProps) { if (protoProps) SnackBar__defineProperties(Constructor.prototype, protoProps); if (staticProps) SnackBar__defineProperties(Constructor, staticProps); return Constructor; }

function SnackBar__possibleConstructorReturn(self, call) { if (call && (SnackBar__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function SnackBar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function SnackBar__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }





 // const getIcon = type => {
//   switch (type && type.toLowerCase()) {
//     case 'success':
//       return {
//         icon: 'mdi mdi-check-circle-outline',
//         color: 'var(--accent-success)',
//         textColor: 'var(--bg-panel)',
//       };
//     case 'warning':
//       return {
//         icon: 'mdi mdi-alert-outline',
//         color: 'var(--accent-warning)',
//         textColor: 'var(--text-bold)',
//       };
//     case 'danger':
//       return {
//         icon: 'mdi mdi-close-circle-outline',
//         color: 'var(--accent-danger)',
//         textColor: 'var(--bg-panel)',
//       };
//     default:
//       return {
//         icon: 'mdi mdi-information-outline',
//         color: 'var(--new-primary)',
//         textColor: 'var(--bg-panel)',
//       };
//   }
// };

var getIcon = function getIcon(type) {
  switch (type && type.toLowerCase()) {
    case 'success':
      return {
        icon: 'mdi mdi-check-circle-outline',
        color: '0, 209, 178',
        textColor: '255, 255, 255'
      };

    case 'warning':
      return {
        icon: 'mdi mdi-alert-outline',
        color: '255, 246, 161',
        textColor: 'var(--text-bold)'
      };

    case 'danger':
      return {
        icon: 'mdi mdi-close-circle-outline',
        color: '255, 56, 96',
        textColor: '255, 255, 255'
      };

    default:
      return {
        icon: 'mdi mdi-information-outline',
        color: '78, 77, 174',
        textColor: '255, 255, 255'
      };
  }
};

var SnackBar_SnackBar_SnackBar =
/*#__PURE__*/
function (_React$Component) {
  SnackBar__inherits(SnackBar, _React$Component);

  function SnackBar(props) {
    var _this;

    SnackBar__classCallCheck(this, SnackBar);

    _this = SnackBar__possibleConstructorReturn(this, (SnackBar.__proto__ || Object.getPrototypeOf(SnackBar)).call(this, props));
    Object.defineProperty(SnackBar__assertThisInitialized(_this), "show", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(message) {
        if (!message || message === '') {
          return;
        }

        _this.setState({
          enter: true,
          exit: false
        });
      }
    });
    Object.defineProperty(SnackBar__assertThisInitialized(_this), "hide", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(message) {
        if (!message || message === '') {
          _this.setState({
            enter: false,
            exit: false
          }, _this.props.onEnd);

          return;
        }

        var endAnimation = function endAnimation() {
          return _this.setState({
            enter: false,
            exit: false
          }, _this.props.onEnd);
        };

        var onExit = function onExit() {
          return setTimeout(endAnimation, 500);
        };

        _this.setState({
          enter: false,
          exit: true
        }, onExit);
      }
    });
    Object.defineProperty(SnackBar__assertThisInitialized(_this), "showOnce", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(message) {
        if (!message || message === '') {
          return;
        }

        var endAnimation = function endAnimation() {
          return _this.setState({
            enter: false,
            exit: false
          }, _this.props.onEnd);
        };

        var onExit = function onExit() {
          return setTimeout(endAnimation, 500);
        };

        var startExit = function startExit() {
          return _this.setState({
            enter: false,
            exit: true
          }, onExit);
        };

        var onEnter = function onEnter() {
          return setTimeout(startExit, 3000);
        };

        _this.setState({
          enter: true,
          exit: false
        }, onEnter);
      }
    });
    _this.state = {
      enter: false,
      exit: false
    };
    return _this;
  }

  SnackBar__createClass(SnackBar, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (!this.props.show && newProps.show) {
        this.show(newProps.message);
        return;
      }

      if (this.props.show && !newProps.show) {
        this.hide(newProps.message);
        return;
      }

      if (!this.props.showOnce && newProps.showOnce) {
        this.showOnce(newProps.message);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _cx;

      var _props = this.props,
          message = _props.message,
          type = _props.type;
      var _state = this.state,
          enter = _state.enter,
          exit = _state.exit;
      return SnackBar__jsx("div", {
        className: SnackBar_default.a.root,
        style: {
          width: !enter && !exit ? 0 : 'auto',
          height: !enter && !exit ? 0 : 'auto'
        }
      }, void 0, SnackBar__jsx("div", {
        className: classnames_default()(SnackBar_default.a.snackbar, (_cx = {}, SnackBar__defineProperty(_cx, SnackBar_default.a.fadeIn, enter), SnackBar__defineProperty(_cx, SnackBar_default.a.fadeOut, exit), _cx))
      }, void 0, SnackBar__jsx("div", {
        className: SnackBar_default.a.message,
        style: {
          backgroundColor: "rgb(".concat(getIcon(type).color, ")"),
          color: "rgb(".concat(getIcon(type).textColor, ")")
        }
      }, void 0, SnackBar__jsx("p", {}, void 0, message || 'akjshdkjashdkjahsd kjahsdkjad jakshd aksd')), SnackBar__jsx("div", {
        className: SnackBar_default.a.icon
      }, void 0, SnackBar__jsx("span", {
        className: getIcon(type).icon,
        style: {
          color: "rgb(".concat(getIcon(type).color, ")")
        }
      }))));
    }
  }]);

  return SnackBar;
}(react_default.a.Component);

Object.defineProperty(SnackBar_SnackBar_SnackBar, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    show: false,
    showOnce: false,
    message: null,
    onEnd: function onEnd() {},
    type: ''
  }
});
/* harmony default export */ var components_SnackBar_SnackBar = (withStyles_default()(SnackBar_default.a)(SnackBar_SnackBar_SnackBar));
// EXTERNAL MODULE: ./src/reducers/layout.js + 1 modules
var layout = __webpack_require__(69);

// EXTERNAL MODULE: ./src/actions/sagAuth.js
var sagAuth = __webpack_require__(58);

// CONCATENATED MODULE: ./src/components/Layout/Layout.js
function Layout__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Layout__typeof = function _typeof(obj) { return typeof obj; }; } else { Layout__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Layout__typeof(obj); }

var Layout_REACT_ELEMENT_TYPE;

function Layout__jsx(type, props, key, children) { if (!Layout_REACT_ELEMENT_TYPE) { Layout_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Layout_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }

function Layout__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Layout__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Layout__createClass(Constructor, protoProps, staticProps) { if (protoProps) Layout__defineProperties(Constructor.prototype, protoProps); if (staticProps) Layout__defineProperties(Constructor, staticProps); return Constructor; }

function Layout__possibleConstructorReturn(self, call) { if (call && (Layout__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Layout__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Layout__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }























var Layout_Layout_Layout =
/*#__PURE__*/
function (_React$Component) {
  Layout__inherits(Layout, _React$Component);

  function Layout() {
    var _this;

    Layout__classCallCheck(this, Layout);

    _this = Layout__possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).call(this));
    Object.defineProperty(Layout__assertThisInitialized(_this), "saveConsent", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          isCookieConsentGiven: true
        });
      }
    });
    Object.defineProperty(Layout__assertThisInitialized(_this), "handleGoToPlatform", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function () {
        var _value = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee() {
          var user, currPath, isLogoutUrl, isTrackMailUrl, redirectUrl;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  user = _this.props.auth.user;
                  currPath = src_history["a" /* default */].location && src_history["a" /* default */].location.pathname;
                  isLogoutUrl = currPath === '/logout';
                  isTrackMailUrl = currPath === '/track-mail';

                  if (!(Object(lodash["isEmpty"])(user) || isLogoutUrl || isTrackMailUrl)) {
                    _context.next = 6;
                    break;
                  }

                  return _context.abrupt("return");

                case 6:
                  redirectUrl = Object(login["a" /* default */])({
                    organizationSubdomain: user.subdomain_url,
                    websiteHost: window.location.host
                  });
                  window.location.replace(redirectUrl);

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        return function value() {
          return _value.apply(this, arguments);
        };
      }()
    });
    _this.state = {
      isCookieConsentGiven: true
    };
    return _this;
  }

  Layout__createClass(Layout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.init();
      var isCookieConsentGiven = document.cookie.includes("cookie_consent=true"); // this.handleGoToPlatform();

      this.setState({
        isCookieConsentGiven: isCookieConsentGiven
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isLoginPage = _props.isLoginPage,
          alertMessage = _props.alertMessage,
          contactFields = _props.contactFields,
          isSendingMsg = _props.isSendingMsg,
          alertType = _props.alertType,
          setAlert = _props.setAlert,
          headerBackground = _props.headerBackground,
          showFooter = _props.showFooter,
          hideHeader = _props.hideHeader,
          changeFields = _props.changeFields,
          submitContactUs = _props.submitContactUs,
          underMaintenance = _props.underMaintenance,
          logoutUser = _props.logoutUser,
          _props$auth = _props.auth,
          token = _props$auth.token,
          refreshToken = _props$auth.refreshToken,
          user = _props$auth.user;
      var isCookieConsentGiven = this.state.isCookieConsentGiven;
      var isLoggedIn = !!refreshToken;
      var childrenWithProps = react_default.a.Children.map(children, function (child) {
        return react_default.a.cloneElement(child, {
          isLoggedIn: isLoggedIn,
          token: token,
          refreshToken: refreshToken,
          userName: user && user.name,
          userId: user && user.user_id,
          subdomain: user && user.subdomain_url
        });
      });
      var currPath = src_history["a" /* default */].location && src_history["a" /* default */].location.pathname;
      var isLogoutUrl = currPath === '/logout';
      var isTrackMailUrl = currPath === '/track-mail'; // if (!isEmpty(user) && currPath && !isLogoutUrl && !isTrackMailUrl) {
      //   return <Placeholder text="Redirecting..." />;
      // }

      return Layout__jsx("div", {}, void 0, !hideHeader && !underMaintenance && Layout__jsx(components_Header_Header, {
        isLoggedIn: isLoggedIn,
        user: user,
        logoutUser: logoutUser,
        isCookieConsentGiven: isCookieConsentGiven,
        headerBackground: headerBackground
      }), !isCookieConsentGiven && Layout__jsx(Layout_CookiePrompt, {
        styles: Layout_default.a,
        isLoginPage: isLoginPage,
        hideCookie: this.hideCookie,
        saveConsent: this.saveConsent
      }), childrenWithProps, Layout__jsx(components_SnackBar_SnackBar, {
        showOnce: !!alertMessage,
        message: alertMessage,
        type: alertType,
        onEnd: function onEnd() {
          return setAlert(null, null);
        }
      }), showFooter && !underMaintenance && Layout__jsx(components_Footer_Footer, {
        contactFields: contactFields,
        changeFields: changeFields,
        submitContactUs: submitContactUs,
        isSendingMsg: isSendingMsg
      }));
    }
  }]);

  return Layout;
}(react_default.a.Component);

Object.defineProperty(Layout_Layout_Layout, "contextTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    auth: prop_types_default.a.object.isRequired,
    user: prop_types_default.a.object.isRequired
  }
});
Object.defineProperty(Layout_Layout_Layout, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    showFooter: true
  }
});

var mapState = function mapState(state) {
  return {
    alertMessage: state.layout.alertMessage,
    alertType: state.layout.alertType,
    contactFields: state.layout.contactFields,
    isSendingMsg: state.layout.isSendingMsg,
    auth: state.routes.auth
  };
};

var mapDispatch = {
  init: layout["a" /* ACTIONS */].init,
  setAlert: layout["a" /* ACTIONS */].setAlert,
  submitContactUs: layout["a" /* ACTIONS */].submitContactUs,
  changeFields: layout["a" /* ACTIONS */].changeFields,
  logoutUser: sagAuth["e" /* logoutUser */]
};
/* harmony default export */ var components_Layout_Layout = __webpack_exports__["a"] = (Object(es["a" /* connect */])(mapState, mapDispatch)(withStyles_default()(bootstrap_min_default.a, normalize_default.a, font_awesome_min_default.a, Layout_default.a, slick_default.a, slick_theme_default.a)(Layout_Layout_Layout)));

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var _ref = _jsx("g", {
  id: "XMLID_3_"
}, void 0, _jsx("g", {
  id: "XMLID_10_"
}, void 0, _jsx("path", {
  id: "XMLID_11_",
  className: "st0",
  d: "M48.6,52.8c0,3-0.5,5.6-1.6,7.9c-1.1,2.3-2.6,4.3-4.5,5.9c-1.9,1.6-4.2,2.8-6.8,3.6 c-2.6,0.8-5.4,1.2-8.5,1.2c-2.1,0-4.1-0.2-5.9-0.5c-1.8-0.4-3.4-0.8-4.8-1.3c-1.4-0.5-2.6-1.1-3.6-1.6c-1-0.6-1.6-1-2-1.4 c-0.4-0.4-0.7-0.9-0.8-1.5c-0.2-0.6-0.3-1.4-0.3-2.4c0-0.7,0-1.3,0.1-1.8c0.1-0.5,0.2-0.9,0.3-1.1c0.1-0.3,0.3-0.5,0.5-0.6 c0.2-0.1,0.4-0.2,0.7-0.2c0.5,0,1.1,0.3,1.9,0.8c0.8,0.6,1.9,1.2,3.2,1.8c1.3,0.7,2.9,1.3,4.7,1.8c1.8,0.6,4,0.9,6.4,0.9 c1.8,0,3.5-0.2,5-0.7c1.5-0.5,2.8-1.2,3.9-2.1c1.1-0.9,1.9-2,2.5-3.3c0.6-1.3,0.9-2.8,0.9-4.4c0-1.8-0.4-3.3-1.2-4.6 c-0.8-1.3-1.9-2.4-3.2-3.3c-1.3-1-2.9-1.8-4.6-2.6c-1.7-0.8-3.5-1.6-5.2-2.4c-1.8-0.8-3.5-1.7-5.2-2.8c-1.7-1-3.2-2.2-4.5-3.6 c-1.3-1.4-2.4-3-3.2-4.8c-0.8-1.8-1.2-4-1.2-6.6c0-2.6,0.5-5,1.4-7.1c1-2.1,2.3-3.8,4-5.2c1.7-1.4,3.7-2.5,6.1-3.2 c2.4-0.7,4.9-1.1,7.6-1.1c1.4,0,2.8,0.1,4.2,0.4c1.4,0.2,2.7,0.6,4,1c1.3,0.4,2.4,0.9,3.3,1.4c1,0.5,1.6,0.9,1.9,1.2 c0.3,0.3,0.5,0.6,0.6,0.7c0.1,0.2,0.2,0.4,0.2,0.7c0.1,0.3,0.1,0.6,0.1,1c0,0.4,0,0.9,0,1.5c0,0.6,0,1.1-0.1,1.6 c0,0.5-0.1,0.8-0.2,1.1c-0.1,0.3-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0.2-0.6,0.2c-0.4,0-0.9-0.2-1.7-0.7c-0.8-0.5-1.7-1-2.8-1.5 c-1.1-0.6-2.4-1.1-3.9-1.6c-1.5-0.5-3.2-0.7-5.1-0.7c-1.8,0-3.3,0.2-4.6,0.7c-1.3,0.5-2.4,1.1-3.2,1.9c-0.8,0.8-1.5,1.7-1.9,2.8 c-0.4,1.1-0.6,2.2-0.6,3.4c0,1.8,0.4,3.3,1.2,4.5c0.8,1.3,1.9,2.4,3.2,3.4c1.3,1,2.9,1.9,4.6,2.7c1.7,0.8,3.5,1.6,5.3,2.5 c1.8,0.8,3.5,1.7,5.3,2.7c1.7,1,3.3,2.2,4.6,3.5c1.3,1.4,2.4,2.9,3.3,4.8C48.2,48.1,48.6,50.3,48.6,52.8z"
}), _jsx("path", {
  id: "XMLID_13_",
  className: "st0",
  d: "M99.4,25.8c0,3.2-0.5,6-1.6,8.5c-1,2.5-2.5,4.7-4.5,6.5c-1.9,1.8-4.3,3.2-7.1,4.1 c-2.8,1-6.2,1.5-10.1,1.5H69v22.7c0,0.3-0.1,0.5-0.2,0.7c-0.1,0.2-0.4,0.3-0.7,0.5c-0.3,0.1-0.7,0.2-1.3,0.3 c-0.5,0.1-1.2,0.1-2,0.1c-0.8,0-1.5,0-2-0.1c-0.5-0.1-1-0.2-1.3-0.3c-0.3-0.1-0.6-0.3-0.7-0.5c-0.1-0.2-0.2-0.4-0.2-0.7V11 c0-1.3,0.3-2.2,1-2.8c0.7-0.6,1.4-0.8,2.3-0.8h13.5c1.4,0,2.7,0.1,3.9,0.2c1.3,0.1,2.7,0.4,4.4,0.7c1.7,0.4,3.4,1.1,5.2,2.1 c1.8,1,3.3,2.3,4.5,3.8c1.2,1.5,2.2,3.2,2.9,5.2C99.1,21.3,99.4,23.5,99.4,25.8z M90.6,26.5c0-2.6-0.5-4.7-1.4-6.4 c-1-1.7-2.1-3-3.6-3.9c-1.4-0.8-2.9-1.4-4.4-1.6c-1.5-0.2-3-0.3-4.4-0.3H69v25.3h7.6c2.5,0,4.6-0.3,6.3-1 c1.7-0.7,3.1-1.6,4.2-2.7c1.1-1.2,2-2.5,2.6-4.1C90.3,30.2,90.6,28.4,90.6,26.5z"
}), _jsx("path", {
  id: "XMLID_16_",
  className: "st0",
  d: "M165.2,38.2c0,5.1-0.6,9.7-1.8,13.8c-1.2,4.1-3,7.6-5.4,10.5c-2.4,2.9-5.4,5.1-9,6.6 c-3.6,1.5-7.8,2.3-12.6,2.3c-4.8,0-8.9-0.7-12.3-2.1c-3.5-1.4-6.3-3.5-8.6-6.2c-2.3-2.7-3.9-6.1-5.1-10.1 c-1.1-4-1.7-8.6-1.7-13.8c0-5,0.6-9.5,1.8-13.6c1.2-4.1,3-7.5,5.4-10.4c2.4-2.8,5.4-5,9-6.6c3.6-1.5,7.8-2.3,12.6-2.3 c4.7,0,8.7,0.7,12.2,2.1c3.4,1.4,6.3,3.4,8.6,6.1c2.3,2.7,4,6,5.1,10C164.6,28.6,165.2,33.1,165.2,38.2z M156.3,38.8 c0-3.6-0.3-6.9-1-10c-0.6-3.1-1.7-5.7-3.2-8c-1.5-2.3-3.5-4-5.9-5.3c-2.5-1.3-5.5-1.9-9.2-1.9c-3.6,0-6.7,0.7-9.2,2 c-2.5,1.4-4.5,3.2-6,5.5c-1.5,2.3-2.6,4.9-3.3,8c-0.7,3-1,6.2-1,9.6c0,3.7,0.3,7.1,0.9,10.3c0.6,3.1,1.7,5.8,3.1,8.1 c1.5,2.3,3.4,4,5.9,5.3c2.5,1.3,5.5,1.9,9.2,1.9c3.7,0,6.8-0.7,9.3-2.1c2.5-1.4,4.5-3.2,6-5.5c1.5-2.3,2.6-5,3.3-8.1 C156,45.4,156.3,42.2,156.3,38.8z"
}), _jsx("path", {
  id: "XMLID_20_",
  className: "st0",
  d: "M215.4,11c0,0.6,0,1.2-0.1,1.6c-0.1,0.5-0.2,0.8-0.3,1.1c-0.1,0.3-0.3,0.5-0.5,0.6 c-0.2,0.1-0.4,0.2-0.7,0.2h-17.8v54.8c0,0.3-0.1,0.5-0.2,0.7c-0.1,0.2-0.4,0.3-0.7,0.5c-0.3,0.1-0.8,0.2-1.3,0.3 c-0.5,0.1-1.2,0.1-2,0.1c-0.8,0-1.4,0-2-0.1c-0.6-0.1-1-0.2-1.3-0.3c-0.3-0.1-0.6-0.3-0.7-0.5c-0.1-0.2-0.2-0.4-0.2-0.7V14.5 h-17.8c-0.3,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.4-0.3-0.5-0.6c-0.1-0.3-0.2-0.6-0.3-1.1c-0.1-0.5-0.1-1-0.1-1.6c0-0.6,0-1.2,0.1-1.6 c0.1-0.5,0.2-0.9,0.3-1.1c0.1-0.3,0.3-0.5,0.5-0.6c0.2-0.1,0.4-0.2,0.7-0.2h43.9c0.3,0,0.5,0.1,0.7,0.2c0.2,0.1,0.4,0.3,0.5,0.6 c0.1,0.3,0.3,0.7,0.3,1.1C215.3,9.8,215.4,10.3,215.4,11z"
})), _jsx("g", {
  id: "XMLID_6_"
}, void 0, _jsx("g", {
  id: "XMLID_127_"
}, void 0, _jsx("path", {
  id: "XMLID_138_",
  className: "st0",
  d: "M359.9,67c0,0.6,0,1.1-0.1,1.5c-0.1,0.4-0.2,0.8-0.3,1.1c-0.2,0.3-0.3,0.5-0.6,0.6 c-0.2,0.1-0.4,0.2-0.7,0.2h-30.3c-0.7,0-1.5-0.3-2.1-0.8c-0.7-0.5-1-1.4-1-2.7V10.8c0-1.3,0.3-2.2,1-2.7 c0.7-0.5,1.4-0.8,2.1-0.8h30c0.3,0,0.5,0.1,0.7,0.2c0.2,0.1,0.4,0.3,0.5,0.6c0.1,0.3,0.2,0.7,0.3,1.1c0.1,0.4,0.1,1,0.1,1.6 c0,0.6,0,1.1-0.1,1.5c-0.1,0.4-0.2,0.8-0.3,1.1c-0.1,0.3-0.3,0.5-0.5,0.6c-0.2,0.1-0.4,0.2-0.7,0.2h-24.7v19.8h21.2 c0.3,0,0.5,0.1,0.7,0.2c0.2,0.1,0.4,0.3,0.5,0.6c0.1,0.3,0.3,0.6,0.3,1.1c0.1,0.5,0.1,1,0.1,1.6c0,0.6,0,1.1-0.1,1.5 c-0.1,0.4-0.2,0.8-0.3,1c-0.1,0.3-0.3,0.4-0.5,0.6c-0.2,0.1-0.4,0.2-0.7,0.2h-21.2v22.6h25c0.3,0,0.5,0.1,0.7,0.2 c0.2,0.1,0.4,0.3,0.6,0.6c0.2,0.3,0.3,0.6,0.3,1.1C359.9,65.8,359.9,66.4,359.9,67z"
}), _jsx("path", {
  id: "XMLID_136_",
  className: "st0",
  d: "M421.3,67c0,0.7-0.1,1.2-0.3,1.7c-0.2,0.5-0.5,0.8-0.9,1.1c-0.4,0.3-0.7,0.5-1.2,0.6 c-0.4,0.1-0.9,0.2-1.3,0.2h-2.8c-0.9,0-1.6-0.1-2.3-0.3c-0.7-0.2-1.3-0.5-1.9-1c-0.6-0.5-1.2-1.1-1.8-1.9 c-0.6-0.8-1.2-1.9-1.9-3.1l-19.3-35.9c-1-1.9-2-3.8-3-5.8c-1-2-2-4-2.9-5.9h-0.1c0.1,2.3,0.1,4.7,0.1,7.2c0,2.4,0,4.9,0,7.3 v38.1c0,0.2-0.1,0.4-0.2,0.7c-0.1,0.2-0.4,0.4-0.7,0.5c-0.3,0.1-0.8,0.2-1.3,0.3c-0.5,0.1-1.2,0.1-2,0.1c-0.8,0-1.5,0-2-0.1 c-0.5-0.1-1-0.2-1.3-0.3c-0.3-0.1-0.5-0.3-0.7-0.5c-0.1-0.2-0.2-0.4-0.2-0.7V11c0-1.3,0.4-2.2,1.1-2.8c0.7-0.6,1.5-0.8,2.4-0.8 h4.1c1,0,1.8,0.1,2.4,0.2c0.7,0.2,1.2,0.4,1.8,0.8c0.5,0.4,1,0.9,1.5,1.6c0.5,0.7,1,1.5,1.5,2.5l14.8,27.7 c0.9,1.7,1.8,3.3,2.6,5c0.8,1.6,1.7,3.2,2.5,4.8c0.8,1.6,1.6,3.1,2.3,4.6c0.8,1.5,1.5,3,2.3,4.6h0c-0.1-2.6-0.1-5.2-0.1-8 c0-2.8,0-5.5,0-8V8.8c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.4-0.4,0.7-0.5c0.3-0.1,0.8-0.3,1.3-0.3c0.5-0.1,1.2-0.1,2.1-0.1 c0.8,0,1.4,0,2,0.1c0.5,0.1,1,0.2,1.3,0.3c0.3,0.1,0.5,0.3,0.7,0.5c0.1,0.2,0.2,0.4,0.2,0.6V67z"
}), _jsx("path", {
  id: "XMLID_134_",
  className: "st0",
  d: "M477.7,11c0,0.6,0,1.2-0.1,1.6c-0.1,0.5-0.2,0.8-0.3,1.1c-0.1,0.3-0.3,0.5-0.5,0.6 c-0.2,0.1-0.4,0.2-0.7,0.2h-17.8v54.8c0,0.3-0.1,0.5-0.2,0.7c-0.1,0.2-0.4,0.3-0.7,0.5c-0.3,0.1-0.8,0.2-1.3,0.3 c-0.5,0.1-1.2,0.1-2,0.1c-0.8,0-1.4,0-2-0.1c-0.6-0.1-1-0.2-1.3-0.3c-0.3-0.1-0.6-0.3-0.7-0.5c-0.1-0.2-0.2-0.4-0.2-0.7V14.5 h-17.8c-0.3,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.4-0.3-0.5-0.6c-0.1-0.3-0.2-0.6-0.3-1.1c-0.1-0.5-0.1-1-0.1-1.6c0-0.6,0-1.2,0.1-1.6 c0.1-0.5,0.2-0.9,0.3-1.1c0.1-0.3,0.3-0.5,0.5-0.6c0.2-0.1,0.4-0.2,0.7-0.2H476c0.3,0,0.5,0.1,0.7,0.2c0.2,0.1,0.4,0.3,0.5,0.6 c0.1,0.3,0.3,0.7,0.3,1.1C477.7,9.8,477.7,10.3,477.7,11z"
}), _jsx("path", {
  id: "XMLID_131_",
  className: "st0",
  d: "M536.9,38.2c0,5.1-0.6,9.7-1.8,13.8c-1.2,4.1-3,7.6-5.4,10.5c-2.4,2.9-5.4,5.1-9,6.6 c-3.6,1.5-7.8,2.3-12.6,2.3c-4.8,0-8.9-0.7-12.3-2.1c-3.5-1.4-6.3-3.5-8.6-6.2c-2.3-2.7-3.9-6.1-5.1-10.1 c-1.1-4-1.7-8.6-1.7-13.8c0-5,0.6-9.5,1.8-13.6c1.2-4.1,3-7.5,5.4-10.4c2.4-2.8,5.4-5,9-6.6c3.6-1.5,7.8-2.3,12.6-2.3 c4.7,0,8.7,0.7,12.2,2.1c3.4,1.4,6.3,3.4,8.6,6.1c2.3,2.7,4,6,5.1,10C536.3,28.6,536.9,33.1,536.9,38.2z M528,38.8 c0-3.6-0.3-6.9-1-10c-0.6-3.1-1.7-5.7-3.2-8c-1.5-2.3-3.5-4-5.9-5.3c-2.5-1.3-5.5-1.9-9.2-1.9c-3.6,0-6.7,0.7-9.2,2 c-2.5,1.4-4.5,3.2-6,5.5c-1.5,2.3-2.6,4.9-3.3,8c-0.7,3-1,6.2-1,9.6c0,3.7,0.3,7.1,0.9,10.3c0.6,3.1,1.7,5.8,3.1,8.1 c1.5,2.3,3.4,4,5.9,5.3c2.5,1.3,5.5,1.9,9.2,1.9c3.7,0,6.8-0.7,9.3-2.1c2.5-1.4,4.5-3.2,6-5.5c1.5-2.3,2.6-5,3.3-8.1 C527.7,45.4,528,42.2,528,38.8z"
}), _jsx("path", {
  id: "XMLID_128_",
  className: "st0",
  d: "M592.3,69.2c0,0.3,0,0.5-0.1,0.7c-0.1,0.2-0.3,0.4-0.6,0.5c-0.3,0.1-0.8,0.2-1.4,0.3 c-0.6,0.1-1.4,0.1-2.3,0.1c-0.8,0-1.5,0-2.1-0.1c-0.5-0.1-1-0.2-1.3-0.3c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.3-0.3-0.6-0.5-1 l-5.8-14.9c-0.7-1.7-1.4-3.2-2.1-4.7c-0.7-1.4-1.6-2.6-2.6-3.7c-1-1-2.2-1.8-3.6-2.4c-1.4-0.6-3-0.9-4.9-0.9h-5.6v26.9 c0,0.3-0.1,0.5-0.2,0.7c-0.1,0.2-0.4,0.3-0.7,0.5c-0.3,0.1-0.7,0.2-1.3,0.3c-0.5,0.1-1.2,0.1-2,0.1c-0.8,0-1.5,0-2-0.1 c-0.5-0.1-1-0.2-1.3-0.3c-0.3-0.1-0.6-0.3-0.7-0.5c-0.1-0.2-0.2-0.4-0.2-0.7V10.8c0-1.3,0.3-2.2,1-2.7c0.7-0.5,1.4-0.8,2.1-0.8 h13.4c1.6,0,2.9,0,4,0.1c1.1,0.1,2,0.2,2.9,0.3c2.4,0.4,4.6,1.1,6.5,2c1.9,0.9,3.4,2.1,4.7,3.5c1.3,1.4,2.2,3,2.9,4.8 c0.6,1.8,1,3.8,1,6c0,2.1-0.3,4-0.9,5.7c-0.6,1.7-1.4,3.2-2.5,4.4c-1.1,1.3-2.4,2.4-3.9,3.3c-1.5,0.9-3.2,1.7-5,2.4 c1,0.5,2,1,2.8,1.7c0.8,0.7,1.6,1.5,2.4,2.5c0.7,1,1.4,2.1,2.1,3.4c0.7,1.3,1.3,2.7,2,4.3l5.7,13.9c0.5,1.2,0.7,2,0.9,2.5 C592.2,68.6,592.3,69,592.3,69.2z M579.7,24.9c0-2.5-0.6-4.6-1.7-6.3c-1.1-1.7-3-2.9-5.6-3.7c-0.8-0.2-1.7-0.4-2.8-0.5 c-1-0.1-2.4-0.1-4-0.1h-7.1v21.3h8.2c2.2,0,4.1-0.3,5.7-0.8c1.6-0.5,3-1.3,4-2.2c1.1-1,1.9-2.1,2.4-3.4 C579.4,27.8,579.7,26.4,579.7,24.9z"
}))), _jsx("line", {
  id: "XMLID_2_",
  className: "st1",
  x1: "269.2",
  y1: "90.4",
  x2: "3.6",
  y2: "90.4"
}), _jsx("g", {
  id: "XMLID_8_"
}, void 0, _jsx("polygon", {
  id: "XMLID_9_",
  className: "st2",
  points: "234.3,71 234.3,7.3 268,36.3 301.9,7 301.9,71         "
}), _jsx("g", {
  id: "XMLID_7_"
}, void 0, _jsx("path", {
  id: "XMLID_1_",
  className: "st0",
  d: "M269.2,88.2c-0.4,1.6-0.7,3.2-1.1,4.8c-12.2-6.4-24.4-12.7-36.6-19.1l2.6-4.1L269.2,88.2z"
}), _jsx("path", {
  id: "XMLID_4_",
  className: "st0",
  d: "M266.9,88.2c0.4,1.5,0.8,3.1,1.2,4.6c12.2-6.3,24.3-12.6,36.5-18.9l-2.6-4.1L266.9,88.2z"
}), _jsx("rect", {
  id: "XMLID_5_",
  x: "259.1",
  y: "84.1",
  className: "st0",
  width: "17.7",
  height: "3.5"
}))));

var LogoSvg =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LogoSvg, _React$Component);

  function LogoSvg() {
    _classCallCheck(this, LogoSvg);

    return _possibleConstructorReturn(this, (LogoSvg.__proto__ || Object.getPrototypeOf(LogoSvg)).apply(this, arguments));
  }

  _createClass(LogoSvg, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          brandColor = _props.brandColor,
          className = _props.className;
      return _jsx("svg", {
        className: className,
        viewBox: "0 0 600 100",
        style: {
          stroke: brandColor,
          fill: brandColor
        }
      }, void 0, _ref);
    }
  }]);

  return LogoSvg;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (LogoSvg);

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_cookie__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_helpers_tokenHelpers__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_sagAuth__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_login__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors_auth__ = __webpack_require__(236);
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }







var INIT = 'newPassword/INIT';
var SET_FIELDS = 'newPassword/SET_FIELDS';
var SET_ERROR = 'newPassword/SET_ERROR';
var SET_SUCCESS = 'newPassword/SET_SUCCESS';
var SET_SUBMITTING = 'newPassword/SET_SUBMITTING';
var SET_VALIDATION_TXT = 'newPassword/SET_VALIDATION_TXT';
var defaultState = {
  fields: {
    password: '',
    password2: ''
  },
  errorMessage: '',
  successMessage: '',
  submitting: false,
  validationTxt: {}
};

var setFields = function setFields(fields) {
  return {
    type: SET_FIELDS,
    fields: fields
  };
};

var setError = function setError(err) {
  return {
    type: SET_ERROR,
    err: err
  };
};

var setSuccess = function setSuccess(successMessage) {
  return {
    type: SET_SUCCESS,
    successMessage: successMessage
  };
};

var setSubmitting = function setSubmitting(bool) {
  return {
    type: SET_SUBMITTING,
    bool: bool
  };
};

var setValidationTxt = function setValidationTxt(txt) {
  return {
    type: SET_VALIDATION_TXT,
    txt: txt
  };
};

var setFieldsVal = function setFieldsVal(field, val) {
  return function (dispatch, getState) {
    var fields = getState().routes.newPassword.fields;
    var clonedFields = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(fields);
    clonedFields[field] = val;
    dispatch(setFields(clonedFields));
  };
}; // const redirectToSubdomain = () => (dispatch, getState) => {
//   console.log('++++++++++++++++++++++', getState())
//   const { auth: {user} } = getState().routes;
//
//
//   const redirectUrl = getPlatformUrl({
//     organizationSubdomain: user.subdomain_url,
//     websiteHost: window.location.host,
//   });
//
//   clearExtraAliasInfo();
//   window.location.replace(redirectUrl);
// };


var submitPassword = function submitPassword() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(dispatch, getState) {
        var _getState$routes$newP, fields, submitting, password, password2, errors, extraAliasInfo, parsedExtraAliasInfo, passwordRegex, validationTxt, correctPass, userToken, _ref2, error, errorCode;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _getState$routes$newP = getState().routes.newPassword, fields = _getState$routes$newP.fields, submitting = _getState$routes$newP.submitting;
                password = fields.password, password2 = fields.password2;
                errors = [];

                if (password) {
                  _context.next = 6;
                  break;
                }

                dispatch(setError('Password cannot be empty'));
                return _context.abrupt("return");

              case 6:
                if (password2) {
                  _context.next = 9;
                  break;
                }

                dispatch(setError('Confirm password cannot be empty'));
                return _context.abrupt("return");

              case 9:
                if (!(password && password2 && password !== password2)) {
                  _context.next = 12;
                  break;
                }

                dispatch(setError("Passwords don't match"));
                return _context.abrupt("return");

              case 12:
                if (!(password && !/^.{10,}$/i.test(password))) {
                  _context.next = 16;
                  break;
                }

                errors.push('Password must at least be 10 characters in length');
                dispatch(setError(errors.join('/r/n')));
                return _context.abrupt("return");

              case 16:
                if (!(password && !/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password))) {
                  _context.next = 20;
                  break;
                }

                errors.push('Password must contain at least one special case character');
                dispatch(setError(errors.join('/r/n')));
                return _context.abrupt("return");

              case 20:
                if (!(password && !/[A-Z]/.test(password))) {
                  _context.next = 24;
                  break;
                }

                errors.push('Password must contain at least one upper case letter');
                dispatch(setError(errors.join('/r/n')));
                return _context.abrupt("return");

              case 24:
                if (!(password && !/[a-z]/.test(password))) {
                  _context.next = 28;
                  break;
                }

                errors.push('Password must contain at least one lower case letter');
                dispatch(setError(errors.join('/r/n')));
                return _context.abrupt("return");

              case 28:
                if (!(password && !/[0-9]/.test(password))) {
                  _context.next = 32;
                  break;
                }

                errors.push('Password must contain at least one digit');
                dispatch(setError(errors.join('/r/n')));
                return _context.abrupt("return");

              case 32:
                extraAliasInfo = Object(__WEBPACK_IMPORTED_MODULE_1__utils_cookie__["d" /* getCookieValue */])('extra_alias_info');

                if (!extraAliasInfo) {
                  _context.next = 40;
                  break;
                }

                parsedExtraAliasInfo = JSON.parse(extraAliasInfo);
                passwordRegex = parsedExtraAliasInfo.passwordRegex, validationTxt = parsedExtraAliasInfo.validationTxt;
                correctPass = RegExp(passwordRegex).test(password);

                if (correctPass) {
                  _context.next = 40;
                  break;
                }

                dispatch(setValidationTxt(validationTxt));
                return _context.abrupt("return");

              case 40:
                if (!submitting) {
                  _context.next = 42;
                  break;
                }

                return _context.abrupt("return");

              case 42:
                dispatch(setSubmitting(true));
                _context.prev = 43;
                userToken = Object(__WEBPACK_IMPORTED_MODULE_5__selectors_auth__["a" /* tokenSelector */])(getState().routes);
                _context.next = 47;
                return Object(__WEBPACK_IMPORTED_MODULE_2__actions_helpers_tokenHelpers__["a" /* withClientToken */])({
                  action: __WEBPACK_IMPORTED_MODULE_3__actions_sagAuth__["g" /* updatePassword */],
                  args: [userToken, password, password2]
                });

              case 47:
                _ref2 = _context.sent;
                error = _ref2.error;
                errorCode = _ref2.errorCode;
                console.log({
                  error: error,
                  errorCode: errorCode
                });

                if (!error) {
                  _context.next = 55;
                  break;
                }

                dispatch(setSubmitting(false));
                dispatch(setError(error.errorMessage));
                return _context.abrupt("return");

              case 55:
                // const {
                //   refresh_token: refreshToken,
                //   subdomain_url: subdomain,
                //   user_token: userToken,
                //   id: userId,
                // } = data;
                // const user = merge({}, data, { user_id: userId });
                // delete user.user_token;
                // delete user.refresh_token;
                // delete user.redirection_token;
                // delete user.id;
                // saveAuthCookie(userToken, refreshToken, user, subdomain, true);
                // dispatch(setError(''));
                // const { auth: {user} } = getState().routes;
                //
                //
                // const redirectUrl = getPlatformUrl({
                //   organizationSubdomain: user.subdomain_url,
                //   websiteHost: window.location.host,
                // });
                //
                // clearExtraAliasInfo();
                // window.location.replace(redirectUrl);
                dispatch(setSubmitting(false));
                dispatch(setError(''));
                dispatch(setFields({
                  password: '',
                  password2: ''
                }));
                dispatch(setSuccess('Password changed successfully'));
                setTimeout(function () {
                  window.location.replace('/sign-in');
                }, 3000);
                _context.next = 66;
                break;

              case 62:
                _context.prev = 62;
                _context.t0 = _context["catch"](43);
                dispatch(setSubmitting(false));
                dispatch(setError('Some error occured'));

              case 66:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[43, 62]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

var ACTIONS = {
  init: function init() {
    return {
      type: INIT
    };
  },
  setFieldsVal: setFieldsVal,
  submitPassword: submitPassword
};

function newPassword() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case INIT:
      return Object.assign({}, state);

    case SET_FIELDS:
      return Object.assign({}, state, {
        fields: action.fields
      });

    case SET_ERROR:
      return Object.assign({}, state, {
        errorMessage: action.err
      });

    case SET_SUCCESS:
      return Object.assign({}, state, {
        successMessage: action.successMessage
      });

    case SET_SUBMITTING:
      return Object.assign({}, state, {
        submitting: action.bool
      });

    case SET_VALIDATION_TXT:
      return Object.assign({}, state, {
        validationTxt: action.txt
      });

    default:
      return Object.assign({}, state);
  }
}

/* harmony default export */ __webpack_exports__["b"] = (newPassword);

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export registerUser */
/* unused harmony export registerOrg */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRegistrationFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return registerUserToOrg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return listOrgProfiles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_fetch__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utils_fetch__);
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var registerUser = function registerUser(clientToken, email, password, name, phone) {
  var userData = {
    email: email,
    password: password,
    name: name,
    cell_phone: phone
  };
  var config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken
    },
    body: JSON.stringify(userData)
  };
  return __WEBPACK_IMPORTED_MODULE_1__utils_fetch___default()("".concat(__WEBPACK_IMPORTED_MODULE_0__config__["API_ROOT"], "auth/try-free/"), config).then(function (response) {
    if (response.headers.get('content-type') !== 'application/json') {
      return {
        error: response.statusText,
        errorCode: response.status
      };
    }

    return response.json().then(function (json) {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status
        };
      }

      var data = json.results;
      return data;
    });
  });
};
var registerOrg = function registerOrg(clientToken, name, domain, subdomain, userId, sessionId, userToken) {
  var orgData = {
    organization_name: name,
    organization_domain: "https://".concat(domain),
    subdomain_url: "https://".concat(subdomain, ".spotmentor.com"),
    user_id: userId,
    session_code: sessionId,
    package_id: __WEBPACK_IMPORTED_MODULE_0__config__["PACKAGE_ID"]
  };
  var config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken,
      'User-Access-Token': userToken
    },
    body: JSON.stringify(orgData)
  };
  return __WEBPACK_IMPORTED_MODULE_1__utils_fetch___default()("".concat(__WEBPACK_IMPORTED_MODULE_0__config__["API_ROOT"], "organization/register/"), config).then(function (response) {
    if (response.headers.get('content-type') !== 'application/json') {
      return {
        error: response.statusText,
        errorCode: response.status
      };
    }

    return response.json().then(function (json) {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status
        };
      }

      var data = json.results;
      return data;
    });
  });
};
var getRegistrationFields = function getRegistrationFields(clientToken, hashCode) {
  var config = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken
    }
  };
  return __WEBPACK_IMPORTED_MODULE_1__utils_fetch___default()("".concat("https://sag.spotmentor.com/", "/get-org-reg-fields?code=").concat(hashCode), config).then(function (response) {
    if (response.headers.get('content-type') !== 'application/json') {
      return {
        error: response.statusText,
        errorCode: response.status
      };
    }

    return response.json().then(function (json) {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status
        };
      }

      var data = json.results;
      return data;
    });
  });
};
var standardRegFields = ['name', 'email', 'password'];
var registerUserToOrg = function registerUserToOrg(clientToken, orgId, userDetails) {
  var standardDetails = {};
  var customRegDetails = {};
  var keys = Object.keys(userDetails);

  for (var i = keys.length - 1; i >= 0; i -= 1) {
    var key = keys[i];

    if (standardRegFields.includes(key)) {
      standardDetails[key] = userDetails[key];
    } else {
      customRegDetails[key] = userDetails[key];
    }
  }

  var config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken
    },
    body: JSON.stringify(_extends({
      organization_id: orgId,
      custom_fields: customRegDetails
    }, standardDetails))
  };
  return __WEBPACK_IMPORTED_MODULE_1__utils_fetch___default()("".concat("https://sag.spotmentor.com/", "/register"), config).then(function (response) {
    if (response.headers.get('content-type') !== 'application/json') {
      return {
        error: response.statusText,
        errorCode: response.status
      };
    }

    return response.json().then(function (json) {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status
        };
      }

      var data = json.results;
      return data;
    });
  });
};
var listOrgProfiles =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(clientToken, orgId) {
    var config, roles, jsonRoles;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            config = {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Client-Access-Token': clientToken
              }
            };
            _context.prev = 1;
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_1__utils_fetch___default()("".concat("https://sag.spotmentor.com/", "/list-profiles-for-organization?organization_id=").concat(orgId), config);

          case 4:
            roles = _context.sent;
            _context.next = 7;
            return roles.json();

          case 7:
            jsonRoles = _context.sent;
            return _context.abrupt("return", {
              roles: jsonRoles && jsonRoles.results,
              error: null
            });

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);
            console.error(_context.t0);
            return _context.abrupt("return", {
              roles: [],
              error: 'Error while fetching roles'
            });

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[1, 11]]);
  }));

  return function listOrgProfiles(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_helpers_tokenHelpers__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_sagAuth__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout__ = __webpack_require__(69);
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }




var INIT = 'changePassword/INIT';
var SET_EMAIL = 'changePassword/SET_EMAIL';
var SET_ATTEMPTING_LOGIN = 'changePassword/SET_ATTEMPTING_LOGIN';
var SUBMIT_FORGOT_PASS = 'changePassword/SUBMIT_FORGOT_PASS';
var defaultState = {
  email: '',
  attemptingLogin: false,
  forgotPassSubmitted: false,
  errorMessage: ''
};

var setAttemptingLogin = function setAttemptingLogin(bool) {
  return {
    type: SET_ATTEMPTING_LOGIN,
    bool: bool
  };
};

var submitForgotPass = function submitForgotPass(bool, errorMessage) {
  return {
    type: SUBMIT_FORGOT_PASS,
    bool: bool,
    errorMessage: errorMessage
  };
};

var handleForgotPassword = function handleForgotPassword() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(dispatch, getState) {
        var email, _ref2, error, errorCode;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                email = getState().routes.changePassword.email;

                if (email) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", dispatch(__WEBPACK_IMPORTED_MODULE_2__layout__["a" /* ACTIONS */].setAlert('Please enter email', 'danger')));

              case 3:
                dispatch(setAttemptingLogin(true));
                _context.prev = 4;
                _context.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_0__actions_helpers_tokenHelpers__["a" /* withClientToken */])({
                  action: __WEBPACK_IMPORTED_MODULE_1__actions_sagAuth__["a" /* forgotPassword */],
                  args: [email]
                });

              case 7:
                _ref2 = _context.sent;
                error = _ref2.error;
                errorCode = _ref2.errorCode;

                if (error) {
                  dispatch(__WEBPACK_IMPORTED_MODULE_2__layout__["a" /* ACTIONS */].setAlert("Some error Occured: ".concat(error && error.errorMessage), 'danger'));
                }

                dispatch(submitForgotPass(true, error && error.errorMessage));
                dispatch(setAttemptingLogin(false));
                _context.next = 20;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](4);
                console.error(_context.t0);
                dispatch(setAttemptingLogin(false));
                dispatch(__WEBPACK_IMPORTED_MODULE_2__layout__["a" /* ACTIONS */].setAlert('Some error eccured. Please try after some time', 'danger'));

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 15]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

var ACTIONS = {
  init: function init() {
    return {
      type: INIT
    };
  },
  changeEmail: function changeEmail(val) {
    return {
      type: SET_EMAIL,
      val: val
    };
  },
  handleForgotPassword: handleForgotPassword,
  submitForgotPass: submitForgotPass
};

function changePassword() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case INIT:
      return Object.assign({}, state);

    case SET_EMAIL:
      return Object.assign({}, state, {
        email: action.val
      });

    case SET_ATTEMPTING_LOGIN:
      return Object.assign({}, state, {
        attemptingLogin: action.bool
      });

    case SUBMIT_FORGOT_PASS:
      return Object.assign({}, state, {
        forgotPassSubmitted: action.bool,
        errorMessage: action.errorMessage
      });

    default:
      return Object.assign({}, state);
  }
}

/* harmony default export */ __webpack_exports__["b"] = (changePassword);

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(255);
module.exports = __webpack_require__(454);


/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCookieValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteAuthCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return saveAuthCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return saveCookieConsent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return saveExtraAliasInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearExtraAliasInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAuthFromCookie; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


var getCookieValue = function getCookieValue(name) {
  var cookie = document && document.cookie;
  var value = "; ".concat(cookie);
  var parts = value.split("; ".concat(name, "="));
  if (parts.length === 2) return parts.pop().split(';').shift();
  return '';
};
var deleteAuthCookie = function deleteAuthCookie() {
  var devDomain = document.location.hostname;
  var cookieDomain =  false ? devDomain : __WEBPACK_IMPORTED_MODULE_0__config__["COOKIE_DOMAIN"]; // document.cookie = `user_access_token=; max-age=0; path=/; domain=${cookieDomain}`;
  // document.cookie = `refresh_token=; max-age=0; path=/; domain=${cookieDomain}`;
  // document.cookie = `user=; max-age=0; path=/; domain=${cookieDomain}`;

  document.cookie = "sessionSubdomain=; max-age=0; path=/; domain=".concat(cookieDomain); // document.cookie = `hasDemo=; max-age=0; path=/; domain=${cookieDomain}`;
  // document.cookie = `saveSession=; max-age=0; path=/; domain=${cookieDomain}`;
};
var saveAuthCookie = function saveAuthCookie(orgSubdomain) {
  // const hasDemoBool = !!hasDemo;
  var devDomain = document.location.hostname;
  var cookieDomain =  false ? devDomain : __WEBPACK_IMPORTED_MODULE_0__config__["COOKIE_DOMAIN"]; // document.cookie = `user_access_token=${token}; max-age=${REFRESH_COOKIE_TIMEOUT}; path=/; domain=${cookieDomain}`;
  // document.cookie = `refresh_token=${refreshToken}; max-age=${REFRESH_COOKIE_TIMEOUT}; path=/; domain=${cookieDomain}`;
  // document.cookie = `user=${JSON.stringify(
  //   user,
  // )}; max-age=${COOKIE_TIMEOUT}; path=/; domain=${cookieDomain}`;

  document.cookie = "sessionSubdomain=".concat(orgSubdomain, "; max-age=").concat(__WEBPACK_IMPORTED_MODULE_0__config__["COOKIE_TIMEOUT"], "; path=/; domain=").concat(cookieDomain); // document.cookie = `hasDemo=${hasDemoBool}; max-age=${COOKIE_TIMEOUT}; path=/; domain=${cookieDomain}`;
  // document.cookie = `saveSession=${saveSession}; max-age=${COOKIE_TIMEOUT}; path=/; domain=${cookieDomain}`;
};
var saveCookieConsent = function saveCookieConsent(consent) {
  var devDomain = document.location.hostname;
  var cookieDomain =  false ? devDomain : __WEBPACK_IMPORTED_MODULE_0__config__["COOKIE_DOMAIN"];
  document.cookie = "cookie_consent=".concat(consent, "; max-age=").concat(__WEBPACK_IMPORTED_MODULE_0__config__["COOKIE_TIMEOUT"], "; path=/; domain=").concat(cookieDomain);
};
var saveExtraAliasInfo = function saveExtraAliasInfo(details) {
  var devDomain = document.location.hostname;
  var cookieDomain =  false ? devDomain : __WEBPACK_IMPORTED_MODULE_0__config__["COOKIE_DOMAIN"];
  document.cookie = "extra_alias_info=".concat(JSON.stringify(details), "; max-age=").concat(__WEBPACK_IMPORTED_MODULE_0__config__["COOKIE_TIMEOUT"], "; path=/; domain=").concat(cookieDomain);
};
var clearExtraAliasInfo = function clearExtraAliasInfo() {
  var devDomain = document.location.hostname;
  var cookieDomain =  false ? devDomain : __WEBPACK_IMPORTED_MODULE_0__config__["COOKIE_DOMAIN"];
  document.cookie = "extra_alias_info=; max-age=0; path=/; domain=".concat(cookieDomain);
};

var getAuthFromServerCookie = function getAuthFromServerCookie(cookie) {
  if (_typeof(cookie) !== 'object') {
    return {};
  }

  var userToken = cookie.user_access_token || '';
  var refreshToken = cookie[__WEBPACK_IMPORTED_MODULE_0__config__["SPOTMENTOR_ENV"]] || '';
  var user = {};

  try {
    user = JSON.parse(decodeURIComponent(cookie.user || ''));
  } catch (err) {
    console.error(err);
    user = {};
  }

  var hasDemo = cookie.hasDemo || 'true';

  if (typeof hasDemo === 'string') {
    hasDemo = hasDemo !== 'false';
  }

  return {
    userToken: userToken,
    refreshToken: refreshToken,
    user: user,
    hasDemo: hasDemo
  };
};

var getAuthFromBrowserCookie = function getAuthFromBrowserCookie() {
  var userToken = getCookieValue('user_access_token');
  var refreshToken = getCookieValue('refresh_token');
  var user = JSON.parse(decodeURIComponent(getCookieValue('user')) || '{}');
  var hasDemo = getCookieValue('hasDemo') || 'true';

  if (typeof hasDemo === 'string') {
    hasDemo = hasDemo !== 'false';
  }

  return {
    userToken: userToken,
    refreshToken: refreshToken,
    user: user,
    hasDemo: hasDemo
  };
};

var getAuthFromCookie =  true ? getAuthFromBrowserCookie : getAuthFromServerCookie;

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);
 // Navigation manager, e.g. history.push('/home')
// https://github.com/mjackson/history

/* harmony default export */ __webpack_exports__["a"] = (true && __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()());

/***/ }),

/***/ 454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/whatwg-fetch/fetch.js
var whatwg_fetch_fetch = __webpack_require__(205);
var fetch_default = /*#__PURE__*/__webpack_require__.n(whatwg_fetch_fetch);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(79);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/react-deep-force-update/lib/index.js
var lib = __webpack_require__(459);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(460);
var query_string_default = /*#__PURE__*/__webpack_require__.n(query_string);

// EXTERNAL MODULE: ./node_modules/history/PathUtils.js
var PathUtils = __webpack_require__(140);
var PathUtils_default = /*#__PURE__*/__webpack_require__.n(PathUtils);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(11);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ./src/components/App.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ContextType = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: prop_types_default.a.func.isRequired,
  // Universal HTTP client
  fetch: prop_types_default.a.func.isRequired,
  auth: prop_types_default.a.object.isRequired,
  store: prop_types_default.a.shape({
    subscribe: prop_types_default.a.func.isRequired,
    dispatch: prop_types_default.a.func.isRequired,
    getState: prop_types_default.a.func.isRequired
  }).isRequired
};
/**
 * The top-level React component setting context (global) variables
 * that can be accessed from all the child components.
 *
 * https://facebook.github.io/react/docs/context.html
 *
 * Usage example:
 *
 *   const context = {
 *     history: createBrowserHistory(),
 *     store: createStore(),
 *   };
 *
 *   ReactDOM.render(
 *     <App context={context}>
 *       <Layout>
 *         <LandingPage />
 *       </Layout>
 *     </App>,
 *     container,
 *   );
 */

var App_App =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(App, _React$PureComponent);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  _createClass(App, [{
    key: "getChildContext",
    value: function getChildContext() {
      return this.props.context;
    }
  }, {
    key: "render",
    value: function render() {
      // NOTE: If you need to add or modify header, footer etc. of the app,
      // please do that inside the Layout component.
      return react_default.a.Children.only(this.props.children);
    }
  }]);

  return App;
}(react_default.a.PureComponent);

Object.defineProperty(App_App, "childContextTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: ContextType
});
/* harmony default export */ var components_App = (App_App);
// CONCATENATED MODULE: ./src/createFetch.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Creates a wrapper function around the HTML5 Fetch API that provides
 * default arguments to fetch(...) and is intended to reduce the amount
 * of boilerplate code in the application.
 * https://developer.mozilla.org/docs/Web/API/Fetch_API/Using_Fetch
 */
function createFetch(fetch, _ref) {
  var baseUrl = _ref.baseUrl,
      cookie = _ref.cookie;
  // NOTE: Tweak the default options to suite your application needs
  var defaults = {
    method: 'POST',
    // handy with GraphQL backends
    mode: baseUrl ? 'cors' : 'same-origin',
    credentials: baseUrl ? 'include' : 'same-origin',
    headers: _extends({
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }, cookie ? {
      Cookie: cookie
    } : null)
  };
  return function (url, options) {
    return url.startsWith('/graphql') || url.startsWith('/api') ? fetch("".concat(baseUrl).concat(url), _extends({}, defaults, options, {
      headers: _extends({}, defaults.headers, options && options.headers)
    })) : fetch(url, options);
  };
}

/* harmony default export */ var src_createFetch = (createFetch);
// EXTERNAL MODULE: ./src/history.js
var src_history = __webpack_require__(40);

// CONCATENATED MODULE: ./src/DOMUtils.js
function updateTag(tagName, keyName, keyValue, attrName, attrValue) {
  var node = document.head.querySelector("".concat(tagName, "[").concat(keyName, "=\"").concat(keyValue, "\"]"));
  if (node && node.getAttribute(attrName) === attrValue) return; // Remove and create a new tag in order to make it work with bookmarks in Safari

  if (node) {
    node.parentNode.removeChild(node);
  }

  if (typeof attrValue === 'string') {
    var nextNode = document.createElement(tagName);
    nextNode.setAttribute(keyName, keyValue);
    nextNode.setAttribute(attrName, attrValue);
    document.head.appendChild(nextNode);
  }
}
function updateMeta(name, content) {
  updateTag('meta', 'name', name, 'content', content);
}
function updateCustomMeta(property, content) {
  updateTag('meta', 'property', property, 'content', content);
}
function updateLink(rel, href) {
  updateTag('link', 'rel', rel, 'href', href);
}
// EXTERNAL MODULE: ./node_modules/universal-router/browser.mjs
var browser = __webpack_require__(473);

// EXTERNAL MODULE: ./src/components/Layout/Layout.js + 12 modules
var Layout = __webpack_require__(238);

// EXTERNAL MODULE: ./src/utils/cookie.js
var cookie = __webpack_require__(32);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(77);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/isomorphic-style-loader/lib/withStyles.js
var withStyles = __webpack_require__(57);
var withStyles_default = /*#__PURE__*/__webpack_require__.n(withStyles);

// CONCATENATED MODULE: ./src/components/LogoutOverlay/LogoutIcon.js
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }



var LogoutIcon__ref = _jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  id: "Capa_1",
  height: "70px",
  viewBox: "0 0 524.235 524.235",
  width: "70px"
}, void 0, _jsx("g", {}, void 0, _jsx("path", {
  d: "m294.882 0h-262.117c-18.094 0-32.765 14.671-32.765 32.765v458.706c0 18.094 14.671 32.765 32.765 32.765h262.118c18.094 0 32.765-14.671 32.765-32.765v-458.706c-.001-18.094-14.671-32.765-32.766-32.765zm-65.529 294.882c-18.096 0-32.765-14.671-32.765-32.765 0-18.096 14.669-32.765 32.765-32.765s32.765 14.669 32.765 32.765c0 18.095-14.669 32.765-32.765 32.765z",
  "data-original": "#000000",
  "data-old_color": "#000000",
  fill: "#FFFFFF"
}), _jsx("path", {
  d: "m524.235 262.118-114.676-98.294v65.529h-49.147v65.529h49.147v65.529z",
  "data-original": "#000000",
  "data-old_color": "#000000",
  fill: "#FFFFFF"
})), ' ');

var LogoutIcon = function LogoutIcon() {
  return LogoutIcon__ref;
};

/* harmony default export */ var LogoutOverlay_LogoutIcon = (LogoutIcon);
// EXTERNAL MODULE: ./src/components/LogoutOverlay/LogoutOverlay.css
var LogoutOverlay = __webpack_require__(643);
var LogoutOverlay_default = /*#__PURE__*/__webpack_require__.n(LogoutOverlay);

// CONCATENATED MODULE: ./src/components/LogoutOverlay/LogoutOverlay.js
function LogoutOverlay__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { LogoutOverlay__typeof = function _typeof(obj) { return typeof obj; }; } else { LogoutOverlay__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return LogoutOverlay__typeof(obj); }

var LogoutOverlay_REACT_ELEMENT_TYPE;

function LogoutOverlay__jsx(type, props, key, children) { if (!LogoutOverlay_REACT_ELEMENT_TYPE) { LogoutOverlay_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: LogoutOverlay_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function LogoutOverlay__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LogoutOverlay__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function LogoutOverlay__createClass(Constructor, protoProps, staticProps) { if (protoProps) LogoutOverlay__defineProperties(Constructor.prototype, protoProps); if (staticProps) LogoutOverlay__defineProperties(Constructor, staticProps); return Constructor; }

function LogoutOverlay__possibleConstructorReturn(self, call) { if (call && (LogoutOverlay__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function LogoutOverlay__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var LogoutOverlay__ref = LogoutOverlay__jsx(LogoutOverlay_LogoutIcon, {});

var _ref2 = LogoutOverlay__jsx("p", {}, void 0, "Logging out. Hang in there.");

var LogoutOverlay_LoginTab =
/*#__PURE__*/
function (_React$Component) {
  LogoutOverlay__inherits(LoginTab, _React$Component);

  function LoginTab() {
    LogoutOverlay__classCallCheck(this, LoginTab);

    return LogoutOverlay__possibleConstructorReturn(this, (LoginTab.__proto__ || Object.getPrototypeOf(LoginTab)).apply(this, arguments));
  }

  LogoutOverlay__createClass(LoginTab, [{
    key: "render",
    value: function render() {
      return LogoutOverlay__jsx("div", {
        className: LogoutOverlay_default.a.overlay
      }, void 0, LogoutOverlay__jsx("div", {}, void 0, LogoutOverlay__ref, LogoutOverlay__jsx("div", {
        className: LogoutOverlay_default.a.loading
      }, void 0, LogoutOverlay__jsx("div", {
        className: classnames_default()(LogoutOverlay_default.a.dot, LogoutOverlay_default.a.d1)
      }), LogoutOverlay__jsx("div", {
        className: classnames_default()(LogoutOverlay_default.a.dot, LogoutOverlay_default.a.d2)
      }), LogoutOverlay__jsx("div", {
        className: classnames_default()(LogoutOverlay_default.a.dot, LogoutOverlay_default.a.d3)
      }))), _ref2);
    }
  }]);

  return LoginTab;
}(react_default.a.Component);

/* harmony default export */ var LogoutOverlay_LogoutOverlay = (withStyles_default()(LogoutOverlay_default.a)(LogoutOverlay_LoginTab));
// CONCATENATED MODULE: ./src/routes/logout/Logout.js
function Logout__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Logout__typeof = function _typeof(obj) { return typeof obj; }; } else { Logout__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Logout__typeof(obj); }

var Logout_REACT_ELEMENT_TYPE;

function Logout__jsx(type, props, key, children) { if (!Logout_REACT_ELEMENT_TYPE) { Logout_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Logout_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Logout__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Logout__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Logout__createClass(Constructor, protoProps, staticProps) { if (protoProps) Logout__defineProperties(Constructor.prototype, protoProps); if (staticProps) Logout__defineProperties(Constructor, staticProps); return Constructor; }

function Logout__possibleConstructorReturn(self, call) { if (call && (Logout__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Logout__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }


 // import withStyles from 'isomorphic-style-loader/lib/withStyles';




var REDIRECT_TIMEOUT = 1000;
var logoutUser = cookie["b" /* deleteAuthCookie */];

var Logout__ref2 = Logout__jsx(LogoutOverlay_LogoutOverlay, {});

var Logout_Logout =
/*#__PURE__*/
function (_React$Component) {
  Logout__inherits(Logout, _React$Component);

  function Logout() {
    var _ref;

    var _temp, _this;

    Logout__classCallCheck(this, Logout);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return Logout__possibleConstructorReturn(_this, (_temp = _this = Logout__possibleConstructorReturn(this, (_ref = Logout.__proto__ || Object.getPrototypeOf(Logout)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "redirectAfterLogout", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var redirect = _this.props.redirect;

        if (redirect) {
          setTimeout(function () {
            return window.location.replace(redirect);
          }, REDIRECT_TIMEOUT);
          return;
        }

        setTimeout(function () {
          return src_history["a" /* default */].push('/');
        }, REDIRECT_TIMEOUT);
      }
    }), _temp));
  }

  Logout__createClass(Logout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      logoutUser();
      this.redirectAfterLogout();
    }
  }, {
    key: "render",
    value: function render() {
      return Logout__jsx("div", {
        style: {
          minHeight: '100vh'
        }
      }, void 0, Logout__ref2, ' ');
    }
  }]);

  return Logout;
}(react_default.a.Component);

Object.defineProperty(Logout_Logout, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    redirect: null
  }
});
/* harmony default export */ var logout_Logout = (Logout_Logout);
// CONCATENATED MODULE: ./src/routes/logout/index.js
var logout_REACT_ELEMENT_TYPE;

function logout__jsx(type, props, key, children) { if (!logout_REACT_ELEMENT_TYPE) { logout_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: logout_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }





function logout_action(_ref) {
  var query = _ref.query;

  var component = logout__jsx(Layout["a" /* default */], {}, void 0, logout__jsx(logout_Logout, {
    redirect: query.redirect
  }));

  return {
    chunks: [],
    title: 'Logout',
    component: component
  };
}

/* harmony default export */ var logout = (logout_action);
// CONCATENATED MODULE: ./src/routes/index.js
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }

/* eslint-disable global-require */
 // The top-level (parent) route

var routes = {
  path: '',
  // Keep in mind, routes are evaluated in order
  children: [{
    path: '',
    load: function load() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 750));
    }
  }, {
    path: '/logout',
    action: logout
  }, {
    path: '/new-password',
    load: function load() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 751));
    }
  }, {
    path: '/sign-in',
    load: function load() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 752));
    }
  }, {
    path: '/track-mail',
    load: function load() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 753));
    }
  }, // {
  //   path: '/demo',
  //   load: () => import(/* webpackChunkName: 'demo' */ './demo'),
  // },
  // {
  //   path: '/org-selection',
  //   load: () =>
  //     import(/* webpackChunkName: 'org-selection' */ './orgSelection'),
  // },
  {
    path: '/change-password',
    load: function load() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 754));
    }
  }, {
    path: '/legal/cookie-policy',
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 755));
    }
  }, {
    path: '/legal/gdpr-policy',
    load: function load() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 756));
    }
  }, // {
  //   path: '/legal/pdpa-policy',
  //   load: () => import(/* webpackChunkName: 'cookiePolicy' */ './legal/pdpa'),
  // },
  // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
  {
    path: '(.*)',
    load: function load() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 757));
    }
  }],
  action: function () {
    var _action = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var query, next, userToken, route;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              query = _ref.query, next = _ref.next, userToken = _ref.userToken;
              _context.next = 3;
              return next();

            case 3:
              route = _context.sent;
              // Provide default values for title, description etc.
              route.title = "".concat(route.title || 'Untitled Page');
              route.description = route.description || '';
              return _context.abrupt("return", route);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function action(_x) {
      return _action.apply(this, arguments);
    };
  }()
}; // The error page is available by permanent url for development mode

if (false) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default
  });
}

/* harmony default export */ var src_routes = (routes);
// CONCATENATED MODULE: ./src/router.js


/* harmony default export */ var router = (new browser["a" /* default */](src_routes, {
  resolveRoute: function resolveRoute(context, params) {
    if (typeof context.route.load === 'function') {
      return context.route.load().then(function (action) {
        return action.default(context, params);
      });
    }

    if (typeof context.route.action === 'function') {
      return context.route.action(context, params);
    }

    return undefined;
  }
}));
// EXTERNAL MODULE: ./node_modules/redux-thunk/es/index.js
var es = __webpack_require__(645);

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 15 modules
var redux_es = __webpack_require__(96);

// EXTERNAL MODULE: ./src/middleware/logger/index.js
var logger = __webpack_require__(646);
var logger_default = /*#__PURE__*/__webpack_require__.n(logger);

// EXTERNAL MODULE: ./node_modules/lodash/mergeWith.js
var mergeWith = __webpack_require__(649);
var mergeWith_default = /*#__PURE__*/__webpack_require__.n(mergeWith);

// EXTERNAL MODULE: ./node_modules/lodash/isArray.js
var isArray = __webpack_require__(109);
var isArray_default = /*#__PURE__*/__webpack_require__.n(isArray);

// EXTERNAL MODULE: ./src/reducers/routeReducers/signIn.js + 3 modules
var signIn = __webpack_require__(170);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(63);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./src/actions/loginAuth.js
var getOrgDetailsBySubdomain = function getOrgDetailsBySubdomain(clientToken, subdomain) {
  var config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken
    },
    body: JSON.stringify({
      subdomain: subdomain
    })
  };
  return fetch("".concat("https://sag.spotmentor.com/", "/get-org-details-by-subdomain"), config).then(function (response) {
    return response.json().then(function (json) {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status
        };
      }

      var data = json.results;
      return data;
    });
  });
};
var getOrgAuthMech = function getOrgAuthMech(clientToken, orgId) {
  var config = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken
    }
  };
  return fetch("".concat("https://sag.spotmentor.com/", "/get-org-auth-mechanism?organization_id=").concat(orgId), config).then(function (response) {
    return response.json().then(function (json) {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status
        };
      }

      var data = json.results;
      return data;
    });
  });
};
var getOrgByAlias = function getOrgByAlias(clientToken, alias) {
  var config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken
    },
    body: JSON.stringify({
      alias: alias
    })
  };
  return fetch("".concat("https://sag.spotmentor.com/", "/get-org-details-by-alias"), config).then(function (response) {
    return response.json().then(function (json) {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status
        };
      }

      var data = json.results;
      return data;
    });
  });
};
// EXTERNAL MODULE: ./src/actions/helpers/tokenHelpers.js
var tokenHelpers = __webpack_require__(107);

// EXTERNAL MODULE: ./src/reducers/layout.js + 1 modules
var layout = __webpack_require__(69);

// CONCATENATED MODULE: ./src/reducers/routeReducers/orgSelection.js
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function orgSelection__asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }






var INIT = 'orgSelection/INIT';
var SET_COOKIE_MSG = 'orgSelection/SET_COOKIE_MSG';
var SET_FIELDS = 'orgSelection/SET_FIELDS';
var SET_ERROR = 'orgSelection/SET_ERROR';
var defaultState = {
  fields: {
    orgId: ''
  },
  cookieMsg: false,
  orgSelectionErrMsg: '',
  passwordRegex: '',
  showRegisterForm: true,
  validationTxt: {}
};

var setFields = function setFields(fields) {
  return {
    type: SET_FIELDS,
    fields: fields
  };
};

var setCookieMsg = function setCookieMsg(bool) {
  return {
    type: SET_COOKIE_MSG,
    bool: bool
  };
}; // const setError = err => ({ type: SET_ERROR, err });


var orgSelection_setFieldsVal = function setFieldsVal(field, val) {
  return function (dispatch, getState) {
    var fields = getState().routes.orgSelection.fields;
    var clonedFields = Object(lodash["cloneDeep"])(fields);
    clonedFields[field] = val;
    dispatch(setFields(clonedFields));
  };
};

var orgSelection_handleSignIn = function handleSignIn() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = orgSelection__asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(dispatch, getState) {
        var fields, orgId, response, error, errorCode, apiData, passwordRegex, showRegForm, responseOrgId, validationTxt, extraAliasInfo, _window$location, protocol, host, newLocation;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Object(cookie["f" /* saveCookieConsent */])(true);
                fields = getState().routes.orgSelection.fields;
                orgId = fields.orgId;

                if (orgId) {
                  _context.next = 6;
                  break;
                }

                dispatch(layout["a" /* ACTIONS */].setAlert("Company ID can't be empty", 'danger')); // dispatch(setError("Company ID can't be empty"));

                return _context.abrupt("return");

              case 6:
                _context.prev = 6;
                _context.next = 9;
                return Object(tokenHelpers["a" /* withClientToken */])({
                  action: getOrgByAlias,
                  args: [orgId]
                });

              case 9:
                response = _context.sent;
                error = response.error, errorCode = response.errorCode, apiData = _objectWithoutProperties(response, ["error", "errorCode"]);
                passwordRegex = apiData.password_regex, showRegForm = apiData.show_registration_form, responseOrgId = apiData.id;
                validationTxt = {
                  '1': 'Password must be atleast 12 characters long',
                  '2': 'Password must contain atleast 1 uppercase letter',
                  '3': 'Password must contain atleast one lowercase letter',
                  '4': 'Password must contain atleast one number',
                  '5': 'Password must contain atleast one special character'
                };
                extraAliasInfo = {
                  passwordRegex: passwordRegex,
                  showRegForm: showRegForm,
                  validationTxt: validationTxt,
                  responseOrgId: responseOrgId
                };
                Object(cookie["g" /* saveExtraAliasInfo */])(extraAliasInfo); // const responseOrgId = response.id;

                _window$location = window.location, protocol = _window$location.protocol, host = _window$location.host;
                newLocation = "".concat(protocol, "//").concat(host, "/api/login-redirect?orgId=").concat(responseOrgId);

                if (!error) {
                  window.location.replace(newLocation);
                }

                if (errorCode === 400) {
                  dispatch(layout["a" /* ACTIONS */].setAlert('Please enter a valid company ID', 'danger')); // dispatch(setError('Please enter a valid company ID'));
                }

                if (errorCode === 500) {
                  dispatch(layout["a" /* ACTIONS */].setAlert('Some error occured. Try again after some time', 'danger')); // dispatch(setError('Some error occured. Try again after some time'));
                }

                _context.next = 25;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](6);
                console.error(_context.t0);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 22]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

var orgSelection_promptCookie = function promptCookie() {
  return function (dispatch) {
    var cookieConsent = Object(cookie["d" /* getCookieValue */])('cookie_consent');

    if (cookieConsent) {
      dispatch(orgSelection_handleSignIn());
    } else {
      dispatch(setCookieMsg(true));
    }
  };
};

var declineCookie = function declineCookie() {
  return function (dispatch) {
    dispatch(setCookieMsg(false));
  };
};

var enterPressHandler = function enterPressHandler() {
  return function (dispatch) {
    dispatch(orgSelection_handleSignIn());
  };
};

var ACTIONS = {
  init: function init() {
    return {
      type: INIT
    };
  },
  setFieldsVal: orgSelection_setFieldsVal,
  handleSignIn: orgSelection_handleSignIn,
  promptCookie: orgSelection_promptCookie,
  declineCookie: declineCookie,
  enterPressHandler: enterPressHandler
};

function orgSelection() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case INIT:
      return Object.assign({}, state);

    case SET_FIELDS:
      return Object.assign({}, state, {
        fields: action.fields
      });

    case SET_COOKIE_MSG:
      return Object.assign({}, state, {
        cookieMsg: action.bool
      });

    case SET_ERROR:
      return Object.assign({}, state, {
        orgSelectionErrMsg: action.err
      });

    default:
      return Object.assign({}, state);
  }
}

/* harmony default export */ var routeReducers_orgSelection = (orgSelection);
// EXTERNAL MODULE: ./src/reducers/routeReducers/newPassword.js
var newPassword = __webpack_require__(251);

// EXTERNAL MODULE: ./src/reducers/routeReducers/changePassword.js
var changePassword = __webpack_require__(253);

// EXTERNAL MODULE: ./src/reducers/routeReducers/auth.js
var routeReducers_auth = __webpack_require__(161);

// CONCATENATED MODULE: ./src/reducers/routeReducers/index.js






var routeReducer = Object(redux_es["c" /* combineReducers */])({
  auth: routeReducers_auth["e" /* default */],
  signIn: signIn["b" /* default */],
  orgSelection: routeReducers_orgSelection,
  newPassword: newPassword["b" /* default */],
  changePassword: changePassword["b" /* default */]
});
/* harmony default export */ var routeReducers = (routeReducer);
// EXTERNAL MODULE: ./src/reducers/polling.js
var polling = __webpack_require__(237);

// CONCATENATED MODULE: ./src/reducers/index.js
function reducers__extends() { reducers__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return reducers__extends.apply(this, arguments); }








var reducers_customizer = function customizer(objValue, srcValue) {
  if (isArray_default()(srcValue) && srcValue.length === 0) {
    return srcValue;
  }

  return undefined;
};

var reducers_entities = function entities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (action.response && action.response.entities) {
    var keys = Object.keys(action.response.entities);
    var clearLatest = {};

    if (keys.length === 1 && action.response.entities[keys[0]].hasOwnProperty('latest')) {
      clearLatest[keys[0]] = {
        latest: null
      };
    }

    return mergeWith_default()({}, state, reducers__extends({
      suggestions: {}
    }, clearLatest), action.response.entities, reducers_customizer);
  }

  return state;
};

var appReducer = Object(redux_es["c" /* combineReducers */])({
  entities: reducers_entities,
  routes: routeReducers,
  layout: layout["b" /* default */],
  polling: polling["d" /* default */]
});

var rootReducer = function rootReducer(state, action) {
  var appState = state;
  return appReducer(appState, action);
};

/* harmony default export */ var reducers = (rootReducer);
// CONCATENATED MODULE: ./src/store/configureStore.js

 // import { asyncSessionStorage } from 'redux-persist/storages';
// import { autoRehydrate, persistStore } from 'redux-persist';
// import sagApi from '../middleware/sagApi';


 // import { isSessionSaved, deleteAuthCookie, dumpAuthCookie } from '../core/cookie';

function configureStore(initialState, helpersConfig) {
  var middleware = [es["a" /* default */]];
  var enhancer;

  if (false) {
    middleware.push(createLoggerMiddleware()); // https://github.com/zalmoxisus/redux-devtools-extension#redux-devtools-extension

    var devToolsExtension = function devToolsExtension(f) {
      return f;
    };

    if (process.env.BROWSER && window.devToolsExtension) {
      devToolsExtension = window.devToolsExtension();
    }

    enhancer = compose(applyMiddleware.apply(void 0, middleware), devToolsExtension);
  } else {
    enhancer = Object(redux_es["d" /* compose */])(redux_es["a" /* applyMiddleware */].apply(void 0, middleware));
  } // See https://github.com/rackt/redux/releases/tag/v3.1.0


  var store = Object(redux_es["e" /* createStore */])(reducers, initialState, enhancer); // if (process.env.BROWSER && location.pathname !== '/widget') {
  //   persistStore(store, { storage: asyncSessionStorage });
  // }
  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)

  if (false) {
    module.hot.accept('../reducers', function () {
      return store.replaceReducer(require('../reducers').default);
    });
  }

  return store;
}
// CONCATENATED MODULE: ./src/client.js
var client_REACT_ELEMENT_TYPE;

function client__jsx(type, props, key, children) { if (!client_REACT_ELEMENT_TYPE) { client_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: client_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function client__extends() { client__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return client__extends.apply(this, arguments); }

function client__asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }














 // Global (context) variables that can be easily accessed from any React component
// https://facebook.github.io/react/docs/context.html

var client_store = configureStore(window.APP_STATE, {
  history: src_history["a" /* default */]
});
var context = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: function insertCss() {
    for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
      styles[_key] = arguments[_key];
    }

    // eslint-disable-next-line no-underscore-dangle
    var removeCss = styles.map(function (x) {
      return x._insertCss();
    });
    return function () {
      removeCss.forEach(function (f) {
        return f();
      });
    };
  },
  store: client_store,
  // Universal HTTP client
  fetch: src_createFetch(fetch, {
    baseUrl: window.App.apiUrl
  })
};
var container = document.getElementById('app');
var currentLocation = src_history["a" /* default */].location;
var appInstance; // Switch off the native scroll restoration behavior and handle it manually
// https://developers.google.com/web/updates/2015/09/history-api-scroll-restoration

var scrollPositionsHistory = {};

if (window.history && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
} // Re-render the app when window.location changes


function onLocationChange(_x, _x2) {
  return _onLocationChange.apply(this, arguments);
} // Handle client-side navigation by using HTML5 History API
// For more information visit https://github.com/mjackson/history#readme


function _onLocationChange() {
  _onLocationChange = client__asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(location, action) {
    var isInitialRender, auth, route, renderReactApp, subDomain;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Remember the latest scroll position for the previous location
            scrollPositionsHistory[currentLocation.key] = {
              scrollX: window.pageXOffset,
              scrollY: window.pageYOffset
            }; // Delete stored scroll position for next page if any

            if (action === 'PUSH') {
              delete scrollPositionsHistory[location.key];
            }

            currentLocation = location;
            isInitialRender = !action; // if (isInitialRender && currentLocation.key !== location.key) {
            //   window.location.reload();
            // }

            _context.prev = 4;
            // Traverses the list of routes in the order they are defined until
            // it finds the first route that matches provided URL path string
            // and whose action method returns anything other than `undefined`.
            auth = Object(cookie["c" /* getAuthFromCookie */])();
            context.auth = auth;
            _context.next = 9;
            return router.resolve(client__extends({}, context, auth, {
              pathname: location.pathname,
              query: query_string_default.a.parse(location.search),
              host: location.host
            }));

          case 9:
            route = _context.sent;

            if (!(currentLocation.key !== location.key)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return");

          case 12:
            if (!route.redirect) {
              _context.next = 15;
              break;
            }

            src_history["a" /* default */].replace(route.redirect);
            return _context.abrupt("return");

          case 15:
            renderReactApp = isInitialRender ? react_dom_default.a.hydrate : react_dom_default.a.render;
            appInstance = renderReactApp(client__jsx(components_App, {
              context: context
            }, void 0, route.component), container, function () {
              if (isInitialRender) {
                var elem = document.getElementById('css');
                if (elem) elem.parentNode.removeChild(elem);
                return;
              }

              document.title = route.title;
              updateMeta('description', route.description); // Update necessary tags in <head> at runtime here, ie:
              // updateMeta('keywords', route.keywords);
              // updateCustomMeta('og:url', route.canonicalUrl);
              // updateCustomMeta('og:image', route.imageUrl);
              // updateLink('canonical', route.canonicalUrl);
              // etc.

              var scrollX = 0;
              var scrollY = 0;
              var pos = scrollPositionsHistory[location.key];

              if (pos) {
                scrollX = pos.scrollX;
                scrollY = pos.scrollY;
              } else {
                var targetHash = location.hash.substr(1);

                if (targetHash) {
                  var target = document.getElementById(targetHash);

                  if (target) {
                    scrollY = window.pageYOffset + target.getBoundingClientRect().top;
                  }
                }
              } // Restore the scroll position if it was saved into the state
              // or scroll to the given #hash anchor
              // or scroll to top of the page


              window.scrollTo(scrollX, scrollY); // Google Analytics tracking. Don't send 'pageview' event after
              // the initial rendering, as it was already sent

              if (window.ga) {
                window.ga('send', 'pageview', Object(PathUtils["createPath"])(location));
              }
            });

            if (isInitialRender && !!Object(cookie["d" /* getCookieValue */])('sessionSubdomain').length) {
              subDomain = Object(cookie["d" /* getCookieValue */])('sessionSubdomain'); // handleRedirection(true, subDomain);
            }

            _context.next = 26;
            break;

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](4);

            if (true) {
              _context.next = 24;
              break;
            }

            throw _context.t0;

          case 24:
            console.error(_context.t0); // Do a full page reload if error occurs during client-side navigation

            if (!isInitialRender && currentLocation.key === location.key) {
              window.location.reload();
            }

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[4, 20]]);
  }));
  return _onLocationChange.apply(this, arguments);
}

src_history["a" /* default */].listen(onLocationChange);
onLocationChange(currentLocation); // Enable Hot Module Replacement (HMR)

if (false) {
  module.hot.accept('./router', function () {
    if (appInstance && appInstance.updater.isMounted(appInstance)) {
      // Force-update the whole tree, including components that refuse to update
      deepForceUpdate(appInstance);
    }

    onLocationChange(currentLocation);
  });
}

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(560);
    var insertCss = __webpack_require__(22);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Layout.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Layout.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)(false);
// imports


// module
exports.push([module.i, "button:focus{outline:none}html{color:#222;font-weight:100;font-size:1em;font-family:Montserrat,HelveticaNeue-Light,sans-serif;line-height:1.375}body{font:400 16px/26px Montserrat,HelveticaNeue-Light,sans-serif;letter-spacing:.3px;color:#282828;margin:0}button,input,optgroup,select,textarea{font-family:Montserrat,HelveticaNeue-Light,sans-serif}a,button{-webkit-transition:all .3s linear 0s;-o-transition:all .3s linear 0s;transition:all .3s linear 0s}a,a:focus,a:hover,button,button:focus,button:hover{text-decoration:none;outline:none}h2,h3,h4,h5,h6,ul{margin:0;list-style:none;padding:0}a{color:#ffe73e}a:hover{color:#bfac24}::-moz-selection{background:#b3d4fc;text-shadow:none}::selection{background:#b3d4fc;text-shadow:none}hr{display:block;height:1px;border:0;border-top:1px solid #ccc;margin:1em 0;padding:0}audio,canvas,iframe,img,svg,video{vertical-align:middle}fieldset{border:0;margin:0;padding:0}textarea{resize:vertical}.browserupgrade{margin:.2em 0;background:#ccc;color:#1a1a24;padding:.2em 0}@media print{*,:after,:before{background:transparent!important;color:#1a1a24!important;-webkit-box-shadow:none!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}}._2sRhy{width:100%;height:100%;position:fixed;bottom:0;right:0;left:0;z-index:11}.O7q-D{background-color:#2f3d4966}._1LCrV,.O7q-D{position:absolute;width:100%;height:100%}._1LCrV{z-index:11;background-color:#2f3d49;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;padding:10px;-webkit-transition:all .2s linear;-o-transition:.2s linear all;transition:all .2s linear}._1LCrV>span{position:absolute;right:5px;top:0;cursor:pointer;font-size:20px;color:#eee}._1LCrV>h4,._1LCrV>p{margin:0;padding:0;padding:10px 30px}._1LCrV>p{font-size:14px;text-align:center;line-height:24px;color:#eee}._1LCrV>._1Z03N{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}._1LCrV button{margin:0 30px;padding:10px 20px;border:none;background-color:#fff;color:#222;font-size:16px;white-space:nowrap}._1LCrV button:hover{background-color:#ffe73e;color:#222}._2Fa9r{width:500px;-webkit-transition:all 1s ease-in;-o-transition:all 1s ease-in;transition:all 1s ease-in}", ""]);

// exports
exports.locals = {
	"layout": "_2QJBL",
	"cookiePromptContainer": "_2sRhy",
	"cookieOverlay": "O7q-D",
	"cookiePrompt": "_1LCrV",
	"ctrls": "_1Z03N",
	"logoSvg": "_2Fa9r"
};

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(562);
    var insertCss = __webpack_require__(22);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Header.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Header.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)(false);
// imports


// module
exports.push([module.i, "button:focus{outline:none}.qQ2mF{position:fixed;background-color:transparent;top:0;left:0;right:0;color:#fff;z-index:10;-ms-flex-direction:row;flex-direction:row;-webkit-transition:all .5s ease;-o-transition:all .5s ease;transition:all .5s ease;font-family:Montserrat,HelveticaNeue-Light,sans-serif;font:400 14px/22px Montserrat,HelveticaNeue-Light,sans-serif}._2oS_y,.qQ2mF{height:70px;display:-ms-flexbox;display:flex}._2oS_y{-ms-flex:1 1;flex:1 1;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:center;align-items:center;text-decoration:none;font-size:1.75em;max-width:200px;z-index:3;padding-left:30px}._230aH{margin-left:10px;color:#fff;-webkit-transition:all .2s ease;-o-transition:all .2s ease;transition:all .2s ease}._2oS_y:hover>._230aH{font-size:1.1em}._3U7Ez{-ms-flex:4 1;flex:4 1;height:70px;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;padding:0 20px;letter-spacing:1px}.MlWRp{width:120px;-webkit-transition:all 1s ease-in;-o-transition:all 1s ease-in;transition:all 1s ease-in}.MlWRp polygon{fill:transparent;stroke-width:6px}.MlWRp line{stroke-width:5px}._1rHqE{-ms-flex:1 1;flex:1 1;display:-ms-flexbox;display:flex;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:center;align-items:center}._1rHqE>a{margin:0 10px;font-size:18px;font-weight:400;color:#fff;cursor:pointer}._1ZR5p{-ms-flex:1 1;flex:1 1;display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-align:center;align-items:center}._1ZR5p>a{margin:0 10px;color:#fff;cursor:pointer}._1ZR5p>a,._1ZR5p>button{font-weight:400;font-size:15px}._1ZR5p>button{background-color:#fff;color:#5d4ea2;letter-spacing:1px;height:30px;line-height:30px;border:0;border-radius:20px;padding:0 30px;margin:0}._1ZR5p i{width:30px;height:30px;border-radius:30px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}._1ZR5p i:hover{background-color:#d7d7d7}.YZ0vJ{position:fixed;top:50px;left:0;right:0;bottom:0;overflow-x:hidden;overflow-y:scroll}._3R4Nz{position:relative;width:100%;height:100%;background-color:transparent}@-webkit-keyframes _1_TN_{0%{top:0}to{top:10px}}@keyframes _1_TN_{0%{top:0}to{top:10px}}.rVnTE{position:absolute;top:10px;right:10px;height:auto;padding:0;width:300px;background-color:#fff;z-index:2;overflow:hidden;-webkit-animation-duration:.5s;animation-duration:.5s;-webkit-animation-name:_1_TN_;animation-name:_1_TN_;-webkit-transition-timing-function:ease-in;-o-transition-timing-function:ease-in;transition-timing-function:ease-in;-webkit-box-shadow:0 .5rem 2rem rgba(0,0,0,.1);box-shadow:0 .5rem 2rem rgba(0,0,0,.1);border-radius:12px}._1ecAX{padding:10px;margin:10px;text-align:center;color:#fff;background-color:#6c2b2b;border-radius:5px}._3VeG9{display:-ms-flexbox;display:flex;-ms-flex-direction:column-reverse;flex-direction:column-reverse;margin-bottom:20px;padding:0 27px;position:relative}._1SXI0{position:absolute;display:none;left:30px;top:20px;z-index:9;color:#000}._2Gsto,._3IGI6{-webkit-transition:all .2s;-o-transition:all .2s;transition:all .2s;-ms-touch-action:manipulation;touch-action:manipulation;font-weight:100;color:#000}._3IGI6{font-size:1.2em;border:0;border-bottom:1px solid #777;-webkit-appearance:none;border-radius:0;padding:0;cursor:text;background:transparent}._3IGI6:focus{outline:0;border-bottom:1px solid #444}._2Gsto{letter-spacing:.15em;margin-bottom:14px;font-size:.9em}._3IGI6:placeholder-shown+._2Gsto{cursor:text;max-width:66.66%;white-space:nowrap;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;-webkit-transform-origin:left bottom;-ms-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:translateY(2.125rem) scale(1.5);-ms-transform:translateY(2.125rem) scale(1.5);transform:translateY(2.125rem) scale(1.5)}._3IGI6:focus ._1SXI0,._3IGI6:not(:placeholder-shown) ._1SXI0{display:block}._3IGI6:focus::-webkit-input-placeholder{opacity:1}._3IGI6:focus+._2Gsto,._3IGI6:not(:placeholder-shown)+._2Gsto{-webkit-transform:translate(0) scale(1);-ms-transform:translate(0) scale(1);transform:translate(0) scale(1);cursor:pointer}._1nomG{width:calc(100% - 60px);padding:0;margin:20px 30px;height:30px;line-height:28px;letter-spacing:3px;border-radius:30px;-webkit-box-shadow:0 0 0 1px #5d4ea2;box-shadow:0 0 0 1px #5d4ea2;border:0;color:#5d4ea2;background-color:#fff;-webkit-transition:all .5s ease;-o-transition:all .5s ease;transition:all .5s ease;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}._1nomG:hover{-webkit-box-shadow:0 0 0 2px #5d4ea2;box-shadow:0 0 0 2px #5d4ea2}._1nomG:focus{outline:none}._4n5Zh{display:inline-block;position:relative;width:64px;height:30px}._4n5Zh div{position:absolute;top:12px;width:6px;height:6px;border-radius:50%;background:#5d4ea2;-webkit-animation-timing-function:cubic-bezier(0,1,1,0);animation-timing-function:cubic-bezier(0,1,1,0)}._4n5Zh div:first-child{left:6px;-webkit-animation:_2maf2 .6s infinite;animation:_2maf2 .6s infinite}._4n5Zh div:nth-child(2){left:6px}._4n5Zh div:nth-child(2),._4n5Zh div:nth-child(3){-webkit-animation:_1K3lT .6s infinite;animation:_1K3lT .6s infinite}._4n5Zh div:nth-child(3){left:26px}._4n5Zh div:nth-child(4){left:45px;-webkit-animation:_2Fdfg .6s infinite;animation:_2Fdfg .6s infinite}@-webkit-keyframes _2maf2{0%{-webkit-transform:scale(0);transform:scale(0)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes _2maf2{0%{-webkit-transform:scale(0);transform:scale(0)}to{-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes _2Fdfg{0%{-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:scale(0);transform:scale(0)}}@keyframes _2Fdfg{0%{-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:scale(0);transform:scale(0)}}@-webkit-keyframes _1K3lT{0%{-webkit-transform:translate(0);transform:translate(0)}to{-webkit-transform:translate(19px);transform:translate(19px)}}@keyframes _1K3lT{0%{-webkit-transform:translate(0);transform:translate(0)}to{-webkit-transform:translate(19px);transform:translate(19px)}}.QbRQ3{width:100%;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.QbRQ3>span{color:#5d4ea2;cursor:pointer}._10iHr{height:70px;width:40px;padding:0;background:transparent;border:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;position:absolute;right:0;z-index:4}._10iHr:focus{outline:none}.Ksv2p{position:relative}.Ksv2p,.Ksv2p:after,.Ksv2p:before{width:20px;height:1px;background-color:#fff}.Ksv2p:after,.Ksv2p:before{content:\"\";position:absolute;left:0;-webkit-transition:all .3s ease;-o-transition:all .3s ease;transition:all .3s ease}.Ksv2p:after{top:6px}.Ksv2p:before{top:-6px}._4esoH .Ksv2p:before{-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);top:0;background-color:#fff}._4esoH .Ksv2p:after{-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg);top:0;background-color:#fff}._4esoH .Ksv2p{background-color:transparent}._1Ytwo{position:fixed;top:0;bottom:0;left:0;right:0;padding-top:50px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:justify;justify-content:space-between;z-index:2}._1hT1j{position:absolute;top:-130vmax;right:-130vmax;width:260vmax;height:260vmax;background-color:#1c1724;border-radius:50%;-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-name:XH0Is;animation-name:XH0Is}@-webkit-keyframes XH0Is{0%{-webkit-transform:scale(0);transform:scale(0)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes XH0Is{0%{-webkit-transform:scale(0);transform:scale(0)}to{-webkit-transform:scale(1);transform:scale(1)}}._1EWHn{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:100%;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:start;align-items:flex-start;padding:10px 30px;z-index:3}._1EWHn>a{margin:10px 0;font-size:20px;font-weight:300;letter-spacing:2px;color:#fff;cursor:pointer}._15HEl{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-align:start;align-items:flex-start;width:100%;z-index:3}._15HEl>a{margin:10px 0;font-weight:300;color:#fff;cursor:pointer;padding-left:30px}._15HEl>a,._15HEl>button{font-size:20px;letter-spacing:2px}._15HEl>button{background-color:#fff;color:#5c4ea2;font-weight:400;height:60px;line-height:60px;border:0;padding:0 30px;margin:0;width:100%;float:left;text-align:left}._15HEl i{width:30px;height:30px;border-radius:30px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}._15HEl i:hover{background-color:#d7d7d7}", ""]);

// exports
exports.locals = {
	"container": "qQ2mF",
	"brand": "_2oS_y",
	"brandTxt": "_230aH",
	"navigation": "_3U7Ez",
	"logoSvg": "MlWRp",
	"pageLinks": "_1rHqE",
	"buttons": "_1ZR5p",
	"loginFormContainer": "YZ0vJ",
	"overlay": "_3R4Nz",
	"form": "rVnTE",
	"slideDownForm": "_1_TN_",
	"errorMessage": "_1ecAX",
	"field": "_3VeG9",
	"fixedText": "_1SXI0",
	"fieldLabel": "_2Gsto",
	"fieldInput": "_3IGI6",
	"registrationButton": "_1nomG",
	"ellipsisSpinner": "_4n5Zh",
	"ellipsisSpinner1": "_2maf2",
	"ellipsisSpinner2": "_1K3lT",
	"ellipsisSpinner3": "_2Fdfg",
	"forgotpassLink": "QbRQ3",
	"button": "_10iHr",
	"hamburger": "Ksv2p",
	"close": "_4esoH",
	"sideNavPanel": "_1Ytwo",
	"sideNavOverlay": "_1hT1j",
	"fadeIn": "XH0Is",
	"smallPageLinks": "_1EWHn",
	"smallButtons": "_15HEl"
};

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(579);
    var insertCss = __webpack_require__(22);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Footer.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Footer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)(false);
// imports


// module
exports.push([module.i, "button:focus{outline:none}h2,h3,h4,h5,h6,ul{margin:0;list-style:none;padding:0}footer._30o6_,header._30o6_,section._30o6_{margin:0}._17oBy{background-attachment:fixed}._17oBy .mvQxm{background:rgba(0,0,0,.2);padding:96px 0 90px}._17oBy .mvQxm ._2Xl1e{font:400 14px/24px Montserrat,HelveticaNeue-Light,sans-serif;letter-spacing:.5px;color:#555}._2Xl1e .OrzQx{font:700 28px Lato,sans-serif;text-transform:capitalize;color:#fff;margin-top:7px;margin-bottom:35px}._29ZeK a{display:block}._29ZeK ul{margin-top:30px}._29ZeK ul li{list-style:none;display:table;width:100%;padding-bottom:10px;color:#8b8b8b}._29ZeK ul li i{float:left;font-size:16px;width:30px;line-height:24px;color:#5a5a5a}._29ZeK ul li .blKUz{float:left;width:calc(100% - 34px)}._29ZeK p{padding-top:20px;color:#8b8b8b}._17oBy .mvQxm ._15GPB ul li{padding:9px 0;border-top:1px solid rgba(90,90,90,.3)}._17oBy .mvQxm ._15GPB ul li a{color:#8b8b8b;letter-spacing:0}._17oBy .mvQxm ._15GPB ul li a:hover{border-left:2px solid #43cea2;color:#fff;padding-left:12px}._17oBy .mvQxm ._15GPB ul li:first-child{border-top:none}._17oBy .mvQxm ._3QzIV .SSVeD{padding-top:10px}._17oBy .mvQxm ._3QzIV .SSVeD ._3_772{padding:6px 15px 0 0;position:relative}._17oBy .mvQxm ._3QzIV .SSVeD ._3_772 ._3pVtT{padding:2px;position:relative;z-index:1}._17oBy .mvQxm ._3QzIV .SSVeD ._3_772 ._3pVtT img{border-radius:3px}._17oBy .mvQxm ._3QzIV .SSVeD ._3_772 ._3pVtT:before{border:3px solid #43cea2;border-radius:3px;content:\"\";position:absolute;top:0;left:0;bottom:0;right:0;display:block;z-index:-1;opacity:0;-webkit-transition:all .3s linear 0s;-o-transition:all .3s linear 0s;transition:all .3s linear 0s}._17oBy .mvQxm ._3QzIV .SSVeD ._3WDO3{cursor:pointer}._17oBy .mvQxm ._3QzIV .SSVeD ._3WDO3 h3{border-bottom:1px solid #2a2929;padding-bottom:20px;position:relative;font:400 14px/24px Montserrat,HelveticaNeue-Light,sans-serif;color:#8b8b8b}._17oBy .mvQxm ._3QzIV .SSVeD ._3WDO3 h3,._17oBy .mvQxm ._3QzIV .SSVeD ._3WDO3 h3:before{-webkit-transition:all .3s linear 0s;-o-transition:all .3s linear 0s;transition:all .3s linear 0s}._17oBy .mvQxm ._3QzIV .SSVeD ._3WDO3 h3:before{content:\"\";color:#fff;position:absolute;left:0;right:0;height:1px;bottom:0;opacity:0}._17oBy .mvQxm ._3QzIV .SSVeD ._3WDO3 a{color:#8b8b8b;font:400 9px/24px Montserrat,HelveticaNeue-Light,sans-serif;letter-spacing:.5px;font-style:italic;-webkit-transition:all .3s linear 0s;-o-transition:all .3s linear 0s;transition:all .3s linear 0s}._17oBy .mvQxm ._3QzIV .SSVeD+.SSVeD{margin-top:20px;border-top:1px solid rgba(90,90,90,.3);padding-top:19px}._17oBy .mvQxm ._3QzIV .SSVeD:hover ._3pVtT:before{opacity:1}._17oBy .mvQxm ._3QzIV .SSVeD:hover ._3WDO3 h3{color:#fff}._17oBy .mvQxm ._3QzIV .SSVeD:hover ._3WDO3 h3:before{opacity:1}._17oBy .mvQxm ._3QzIV .SSVeD:hover ._3WDO3 a{color:gray}._17oBy .mvQxm ._2uzJm .SBtKk{font:400 14px/30px Montserrat,HelveticaNeue-Light,sans-serif;letter-spacing:.5px;padding-top:15px}._17oBy .mvQxm ._2uzJm .SBtKk .tsPpg{font:400 14px/38px Montserrat,HelveticaNeue-Light,sans-serif;letter-spacing:.5px;background:#2a2929;border:0;border-radius:3px;margin-bottom:5px;outline:none;-webkit-box-shadow:none;box-shadow:none;padding:0 17px;height:40px;color:#b6b6b6;width:100%}.tsPpg::-webkit-input-placeholder{color:#5d5b5b;opacity:1}.tsPpg:-ms-input-placeholder,.tsPpg::-ms-input-placeholder{color:#5d5b5b;opacity:1}.tsPpg::placeholder{color:#5d5b5b;opacity:1}._17oBy .mvQxm ._2uzJm .SBtKk ._3s655{resize:none;height:98px}._17oBy .mvQxm ._2uzJm .hTYfK{color:#fff;text-transform:capitalize;padding:5px 34px}._17oBy .mvQxm ._2uzJm .hTYfK:hover{background-color:#5d5b5b;cursor:pointer}._17oBy ._1UDdt{background:hsla(0,3%,7%,.6);font:400 14px/30px Montserrat,HelveticaNeue-Light,sans-serif;border-top:1px solid hsla(0,0%,100%,.07);letter-spacing:.3px;color:#555;padding:30px 0 25px;margin-top:-1px;position:relative}._17oBy ._1UDdt ._2M0yO{background:#43cea2;color:#fff;width:70px;height:70px;display:block;text-align:center;border-radius:50%;position:absolute;left:calc(50% - 35px);cursor:pointer;top:-36px}._17oBy ._1UDdt ._2M0yO i{font-size:30px;line-height:68px}._17oBy ._1UDdt a{color:#43cea2}._17oBy ._1UDdt ._11peJ{float:right;overflow:hidden}._17oBy ._1UDdt ._11peJ li{float:left;padding-right:10px}._17oBy ._1UDdt ._11peJ li a{border-radius:50%;width:30px;padding:0;text-align:center;background:#43cea2;-webkit-transition:all .3s linear 0s;-o-transition:all .3s linear 0s;transition:all .3s linear 0s;-webkit-transition-duration:.3s;-o-transition-duration:.3s;transition-duration:.3s}._17oBy ._1UDdt ._11peJ li a i{font-size:14px;line-height:30px;color:#fff}._17oBy ._1UDdt ._11peJ li:hover a{background:#2a2929;color:#fff}._2HL8G .mvQxm ._3QzIV .SSVeD ._3_772 ._3pVtT:before,._2HL8G .mvQxm ._15GPB ul li a:hover{border-color:#ffe73e}._2HL8G ._1UDdt a{color:#505cfe}._2HL8G ._1UDdt ._2M0yO,._2HL8G ._1UDdt ._11peJ li a,._2HL8G .hTYfK:before{background:#505cfe}.hTYfK{color:#fff;border:0;outline:none;-webkit-box-shadow:none;box-shadow:none;border-radius:4px;display:inline-block;background:#2a2929;-webkit-transition-delay:.4s;-o-transition-delay:.4s;transition-delay:.4s;@inculude transition}.hTYfK:before{content:\"\";border-radius:4px;background:#43cea2;opacity:.9;-webkit-transition-duration:.4s;-o-transition-duration:.4s;transition-duration:.4s;@inculude transition}.-Bw-w{background:hsla(0,0%,95%,.3);padding-top:130px}._2VCLe{font:600 22px/30px Montserrat,HelveticaNeue-Light,sans-serif;color:#111}._29ZeK._2-y10 ul li{font-size:14px;padding-bottom:5px}._29ZeK._2-y10 ul li a,._29ZeK._2-y10 ul li i{color:#8b8b8b}._1E0kY{padding-top:65px}._1E0kY ._34cwl li{display:inline-block}._1E0kY ._34cwl li ._3rYA9{display:inline-block;height:30px;width:31px;line-height:30px;text-align:center;border:2px solid #8b8b8b;font-size:16px;-webkit-box-sizing:content-box;box-sizing:content-box;font-weight:500;border-radius:50%;color:#8b8b8b;-webkit-transition:all .3s linear;-o-transition:all .3s linear;transition:all .3s linear}._1E0kY ._34cwl li ._3rYA9:hover{border-color:#000;color:#000}._1E0kY p{font-size:14px;color:#8b8b8b;padding-top:20px}._1E0kY p a{color:#000}._2BONa{font:600 30px/40px Montserrat,HelveticaNeue-Light,sans-serif}._2BONa small{display:block;color:#999;font-size:18px}.iMoJk._2bBFy{font:300 16px/35px Montserrat,HelveticaNeue-Light,sans-serif;color:#999;margin-bottom:0;padding:70px 0 50px}.iMoJk._2bBFy a{color:#000;font-weight:400}._17oBy .mvQxm .TvoY6{margin-top:12px}._17oBy .mvQxm .TvoY6 img{width:70%}._2unLo{color:#212121;background:#8b8b8b;border-radius:5px;padding:0 20px}._1UDXU{background:-webkit-linear-gradient(left,rgba(33,33,33,.995) 100%,transparent 0);background:-o-linear-gradient(left,rgba(33,33,33,.995) 100%,transparent 100%);background:-webkit-gradient(linear,left top,right top,color-stop(100%,rgba(33,33,33,.995)),to(transparent));background:linear-gradient(90deg,rgba(33,33,33,.995) 100%,transparent 0)}._1UDXU .mvQxm{background:transparent}._39rH5{background:-webkit-linear-gradient(left,rgba(33,33,33,.995) 100%,transparent 0);background:-o-linear-gradient(left,rgba(33,33,33,.995) 100%,transparent 100%);background:-webkit-gradient(linear,left top,right top,color-stop(100%,rgba(33,33,33,.995)),to(transparent));background:linear-gradient(90deg,rgba(33,33,33,.995) 100%,transparent 0)}._39rH5 .mvQxm{background:transparent}._39rH5 .mvQxm ._3QzIV .SSVeD ._3_772 ._3pVtT:before,._39rH5 .mvQxm ._15GPB ul li a:hover{border-color:#ffe73e}._39rH5 ._1UDdt ._2M0yO{padding-top:19px}._39rH5 ._1UDdt ._2M0yO,._39rH5 .hTYfK:before{background:#ffe73e}._39rH5 ._1UDdt a{color:#ffe73e}._39rH5 ._1UDdt ._11peJ li a{background:#f66164}._2Xl1e .SSVeD ._3_772{float:left}._1NxeW{display:grid;grid-template-columns:1fr 1fr}.qE6VE{display:none}.ra1ZJ{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex:1 1;flex:1 1;-ms-flex-pack:distribute;justify-content:space-around}a._3qHjF{color:#8b8b8b!important;font-weight:400!important;margin:0 10px!important;-webkit-transition:all .3s;-o-transition:all .3s;transition:all .3s}a._3qHjF:hover{color:#fff!important;font-weight:700!important}", ""]);

// exports
exports.locals = {
	"row": "_30o6_",
	"footerArea": "_17oBy",
	"footerTop": "mvQxm",
	"widget": "_2Xl1e",
	"widgetTitle": "OrzQx",
	"singleFtWidget": "_29ZeK",
	"fleft": "blKUz",
	"latestWidget": "_15GPB",
	"blogWidget": "_3QzIV",
	"media": "SSVeD",
	"mediaLeft": "_3_772",
	"fImage": "_3pVtT",
	"mediaBody": "_3WDO3",
	"contactFromWidget": "_2uzJm",
	"submitForm": "SBtKk",
	"formControl": "tsPpg",
	"message": "_3s655",
	"submit": "hTYfK",
	"footerBottom": "_1UDdt",
	"scrollT": "_2M0yO",
	"nav": "_11peJ",
	"footerAreaTwo": "_2HL8G",
	"arFooterArea": "-Bw-w",
	"arWidgetTitle": "_2VCLe",
	"textWidget": "_2-y10",
	"socialWidget": "_1E0kY",
	"socialLinks": "_34cwl",
	"circle": "_3rYA9",
	"fLogo": "_2BONa",
	"small": "iMoJk",
	"copyright": "_2bBFy",
	"brandLogo": "TvoY6",
	"formAlert": "_2unLo",
	"footerAreaThree": "_1UDXU",
	"footerAreaFour": "_39rH5",
	"bottomRow": "_1NxeW",
	"visibleXs": "qE6VE",
	"right": "ra1ZJ",
	"link": "_3qHjF"
};

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = receiveRefreshToken;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getClientToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loginUser; });
/* unused harmony export uidLogin */
/* unused harmony export ssoLogin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loginUserSession; });
/* unused harmony export refreshUser */
/* unused harmony export refreshAuth */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return forgotPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return updatePassword; });
/* unused harmony export getOrgDetailsBySubdomain */
/* unused harmony export getOrgAuthMech */
/* unused harmony export refreshUserToken */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return logoutUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_merge__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_fetch__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utils_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_cookie__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_routeReducers_auth__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors_auth__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_layout__ = __webpack_require__(69);
var _this = this;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }








function requestRefreshToken() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__reducers_routeReducers_auth__["c" /* REFRESH_REQUEST */]
  };
}

function receiveRefreshToken(token, user, refToken) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__reducers_routeReducers_auth__["d" /* REFRESH_SUCCESS */],
    token: token,
    user: user,
    refToken: refToken
  };
}

function refreshTokenError(message) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__reducers_routeReducers_auth__["b" /* REFRESH_FAILURE */],
    message: message
  };
}

var handleError = function handleError(error, errorCode) {
  console.error("API returned ".concat(errorCode, " status code:"), error);
  var errorMessage = 'Some error occured';

  if (error.detail) {
    errorMessage = error.detail;
  }

  if (error.email) {
    errorMessage = error.email[0];
  }

  if (typeof error === 'string') {
    errorMessage = error;
  }

  return {
    errorMessage: errorMessage,
    errorCode: errorCode
  };
};

var getClientToken = function getClientToken() {
  if (_this.CLIENT_TOKEN) {
    return Promise.resolve({
      token: _this.CLIENT_TOKEN
    });
  }

  var config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      "Cache-Control": "no-store, no-cache"
    },
    body: JSON.stringify({
      client_id: "5c23e025645a7c0027f2d193",
      client_secret: "4f86e660b3867af9afa16809489420d43ed79fbf"
    })
  };
  return __WEBPACK_IMPORTED_MODULE_1__utils_fetch___default()("".concat("https://sag.spotmentor.com/", "/login-client"), config).then(function (response) {
    if (response.headers.get('content-type') !== 'application/json') {
      return {
        error: response.statusText,
        errorCode: response.status
      };
    }

    return response.json().then(function (json) {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status
        };
      }

      var data = json.results;
      _this.CLIENT_TOKEN = data.client_token;
      setTimeout(function () {
        _this.CLIENT_TOKEN = null;
      }, 24 * 3600 * 1000);
      return {
        token: data.client_token
      };
    });
  });
};
var loginUser = function loginUser(clientToken, email, password) {
  var config = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken
    },
    body: JSON.stringify({
      email: email,
      password: password
    })
  }; // return fetch(`${process.env.SAG_ROOT}auth/login/`, config).then(response => {

  return __WEBPACK_IMPORTED_MODULE_1__utils_fetch___default()("".concat("https://sag.spotmentor.com/", "/login-user-email"), config).then(function (response) {
    if (response.headers.get('content-type') !== 'application/json') {
      return {
        error: response.statusText,
        errorCode: response.status
      };
    }

    return response.json().then(function (json) {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status
        };
      }

      var data = json.results;
      return data;
    });
  }).catch(function (error) {
    console.log(error);
  });
};
var uidLogin = function uidLogin(clientToken, hash, uid, ref, email) {
  var config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken
    },
    body: JSON.stringify({
      hash: hash,
      uid: uid,
      referrer_host: ref,
      email: email
    })
  }; // return fetch(`${process.env.SAG_ROOT}auth/login/`, config).then(response => {

  return __WEBPACK_IMPORTED_MODULE_1__utils_fetch___default()("".concat("https://sag.spotmentor.com/", "/authenticate-custom-navigation"), config).then(function (response) {
    if (response.headers.get('content-type') !== 'application/json') {
      return {
        error: response.statusText,
        errorCode: response.status
      };
    }

    return response.json().then(function (json) {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status
        };
      }

      var data = json.results;
      return data;
    });
  });
};
var ssoLogin = function ssoLogin(clientToken, orgId, authData) {
  var config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken
    },
    body: JSON.stringify(_extends({
      organization_id: orgId
    }, authData))
  }; // return fetch(`${process.env.SAG_ROOT}auth/login/`, config).then(response => {

  return __WEBPACK_IMPORTED_MODULE_1__utils_fetch___default()("".concat("https://sag.spotmentor.com/", "/perform-sso-authentication"), config).then(function (response) {
    if (response.headers.get('content-type') !== 'application/json') {
      return {
        error: response.statusText,
        errorCode: response.status
      };
    }

    return response.json().then(function (json) {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status
        };
      }

      var data = json.results;
      return data;
    });
  });
};

var loginUserSessionApi = function loginUserSessionApi(clientToken, sessionId) {
  var config = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken
    }
  };
  return __WEBPACK_IMPORTED_MODULE_1__utils_fetch___default()("".concat("https://sag.spotmentor.com/", "/login-session?session_id=").concat(sessionId), config).then(function (response) {
    if (response.headers.get('content-type') !== 'application/json') {
      return {
        error: response.statusText,
        errorCode: response.status
      };
    }

    return response.json().then(function (json) {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status
        };
      }

      var data = json.results;
      return data;
    });
  });
};

var loginUserSession = function loginUserSession(sessionId) {
  return getClientToken().then(function (_ref) {
    var clientToken = _ref.token,
        error = _ref.error,
        errorCode = _ref.errorCode;

    if (error) {
      return handleError(error, errorCode);
    }

    return loginUserSessionApi(clientToken, sessionId).then(function (_ref2) {
      var newError = _ref2.error,
          newErrorCode = _ref2.errorCode,
          data = _objectWithoutProperties(_ref2, ["error", "errorCode"]);

      if (newError) {
        return handleError(newError, newErrorCode);
      }

      var refreshToken = data.refresh_token,
          subdomain = data.subdomain_url,
          userToken = data.user_token,
          userId = data.id;

      if (!userToken) {
        return {};
      }

      var user = __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default()({}, data, {
        user_id: userId
      });
      delete user.user_token;
      delete user.refresh_token;
      delete user.redirection_token;
      delete user.id;
      Object(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["e" /* saveAuthCookie */])(subdomain);
      return {
        userToken: userToken,
        refreshToken: refreshToken,
        user: user,
        subdomain: subdomain
      };
    });
  }).catch(function (err) {
    return {
      errorMessage: err.message
    };
  });
};


var refreshUser = function refreshUser(refreshToken) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(dispatch) {
        var _ref4, clientToken, config;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getClientToken();

              case 2:
                _ref4 = _context.sent;
                clientToken = _ref4.token;
                config = {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Client-Access-Token': clientToken // 'User-Access-Token': userToken,

                  },
                  body: JSON.stringify({
                    refresh_token: refreshToken
                  })
                };
                dispatch(requestRefreshToken());
                return _context.abrupt("return", __WEBPACK_IMPORTED_MODULE_1__utils_fetch___default()("".concat("https://sag.spotmentor.com/", "/refresh-token"), config).then(function (response) {
                  // return fetch(`${process.env.SAG_ROOT}/auth/token/user/email/`, config).then(response => {
                  if (response.headers.get('content-type') !== 'application/json') {
                    return {
                      error: response.statusText,
                      errorCode: response.status
                    };
                  }

                  return response.json().then(function (json) {
                    if (!response.ok) {
                      return {
                        error: json,
                        errorCode: response.status
                      };
                    }

                    var data = json.results;
                    var refToken = data.refresh_token,
                        token = data.user_token,
                        userId = data.id;

                    if (!token) {
                      return Promise.resolve(token);
                    }

                    var userData = __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default()({}, data, {
                      user_id: userId
                    });
                    delete userData.user_token;
                    delete userData.refresh_token;
                    delete userData.id;
                    dispatch(receiveRefreshToken(token, userData, refToken)); // dispatch(receiveRefreshToken(token, userData, refToken, true));

                    return Promise.resolve(refToken);
                  });
                }).catch(function (err) {
                  dispatch(refreshTokenError(err));
                }));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
};

var refreshAuth =
/*#__PURE__*/
function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(auth) {
    var _ref6, error, errorCode, data, refreshToken, userToken, userId, user;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            console.info('refreshing user', auth.refreshToken);
            _context2.next = 3;
            return refreshUser(auth.refreshToken);

          case 3:
            _ref6 = _context2.sent;
            error = _ref6.error;
            errorCode = _ref6.errorCode;
            data = _objectWithoutProperties(_ref6, ["error", "errorCode"]);

            if (!error) {
              _context2.next = 10;
              break;
            }

            if (false) {
              console.error(error, errorCode); // eslint-disable-line
            }

            return _context2.abrupt("return", {});

          case 10:
            refreshToken = data.refresh_token, userToken = data.user_token, userId = data.id;
            user = __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default()({}, data, {
              user_id: userId
            });
            delete user.user_token;
            delete user.refresh_token;
            delete user.redirection_token;
            delete user.id;
            console.info('refreshing user successful');
            return _context2.abrupt("return", __WEBPACK_IMPORTED_MODULE_0_lodash_merge___default()({}, auth, {
              userToken: userToken,
              user: user,
              refreshToken: refreshToken
            }));

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function refreshAuth(_x2) {
    return _ref5.apply(this, arguments);
  };
}();


var forgotPassword = function forgotPassword(clientToken, email) {
  var config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken
    },
    body: JSON.stringify({
      email: email,
      action: 'forgot_password'
    })
  };
  return __WEBPACK_IMPORTED_MODULE_1__utils_fetch___default()("".concat("https://sag.spotmentor.com/", "/send-user-email"), config).then(function (response) {
    // return fetch(`${process.env.SAG_ROOT}/auth/token/user/email/`, config).then(response => {
    if (response.headers.get('content-type') !== 'application/json') {
      return {
        error: response.statusText,
        errorCode: response.status
      };
    }

    return response.json().then(function (json) {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status
        };
      }

      var data = json.results;
      return data;
    });
  });
};
var updatePassword = function updatePassword(clientToken, userToken, newPass, newPass2) {
  var config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken,
      'User-Access-Token': userToken
    },
    body: JSON.stringify({
      new_password: newPass,
      confirm_password: newPass2
    })
  };
  return __WEBPACK_IMPORTED_MODULE_1__utils_fetch___default()("".concat("https://sag.spotmentor.com/", "/update-user-details"), config).then(function (response) {
    // return fetch(`${process.env.SAG_ROOT}/auth/token/user/email/`, config).then(response => {
    if (response.headers.get('content-type') !== 'application/json') {
      return {
        error: response.statusText,
        errorCode: response.status
      };
    }

    return response.json().then(function (json) {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status
        };
      }

      var data = json.results;
      return data;
    });
  });
};
var getOrgDetailsBySubdomain = function getOrgDetailsBySubdomain(clientToken, subdomain) {
  var config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken
    },
    body: JSON.stringify({
      subdomain: subdomain
    })
  };
  return __WEBPACK_IMPORTED_MODULE_1__utils_fetch___default()("".concat("https://sag.spotmentor.com/", "/get-org-details-by-subdomain"), config).then(function (response) {
    return response.json().then(function (json) {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status
        };
      }

      var data = json.results;
      return data;
    });
  });
};
var getOrgAuthMech = function getOrgAuthMech(clientToken, orgId) {
  var config = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Client-Access-Token': clientToken
    }
  };
  return __WEBPACK_IMPORTED_MODULE_1__utils_fetch___default()("".concat("https://sag.spotmentor.com/", "/get-org-auth-mechanism?organization_id=").concat(orgId), config).then(function (response) {
    return response.json().then(function (json) {
      if (!response.ok) {
        return {
          error: json,
          errorCode: response.status
        };
      }

      var data = json.results;
      return data;
    });
  });
};

var refreshUserTokenClient = function refreshUserTokenClient() {
  return function (dispatch, getState) {
    var thisVar = {};
    var isFetching = getState().auth.isFetching;

    if (isFetching && thisVar && thisVar.refreshTokenPromise) {
      return thisVar.refreshTokenPromise;
    } // const refreshToken = getCookieValue('refresh_token');


    var refreshToken = getState().auth.refreshToken;
    /* New Auth Flow getting refresh token from redux instead of Browser cookie */

    thisVar.refreshTokenPromise = dispatch(refreshUser(refreshToken)).catch(function (error) {
      if (true && error.message === 'Failed to fetch') {
        alert('Either no Internet Connectivity or the Servers are not responding');
      }

      return Promise.reject(error);
    });
    return thisVar.refreshTokenPromise;
  };
};

var refreshUserTokenServer = function refreshUserTokenServer(refreshToken) {
  return (
    /*#__PURE__*/
    function () {
      var _ref7 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(dispatch) {
        var token;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                token = null;
                _context3.prev = 1;
                _context3.next = 4;
                return dispatch(refreshUser(refreshToken));

              case 4:
                token = _context3.sent;
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](1);
                console.error(_context3.t0);

              case 10:
                return _context3.abrupt("return", token);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 7]]);
      }));

      return function (_x3) {
        return _ref7.apply(this, arguments);
      };
    }()
  );
};

var refreshUserToken =  true ? refreshUserTokenClient : refreshUserTokenServer;
var logoutUser = function logoutUser() {
  return (
    /*#__PURE__*/
    function () {
      var _ref8 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(dispatch, getState) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // dispatch(requestLogout());
                getClientToken().then(function (clientToken) {
                  console.log({
                    clientToken: clientToken
                  });
                  var userToken = Object(__WEBPACK_IMPORTED_MODULE_4__selectors_auth__["a" /* tokenSelector */])(getState().routes); // const decodeUserToken = decodeURIComponent(`${userToken}`);

                  var token = clientToken.token;
                  var config = {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                      'Content-Type': 'application/json',
                      'Client-Access-Token': token,
                      'User-Access-Token': userToken
                    },
                    body: JSON.stringify({})
                  };
                  return __WEBPACK_IMPORTED_MODULE_1__utils_fetch___default()("".concat("https://sag.spotmentor.com/", "/logout"), config).then(function (response) {
                    return response.json().then(function (json) {
                      try {
                        window.sessionStorage.clear();
                        window.localStorage.clear();
                        Object(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["b" /* deleteAuthCookie */])();
                        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__reducers_layout__["c" /* setLogoutUser */])());
                        window.localStorage.setItem('logout', Date.now());
                        window.location.reload();
                      } catch (err) {
                        console.log(err);
                      }
                    });
                  }).catch(function (err) {
                    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object') {
                      window.location.reload();
                    }

                    Promise.reject(err);
                  });
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      return function (_x4, _x5) {
        return _ref8.apply(this, arguments);
      };
    }()
  );
};

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(581);
    var insertCss = __webpack_require__(22);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Placeholder.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Placeholder.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)(false);
// imports


// module
exports.push([module.i, "button:focus{outline:none}.zc-zW{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;height:calc(100vh - 50px);width:100%;-ms-flex-align:center;align-items:center;background-color:#edeff2}.zc-zW>h1{color:#ffe73e;font-size:20px;font-weight:700;letter-spacing:1px}._2InOk{width:200px;height:200px;margin:0 auto}._23Hrf .EnUpV svg{width:60px;height:60px;stroke-dasharray:1500px}._25MYV{text-align:center;margin-top:170px}@-webkit-keyframes Vzsa4{to{-webkit-transform:rotate(1turn)}}@keyframes Vzsa4{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}._3X_BP{-ms-flex:none;flex:none;height:180px;width:300px}._3X_BP h1{margin:0;height:20px;width:300px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;position:relative}._3X_BP h1:before{content:\"\";display:block;position:absolute;top:-80px;left:75px;width:180px;height:180px;border-radius:50%;border:3px solid #ffe73e;-webkit-box-sizing:border-box;box-sizing:border-box}._3X_BP em{font-family:Josefin Sans,sans-serif;font-size:20px;position:relative;font-style:normal;width:30px;text-align:center;color:#ffe73e}._3X_BP em._3qysy,._3X_BP em._39z57{-webkit-animation:Vzsa4 4s linear infinite;animation:Vzsa4 4s linear infinite;position:relative}._3X_BP em._3qysy:before,._3X_BP em._39z57:before{content:\"\";position:absolute;top:0;left:0;z-index:-1;width:30px;height:20px;background:#edeff2;border-radius:50%}._3X_BP em._39z57{-webkit-transform-origin:105px 10px;-ms-transform-origin:105px 10px;transform-origin:105px 10px}._3X_BP em._3qysy{-webkit-transform-origin:-75px 10px;-ms-transform-origin:-75px 10px;transform-origin:-75px 10px}._3a3cY{font-size:20px;color:#ffe73e;text-align:center;text-transform:uppercase}.vJpsN{width:300px;height:300px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.vJpsN svg{width:80%;height:80%}.vJpsN svg circle,.vJpsN svg path{stroke-dasharray:2500px;-webkit-animation:G9poo 4s linear;animation:G9poo 4s linear}@-webkit-keyframes G9poo{0%{stroke-dashoffset:2500px;fill:transparent;stroke-width:2px;stroke:#ffe73e}95%{stroke-dashoffset:0;fill:transparent;stroke-width:2px;stroke:#ffe73e}to{stroke-dashoffset:0;fill:inherit;stroke:inherit}}@keyframes G9poo{0%{stroke-dashoffset:2500px;fill:transparent;stroke-width:2px;stroke:#ffe73e}95%{stroke-dashoffset:0;fill:transparent;stroke-width:2px;stroke:#ffe73e}to{stroke-dashoffset:0;fill:inherit;stroke:inherit}}", ""]);

// exports
exports.locals = {
	"container": "zc-zW",
	"imageContainer": "_2InOk",
	"fizIconBox": "_23Hrf",
	"animatedIcon": "EnUpV",
	"imagetext": "_25MYV",
	"spotmentor": "_3X_BP",
	"planetLeft": "_39z57",
	"planetRight": "_3qysy",
	"planet-rotate": "Vzsa4",
	"text": "_3a3cY",
	"svgs": "vJpsN",
	"dash": "G9poo"
};

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(583);
    var insertCss = __webpack_require__(22);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SnackBar.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SnackBar.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)(false);
// imports


// module
exports.push([module.i, "button:focus{outline:none}._1s_uR{z-index:5;position:fixed;bottom:20px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;width:0;height:0;left:50%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%)}._3wHTx{display:none;width:auto;height:auto;text-align:center;border-radius:2px;-ms-flex-pack:center;-ms-flex-align:center;-webkit-box-shadow:0 0 5px 2px hsla(0,0%,75%,.6);box-shadow:0 0 5px 2px hsla(0,0%,75%,.6)}._3wHTx,._274Kw{justify-content:center;align-items:center}._274Kw{-ms-flex-order:1;order:1;-ms-flex:none;flex:none;width:60px;height:100%;background-color:#fff;position:relative;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-ms-flex-align:center;font-size:20px}._274Kw:after{content:\"\";position:absolute;top:50%;right:-10px;width:0;height:0;border-top:10px solid transparent;border-left:15px solid #fff;border-bottom:10px solid transparent;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%)}._2LrVQ{-ms-flex-order:2;order:2;-ms-flex:1 1;flex:1 1;width:100%;height:100%;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;padding:10px 20px}._2LrVQ,._14Y_U{display:-ms-flexbox;display:flex}._14Y_U{-webkit-animation:_2zeer .5s;animation:_2zeer .5s}._19e3K{display:-ms-flexbox;display:flex;-webkit-animation:_1sApi 1s;animation:_1sApi 1s}@-webkit-keyframes _2zeer{0%{-webkit-transform:translateY(30px);transform:translateY(30px);opacity:0}to{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}}@keyframes _2zeer{0%{-webkit-transform:translateY(30px);transform:translateY(30px);opacity:0}to{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}}@-webkit-keyframes _1sApi{0%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}to{-webkit-transform:translateY(30px);transform:translateY(30px);opacity:0;display:none}}@keyframes _1sApi{0%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}to{-webkit-transform:translateY(30px);transform:translateY(30px);opacity:0;display:none}}", ""]);

// exports
exports.locals = {
	"root": "_1s_uR",
	"snackbar": "_3wHTx",
	"icon": "_274Kw",
	"message": "_2LrVQ",
	"fadeIn": "_14Y_U",
	"fadein": "_2zeer",
	"fadeOut": "_19e3K",
	"fadeout": "_1sApi"
};

/***/ }),

/***/ 584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Headers", function() { return Headers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Request", function() { return Request; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Response", function() { return Response; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);

/* harmony default export */ __webpack_exports__["default"] = (self.fetch.bind(self));
var Headers = self.Headers;
var Request = self.Request;
var Response = self.Response;

/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(644);
    var insertCss = __webpack_require__(22);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LogoutOverlay.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LogoutOverlay.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)(false);
// imports


// module
exports.push([module.i, "button:focus{outline:none}._3K6Fa{position:fixed;top:0;right:0;bottom:0;left:0;background:-webkit-gradient(linear,left top,left bottom,from(#4e4dae),color-stop(147.61%,#9c9ccc));background:-webkit-linear-gradient(top,#4e4dae,#9c9ccc 147.61%);background:-o-linear-gradient(top,#4e4dae 0,#9c9ccc 147.61%);background:linear-gradient(180deg,#4e4dae,#9c9ccc 147.61%);-ms-flex-direction:column;flex-direction:column}._3K6Fa,._3K6Fa>div{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}._3K6Fa>div{-ms-flex-direction:row;flex-direction:row;margin-bottom:20px}._3K6Fa>p{font-size:20px;color:#fff}._2hJbF{margin-left:30px;position:relative;width:70px;height:20px;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;justify-content:space-between}._28Vr2{display:inline-block;width:20px;height:20px;border-radius:10px;background:#fff;-webkit-animation-name:_2NfKc;animation-name:_2NfKc;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:linear;animation-timing-function:linear}@-webkit-keyframes _2NfKc{0%{-webkit-transform:scale(1);transform:scale(1)}50%{-webkit-transform:scale(.6);transform:scale(.6)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes _2NfKc{0%{-webkit-transform:scale(1);transform:scale(1)}50%{-webkit-transform:scale(.6);transform:scale(.6)}to{-webkit-transform:scale(1);transform:scale(1)}}._3T44B{-webkit-animation-delay:0s;animation-delay:0s}._1XLIt{-webkit-animation-delay:.33s;animation-delay:.33s}._1QI5a{-webkit-animation-delay:.66s;animation-delay:.66s}", ""]);

// exports
exports.locals = {
	"overlay": "_3K6Fa",
	"loading": "_2hJbF",
	"dot": "_28Vr2",
	"scale": "_2NfKc",
	"d1": "_3T44B",
	"d2": "_1XLIt",
	"d3": "_1QI5a"
};

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable global-require */
if (true) {
  module.exports = __webpack_require__(647);
} else {
  module.exports = require('./logger.server.js');
}

/***/ }),

/***/ 647:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = createLogger;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_logger__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_logger__);

function createLogger() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_redux_logger__["createLogger"])({
    collapsed: true
  });
}

/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(63);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./src/utils/fetch/index.js
var fetch = __webpack_require__(112);
var fetch_default = /*#__PURE__*/__webpack_require__.n(fetch);

// CONCATENATED MODULE: ./src/actions/contactUs.js
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }



var ContactUs =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(name, email, message, number) {
    var config, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            config = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                name: name,
                email: email,
                message: message,
                contact_number: number
              })
            };
            _context.next = 3;
            return fetch_default()("".concat("https://sag.spotmentor.com/", "/contact-us"), config);

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function ContactUs(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ var contactUs = (ContactUs);
// EXTERNAL MODULE: ./src/reducers/routeReducers/auth.js
var auth = __webpack_require__(161);

// EXTERNAL MODULE: ./src/actions/sagAuth.js
var sagAuth = __webpack_require__(58);

// CONCATENATED MODULE: ./src/reducers/layout.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return layout_setLogoutUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONS; });
function layout__asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }





var INIT = 'layout/INIT';
var SET_ALERT = 'layout/SET_ALERT';
var SET_FIELDS = 'layout/SET_FIELDS';
var SET_SENDING_MSG = 'layout/SET_SENDING_MSG';
var defaultState = {
  alertMessage: null,
  alertType: null,
  contactFields: {},
  isSendingMsg: false
};

var setFields = function setFields(fields) {
  return {
    type: SET_FIELDS,
    fields: fields
  };
};

var setSendingMsg = function setSendingMsg(bool) {
  return {
    type: SET_SENDING_MSG,
    bool: bool
  };
};

var layout_setLogoutUser = function setLogoutUser() {
  return {
    type: auth["a" /* LOGOUT_USER */]
  };
};

var setAlert = function setAlert(alertMessage, alertType) {
  return {
    type: SET_ALERT,
    alertMessage: alertMessage,
    alertType: alertType
  };
};

var layout_changeFields = function changeFields(fieldName, fieldVal) {
  return function (dispatch, getState) {
    var contactFields = getState().layout.contactFields;
    var clonedFields = Object(lodash["cloneDeep"])(contactFields);
    clonedFields[fieldName] = fieldVal;
    dispatch(setFields(clonedFields));
  };
};

var layout_submitContactUs = function submitContactUs(e) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = layout__asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(dispatch, getState) {
        var contactFields, name, email, message, number, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                contactFields = getState().layout.contactFields;
                name = contactFields.name, email = contactFields.email, message = contactFields.message, number = contactFields.number;

                if (name) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", dispatch(setAlert('Name field is required', 'danger')));

              case 5:
                if (email) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", dispatch(setAlert('Email field is required', 'danger')));

              case 7:
                if (number) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", dispatch(setAlert('Phone number field is required', 'danger')));

              case 9:
                if (message) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", dispatch(setAlert('Message field is required', 'danger')));

              case 11:
                _context.prev = 11;
                dispatch(setSendingMsg(true));
                _context.next = 15;
                return contactUs(name, email, message, number);

              case 15:
                response = _context.sent;
                dispatch(setSendingMsg(false));
                dispatch(setAlert('Message sent successfully', 'success'));
                _context.next = 25;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](11);
                console.error(_context.t0);
                dispatch(setSendingMsg(false));
                dispatch(setAlert('Something went wrong. Please try again', 'danger'));

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[11, 20]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

var ACTIONS = {
  init: function init() {
    return {
      type: INIT
    };
  },
  setAlert: setAlert,
  changeFields: layout_changeFields,
  submitContactUs: layout_submitContactUs
};

var optToState = function optToState() {
  return {
    contactFields: {
      name: '',
      email: '',
      message: '',
      number: ''
    }
  };
};

function layout() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case INIT:
      return Object.assign({}, state, optToState());

    case SET_ALERT:
      return Object.assign({}, state, {
        alertMessage: action.alertMessage,
        alertType: action.alertType
      });

    case SET_FIELDS:
      return Object.assign({}, state, {
        contactFields: action.fields
      });

    case SET_SENDING_MSG:
      return Object.assign({}, state, {
        isSendingMsg: action.bool
      });

    default:
      return Object.assign({}, state);
  }
}

/* harmony default export */ var reducers_layout = __webpack_exports__["b"] = (layout);

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/* eslint-disable max-len */
if (true) {
  // throw new Error('Do not import `config.js` from inside the client-side code.');
  console.warn('`config.js` accessed from inside the client-side code.');
} // method to configure refresh_token cookie variable name according to the instance


var refreshTokenCookieName = function refreshTokenCookieName() {
  var name = 'refresh_token';
  var sagRoot = "https://sag.spotmentor.com/";

  if (sagRoot.includes('dabba')) {
    name = "".concat(name, "_development");
  } else if (sagRoot.includes('test')) {
    name = "".concat(name, "_testing");
  }

  return name;
};

module.exports = {
  // Node.js app
  port: process.env.PORT || 3000,
  // API Gateway
  api: {
    // API URL to be used in the client-side code
    clientUrl: process.env.API_CLIENT_URL || '',
    // API URL to be used in the server-side code
    serverUrl: process.env.API_SERVER_URL || "http://".concat("spotmentor.com", ":").concat(process.env.PORT || 3000)
  },
  // Database
  databaseUrl: process.env.DATABASE_URL || 'sqlite:database.sqlite',
  // API ROOT
  API_ROOT: "https://api.spotmentor.com/" || 'http://localhost:8200/',
  SAG_ROOT: "https://sag.spotmentor.com/" || 'https://sag.test.spotmentor.com/',
  // Client details
  CLIENT_ID: "5b0d8115cc6538003427b51d",
  CLIENT_SECRET: "f5a9bba56f8d257777317616455bb5afea3993c5",
  SAG_CLIENT_ID: "5c23e025645a7c0027f2d193" || '5bd4431afcc4f50025e25e51',
  SAG_CLIENT_SECRET: "4f86e660b3867af9afa16809489420d43ed79fbf" || 'ebe4c92c6397f36800a315592a1d544b670e1d00',
  SPOTMENTOR_ENV:  false ? "refresh_token_".concat(process.env.SPOTMENTOR_ENV) : 'refresh_token',
  // Cookies
  COOKIE_DOMAIN: "spotmentor.com" || 'localhost.dabba.spotmentor.com',
  COOKIE_TIMEOUT: process.env.COOKIE_TIMEOUT || 30 * 24 * 3600,
  REFRESH_COOKIE_TIMEOUT: process.env.COOKIE_TIMEOUT || 10 * 365 * 24 * 3600,
  // Timeouts
  POLL_TIMEOUT: process.env.POLL_TIMEOUT || 30 * 1000,
  // Spotmentor package id
  PACKAGE_ID: "5b0d807fcc6538003427b51c",
  // Colors
  BRAND_COLOR: '#273992',
  // Web analytics
  analytics: {
    // https://analytics.google.com/
    googleTrackingId: "UA-86405085-1",
    // UA-XXXXX-X
    gtmContainerId: "GTM-MLZJ3CV" // GTM-XXXXXXX

  },
  // Authentication
  auth: {
    jwt: {
      secret: process.env.JWT_SECRET || 'React Starter Kit'
    },
    // https://developers.facebook.com/
    facebook: {
      id: process.env.FACEBOOK_APP_ID || '186244551745631',
      secret: process.env.FACEBOOK_APP_SECRET || 'a970ae3240ab4b9b8aae0f9f0661c6fc'
    },
    // https://cloud.google.com/console/project
    google: {
      id: process.env.GOOGLE_CLIENT_ID || '251410730550-ahcg0ou5mgfhl8hlui1urru7jn5s12km.apps.googleusercontent.com',
      secret: process.env.GOOGLE_CLIENT_SECRET || 'Y8yR9yZAhm9jQ8FKAL8QIEcd'
    },
    // https://apps.twitter.com/
    twitter: {
      key: process.env.TWITTER_CONSUMER_KEY || 'Ie20AZvLJI2lQD5Dsgxgjauns',
      secret: process.env.TWITTER_CONSUMER_SECRET || 'KTZ6cxoKnEakQCeSpZlaUCJWGAlTEBJj0y2EMkUBujA7zWSvaQ'
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(558)))

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config__);
var _PLATFORM_URL;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var SERVER_ENV = {
  DEV: 'dev',
  DABBA: 'dabba'
};
var redirectInstance = __WEBPACK_IMPORTED_MODULE_0__config__["SPOTMENTOR_ENV"] === 'refresh_token_development' ? 'dabba' : 'test';
var redirectProtocol = redirectInstance === 'test' ? 'https' : 'http';
var PLATFORM_URL = (_PLATFORM_URL = {}, _defineProperty(_PLATFORM_URL, SERVER_ENV.DEV, "".concat(redirectProtocol, "://").concat(__WEBPACK_IMPORTED_MODULE_0__config__["COOKIE_DOMAIN"], ":3002")), _defineProperty(_PLATFORM_URL, SERVER_ENV.DABBA, "http://some-org.".concat(redirectInstance, ".spotmentor.com")), _PLATFORM_URL);
var configuredPlatformUrl = "";

var isIntranet = function isIntranet(host) {
  return host.includes('dabba');
};

var getEnvironment = function getEnvironment(host) {
  if (false) {
    return SERVER_ENV.DEV;
  }

  if (isIntranet(host)) {
    return SERVER_ENV.DABBA;
  }

  return undefined;
};

var getDefaultPlatformUrlForEnvironment = function getDefaultPlatformUrlForEnvironment(organizationSubdomain, websiteHost) {
  var serverEnv = getEnvironment(websiteHost);
  var defaultUrl = PLATFORM_URL[serverEnv];
  return defaultUrl || organizationSubdomain;
};

var getPlatformUrl = function getPlatformUrl(_ref) {
  var organizationSubdomain = _ref.organizationSubdomain,
      websiteHost = _ref.websiteHost;

  /*
  get url for spotmentor's learning interface platform
  based on the current running environment and
  organization's registered subdomain on spomentor
   usually used for redirection after a user logs in
  */
  console.info('calculating platform url', {
    organizationSubdomain: organizationSubdomain,
    websiteHost: websiteHost,
    configuredPlatformUrl: configuredPlatformUrl
  });

  if (configuredPlatformUrl) {
    return configuredPlatformUrl;
  }

  var platformUrl = getDefaultPlatformUrlForEnvironment(organizationSubdomain, websiteHost);
  console.info("platformUrl evaluated to ".concat(platformUrl));
  return platformUrl;
};

/* harmony default export */ __webpack_exports__["a"] = (getPlatformUrl);

/***/ })

},[254]);


// WEBPACK FOOTER //
// client.1c105ef0.js